import { Injectable, OnDestroy } from "@angular/core";
import { Observable, BehaviorSubject, AsyncSubject, Subscription, Subject } from "rxjs";
import { AddPurchaseOrderItemDataModel, AddPurchaseOrderItemExtraDataModel, BasketItemViewModel, BasketItemExtraViewModel, AddPurchaseOrderDataModel, orderTypes, CustomerInputFieldViewModel, WebshopSettingsDataModel2, WebshopSettingsDMKey, WebshopOrderDataViewModel, FurtherAddressViewModel, BasketItemExtraPriceViewModel, BasketItemPriceViewModel, DDLViewModel, OrdertypeViewModel, DeliveryCountry, VatStat, AddPurchaseOrderWebvoucherItemDataModel, deliveryTypes } from "../shared/models/webshop.model";
import { LocationOpenTime, LocationDataModel, ServiceOpenTimeViewModel, ArticleAvailabilityDataModel, LocationWebshopViewModel, DeliveryArea, DeliveryAreaPolygonMap, LocationOpenDay, DayOfWeek, ProductExtraDataModel3, ReservationBasketSyncDataModel, ReservationBasketSyncModel, ScheduledForRequest, WebvoucherDataModel, ProductViewModel, DeliveryFee, LeadTimeType, Timeslot, SettingsRegistrationViewModel } from "../shared/models";
import * as moment from "moment";
import { Moment } from "moment";
import DateManager from "../shared/dateManager";
import { WebshopColorTokensDataModel, WebshopColorTokensDMKey } from "../shared/models/webshopColorTokens.model";
import { WebshopColorTokensService } from "./webshopColorTokens.service";
import { IObjectObserver } from "./IObjectObserver";
import { ProductDataModel4, UsingType, MenuSettingsDataModel2, MenuSettingsDMKey, ProductDetailsDataModel3, ProductPricesModel } from "../shared/models";
import { CircularInjectionHelper } from "./circularInjectionHelper";
import { ObjectObserverFactory } from "./objectObserverFactory";
import { ContentType, OrderDataInputFields, OrderDataAddressFieldInputs, VoucherServiceType, YourAPPProductType, SnackBarMessageType, ImageOrientation, OrdereRequirementsStatus } from "../shared/contentTypes";
import { ProductDetailsHelper, ProductDetailsHelperService } from "./product_details_helper.service";
import { CoreLogService } from "./log.service";
import { UserHelperService } from "./userHelper.service";
import { AddressType } from "../shared/models/userInfo.model";
import Utils from "../shared/utils";
import { WebVoucherService } from "./web_voucher.service";
import { CoreLanguageService } from "./language.service";
import { UserProfileService } from "../components/userProfile/userprofile.service";
import { ProductService } from "./product.service";
import { InternationalisationService } from "../forked/angular-internationalisation";
import { Router } from "@angular/router";
import { CoreCOMService } from "./com.service";
import { StorageHive, LocalKeys } from "./valueStorage.service";
import * as _ from "lodash";
import { LocationService } from "../components/location/location.service";
import { WarningdialogComponent } from "../modalDialogs/warningDialog/warningDialog.component";
import { BottomSheetHelperService } from "./bottomSheetHelper.service";
import { AvailableServiceTimeComponent } from "../modalDialogs/availableServiceTime/availableServiceTime.component";
import { CoreOpenDayTime } from "../languages/openDayTime";
import { environment } from "../../../environments/environment";
import { NavigationService } from "./navigation.service";
import { MainnavService } from "../components/mainNav/mainnav.service";
import { FixedBasketErrorCodes } from "../components/fixedBasketErrorPage/fixedBasketErrorPage.component";
import { WebshopOrdertypesService } from "./webShopOrdertypes.service";
import { AgeConfirmDialogComponent } from "../modalDialogs/ageConfirmDialog/ageConfirmDialog.component";
import { LocationDialogComponent } from "../modalDialogs/locationDialog/locationDialog.component";
import { BasketChangeType, BasketItem, BasketItemExtra, ChangeBasketStatus, req_ChangeBasket, TableData, POSTable_Item, POSTable_Item_Extra, OrderType, req_ChangeGroupBasket, ChangeGroupBasketChangeType, ChangeGroupBasketStatus } from "./IInHouseOrderService";
import { ConnectionState } from "./YourAppServer/YourAppServerSoket.service";
import { snackBarMessageKey, SnackBarService } from "./snackBar.service";
import { AccessibilityWebShopService } from "./accessibilityWebShop.service";
import { ResetbasketwarningdialogComponent } from "../modalDialogs/resetBasketWarningDialog/resetBasketWarningDialog.component"; // direkter import statt "../modalDialogs" wegen einem zirkelbezug
import { SecureCheckDialogComponent } from "../modalDialogs/secureCheckDialog/secureCheckDialog.component"; // direkter import statt "../modalDialogs" wegen einem zirkelbezug
import { ProductConfiguration, ProductConfigurationExtra, IServiceTimeSelectionData, TrinkgeldInputMethod, WebShopMode, Webvoucher, WebvoucherConfiguration, OpenProductOptions } from "./IWebShopService";
import { Coordinates, Coordinates as GeocodeCoordinates } from "../shared/models/geocoding.model";
import { ApiResponseData } from "./YourAppServer/YourAppServerApi.service";
import { TrackingManager } from "./tracking/tracking-manager";
import { appConfig } from "../core-config";
import { EventmanagerService, IEvent } from "./eventmanager.service";
import { RouterHelperService } from "./routerHelper.service";
import { NavigationRoute } from "../shared/enums/navigation-route.enum";
import { IAvailableTimesConfig } from "./IOrderTimeValidation.service";
import { DeviceLocationService } from "./deviceLocation.service";
import { CheckoutErrorCode } from "../shared/enums/checkout-error-code.enum";
import { CouponScanState } from "../shared/enums/coupon.enums";

class WebshopBaseData {
  serviceMode: number;
  locationID: number;
  locationName: string;
  city: string;
  zipCode: string;
  address: string;
  country: DeliveryCountry;
  polygonMapInformation: PolygonMapInformation = null;
  deliveryArea: DeliveryArea[];
  serviceLeadTimeType: LeadTimeType;
  serviceLeadTime: number;
  serviceCycletime: number;
  minimumOrderValue: number;
  deliveryFee: number;
  useFreeShipping: boolean;
  freeShippingThreshold: number;
  locationMwst1: number;
  openTimeService: LocationOpenTime[];
  locationOpenDays: LocationOpenDay[];
  timestamp: string;
}

class BasketRestoreData {
  recommendationIds: number[];
  shippingCartItems: BasketItemViewModel[];
  trinkgeldValue: number;
  trinkgeldPercentage: number;
  orderComment: string;
  orderASAP: boolean;
  qrCode: string;
  tableName: string;
  voucherServiceType: VoucherServiceType;
  fixedBasket: boolean;
  addPurchaseOrderToken: string;
  returnURLSuccess: string;
  returnURLFail: string;
  returnURLBasket: string;
}

class WebshopServiceRestorePoint {
  baseData: WebshopBaseData;
  basketData: BasketRestoreData;
}

export type PolygonMapInformation = {
  DeliveryFees: DeliveryFee[];
  Coordinates: GeocodeCoordinates;
};

/** Antwort auf den aufruf von GetOrderIdentification */
class OrderIdentification implements ApiResponseData {
  /** OrderIdenttificationToken */
  token: string;

  public DeserializeType(): void {
    // has no complex type
  }
}

/** null/undefined → "". No trim. Case-sensitive. */
function normalizeComment(value: string | null | undefined): string {
  return value == null ? "" : value;
}

@Injectable({
  providedIn: "root"
})
export class WebShopService implements OnDestroy {
  private loginState: boolean;
  private _webshopSettingsDataModel: WebshopSettingsDataModel2;
  private _menuSettingsObsServ: IObjectObserver<MenuSettingsDataModel2>;
  private _webshopSettingsObsServ: IObjectObserver<WebshopSettingsDataModel2>;
  private _webshopColorTokensObsServ: IObjectObserver<WebshopColorTokensDataModel>;
  private _webvoucherCustomObsServ: IObjectObserver<WebvoucherDataModel>;
  private _locationObsServ: IObjectObserver<LocationDataModel>;

  public get webshopSettingsDataModelObserveChanges(): Observable<(string | number)[]> {
    return this._webshopSettingsObsServ.ObserveChanges;
  }

  private isInitialized: boolean = false;
  private _fullyLoadedAsyncSubject: AsyncSubject<void> = new AsyncSubject<void>();
  public get getFullyLoadedObservable(): Observable<void> {
    return this._fullyLoadedAsyncSubject.asObservable();
  }

  private _shippingCartSubject: BehaviorSubject<BasketItemViewModel[]> = new BehaviorSubject<BasketItemViewModel[]>([]);
  private _locationID: null | number = null; // The Current Location the Basket is for
  /** The Current Location the Basket is for, set over setServiceLocationInfo */
  public get locationID(): null | number {
    return this._locationID;
  }
  /** Einzige Stelle, die die Verfügbarkeit von "an der Kasse" für den aktuellen Standort entscheidet */
  public get isPayAtWaiterAvailable(): boolean {
    const me = this;
    return !!me.ordertype && me.ordertype.isPayAtWaiterAvailableAt(me._locationID);
  }
  public DestinationCity: string = "";
  public DestinationZipCode: string = "";
  public DestinationAddress: string = "";
  public DestinationCountry: DeliveryCountry = null;
  // todo warum wird es nicht in der current adress gespeichert?
  public PolygonMapInformation: PolygonMapInformation = null;
  private _locationMwst1: number = 0;
  public openTimeService: LocationOpenTime[] = null; // used to calculate Open time for Warenkorb
  private deliveryArea: DeliveryArea[] = null;
  private deliveryAreaPolygonMap: DeliveryAreaPolygonMap[] = null;
  public serviceLeadTimeType: LeadTimeType = LeadTimeType.Minute;
  public serviceLeadTime: number = 0;
  public serviceCycletime: number = 0;
  public WebShopMode = WebShopMode;
  private serviceOpenTimeViewModels: ServiceOpenTimeViewModel[] = null; // used to show in dropdownlist in Warenkorb
  private serviceMode: WebShopMode | null = null; // The Current Location the Basket is for
  public ordertype: OrdertypeViewModel | null;
  public shippingCartItems: BasketItemViewModel[] = [];
  public servicePe: number | null;
  public userPe: number | null;
  public useAvailability: boolean;
  public availabilityMinimum: number;
  public qrCode: string = "";
  private locationOpenDays: LocationOpenDay[] = null;
  /** Bonuspunkte werden nur gesammelt, wenn das Bonussystem auch aktiviert wird. */
  private _canCollectBonuspoints: boolean = false;
  /** Cache für die mögliche Navigation zu den Coupons */
  private _canNavigateToCoupons: boolean = false;
  public orderASAP: boolean = false;
  public addPurchaseOrderToken: string = "";
  public sortiment: string = "";
  public currentEventID: number = null;

  private _peChangedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get peChanged$(): Observable<boolean> {
    return this._peChangedSubject.asObservable();
  }

  private _isEventPeActiveSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get isEventPeActive$(): Observable<boolean> {
    return this._isEventPeActiveSubject.asObservable();
  }

  public _hasAcceptedAGB: boolean = false;
  public get hasAcceptedAGB(): boolean {
    return this._hasAcceptedAGB;
  }
  public set hasAcceptedAGB(accepted: boolean) {
    const me = this;
    me._hasAcceptedAGB = accepted;
    if (me.serviceMode == WebShopMode.OrderToTable) {
      me._coreComService.environment.valueStorage.set(StorageHive.Local, LocalKeys.gtc, this._hasAcceptedAGB);
    }
  }

  public get finalDeliveryFee(): number {
    if (this._useFreeShipping && this.getBasketSumDiscounted() >= this._freeShippingThreshold) {
      return 0;
    } else {
      return this._deliveryFee;
    }
  }

  public get meetMinimomPrice(): boolean {
    return this.minimumOrderValue != null && this.minimumOrderValue >= 0 && this.getBasketSumDiscounted() >= this.minimumOrderValue;
  }

  public get remainingAmountUntilFreeShipping(): number {
    return this.freeShippingThreshold - this.getBasketSumDiscounted();
  }

  //#region properties

  /** used with navigate back to set the active itemGroup in menu list */
  private _activeItemGroupId: number | null = null;
  public get activeItemGroupId() {
    return this._activeItemGroupId;
  }
  public set activeItemGroupId(v: number) {
    this._activeItemGroupId = v;
  }

  public allowBasketModification: boolean = true;
  public returnURLSuccess: string = "";
  public returnURLFail: string = "";
  public returnURLBasket: string = "";

  public userHasWebvoucher: boolean;
  public userWebvoucher: Webvoucher;

  private _locationName: string = "";
  public get locationName(): string {
    return this._locationName;
  }

  private _currencySymbol: string = "";
  public get currencySymbol(): string {
    return this._currencySymbol;
  }

  private _webvoucherDiscountPercent: number = 0;
  public get webvoucherDiscountPercent(): number {
    return this._webvoucherDiscountPercent;
  }

  private _userDiscountPercent: number = 0;
  public get userDiscountPercent(): number {
    return this._userDiscountPercent;
  }

  public get discountPercent(): number {
    return Math.max(this._webvoucherDiscountPercent, this._userDiscountPercent);
  }

  private _trinkgeldValue: number = 0;
  public get trinkgeldValue(): number {
    return this.isTippingEnabled() ? this._trinkgeldValue : 0;
  }

  private _trinkgeldPercentage: number;
  public get trinkgeldPercentage(): number {
    return this.isTippingEnabled() ? this._trinkgeldPercentage : 0;
  }

  public trinkgeldInputMethod: TrinkgeldInputMethod = TrinkgeldInputMethod.Percentage;

  private _minimumOrderValue: number = 0;
  public get minimumOrderValue(): number {
    return this._minimumOrderValue;
  }

  // TODO Needs to be updated on Location Set and Possible Orderdata Change (DeliveryAddress)
  private _deliveryFee: number = 0;
  public get deliveryFee(): number {
    return this._deliveryFee;
  }

  private _freeShippingThreshold: number = 0;
  public get freeShippingThreshold(): number {
    return this._freeShippingThreshold;
  }
  private _useFreeShipping: boolean = false;
  public get useFreeShipping(): boolean {
    return this._useFreeShipping;
  }

  public get ShippingCartObserver(): Observable<BasketItemViewModel[]> {
    const me = this;
    return me._shippingCartSubject.asObservable();
  }

  private _recommendationProductIds: number[] = [];
  public get recommendationProductIds(): number[] {
    const me = this;
    return me._recommendationProductIds;
  }

  private _tableName: string = "";
  public get tableName(): string {
    return this._tableName;
  }
  /** wird durch inHouseOrder gesetzt
   * Todo sollte angepast werden wenn die strucktur zwischen INhouseorderservice und webshopservice geklrt wird
   */
  public set tableName(name: string) {
    this._tableName = name;
  }

  private _voucherServiceType: VoucherServiceType = null;
  public get voucherServiceType(): VoucherServiceType {
    return this._voucherServiceType;
  }

  private _orderComment: string = "";
  public get orderComment(): string {
    return this._orderComment;
  }
  public set orderComment(v: string) {
    this._orderComment = v;
  }

  private _webshopOrderDataViewModel: WebshopOrderDataViewModel | null = null;
  public get webshopOrderDataViewModel(): WebshopOrderDataViewModel | null {
    return this._webshopOrderDataViewModel;
  }

  private _webshopOrderDataViewModelChangedAfterUserLoginStatusChangedSubject: Subject<void> = new Subject<void>();
  public get webshopOrderDataViewModelChangedAfterUserLoginStatusChangedObserver(): Observable<void> {
    return this._webshopOrderDataViewModelChangedAfterUserLoginStatusChangedSubject.asObservable();
  }

  private _customerInputFieldViewModels: CustomerInputFieldViewModel[] = null;
  public get customerInputFieldViewModels(): CustomerInputFieldViewModel[] {
    return this._customerInputFieldViewModels;
  }

  private _orderDataCountryChangedSubject = new Subject<boolean>();
  public get orderDataCountryChanged$(): Observable<boolean> {
    return this._orderDataCountryChangedSubject.asObservable();
  }

  private _userServiceAddress: number;
  public get userServiceAddress(): number {
    return this._userServiceAddress;
  }

  private _menuSettings: MenuSettingsDataModel2;
  public async getMenuSettings(): Promise<MenuSettingsDataModel2> {
    if (!this._menuSettings) {
      this._menuSettings = await this._menuSettingsObsServ.GetObject(MenuSettingsDMKey);
    }
    return this._menuSettings;
  }

  //#endregion

  private _userRegisterObserverSubscription: Subscription;
  private _observeUserDataChangedSubscription: Subscription;

  private deliveryAddressViewModel: FurtherAddressViewModel = new FurtherAddressViewModel();
  constructor(public _coreLogService: CoreLogService
    , public _coreComService: CoreCOMService
    , public _router: Router
    , public _userHelperService: UserHelperService
    , public _webvoucherService: WebVoucherService
    , public _objObsInjectHelper: CircularInjectionHelper
    , private _coreLanguageService: CoreLanguageService
    , private _productService: ProductService
    , private _userProfileService: UserProfileService
    , private _navigationService: NavigationService
    , private _mainNavService: MainnavService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , public _webshopOrdertypesService: WebshopOrdertypesService
    , private _locationService: LocationService
    , private _snackBarService: SnackBarService
    , private _accessibilityWebShopService: AccessibilityWebShopService
    , private _trackingManager: TrackingManager
    , private _eventManagerService: EventmanagerService
    , private _routerHelperService: RouterHelperService
    , private _webshopColorTokensService: WebshopColorTokensService
    , private _deviceLocationService: DeviceLocationService
  ) {
    const me = this;
    if (environment.producttype == YourAPPProductType.sot) {
      return; // break here, sot dont need WebShopService
    }
    me._locationObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<LocationDataModel>(ContentType.Location, _objObsInjectHelper);
    me._menuSettingsObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<MenuSettingsDataModel2>(ContentType.MenuSettings, _objObsInjectHelper);
    me._webshopSettingsObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<WebshopSettingsDataModel2>(ContentType.WebshopSettings, _objObsInjectHelper);
    me._webshopColorTokensObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<WebshopColorTokensDataModel>(ContentType.WebshopColorTokens, _objObsInjectHelper);
    me._webvoucherCustomObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<WebvoucherDataModel>(ContentType.Webvoucher_Custom, _objObsInjectHelper);

    me._loadUseECommerce();

    me.onUserChange();
    // User logt sich ein oder aus event
    me._userRegisterObserverSubscription = me._userHelperService.RegisterObserver.subscribe(async (registered) => {
      if (me.loginState !== registered) {
        await me.onUserChange();
        me._webshopOrderDataViewModel = null; // reset cached data
        await me.initializeOrderDataViewModel();
        me._webshopOrderDataViewModelChangedAfterUserLoginStatusChangedSubject.next();

        // Reset newsletter acceptance state when user logs out
        if (!registered) {
          me.resetNewsletterConfirm();
        }
      }
    });
    // User ändert seine daten event
    me._observeUserDataChangedSubscription = me._userProfileService.ObserveUserDataChanged.subscribe(async (_) => {
      me._webshopOrderDataViewModel = null; // reset cached data
      await me.initializeOrderDataViewModel();
    });

    me.restoreFromValueStorage();

    me._webshopSettingsObsServ.ObserveChanges.subscribe(changes => {
      me._webshopSettingsObsServ.GetObject(WebshopSettingsDMKey)
        .then(webshopSettings => {
          me._webshopSettingsDataModel = webshopSettings;
        })
        .catch(e => {
          me._coreLogService.error("WebshopService.constructor", "subscribe:_webshopSettingsObsServ.GetObject", e);
        });
    });

    // same generic ObjectObserver sync cycle as _webshopSettingsObsServ above - no separate request, no app-start special-case
    me._webshopColorTokensObsServ.ObserveChanges.subscribe(changes => {
      me._webshopColorTokensObsServ.GetObject(WebshopColorTokensDMKey)
        .then(colorTokens => {
          me._webshopColorTokensService.writeColorTokens(colorTokens);
        })
        .catch(e => {
          me._coreLogService.error("WebshopService.constructor", "subscribe:_webshopColorTokensObsServ.GetObject", e);
        });
    });
    // Erst-Anstrich, unabhaengig von ObserveChanges: das ist ein Subject ohne Replay
    // (objectObserver.service.ts, _observerChanged), also gibt es zwei Faelle, in denen
    // die Subscription oben allein nie zeichnet und der <style>-Block die ganze Sitzung
    // leer bleibt, obwohl gueltige Daten lokal liegen:
    //   1. Start aus dem Cache ohne Delta - _GetManager emittiert nur bei keys.length > 0,
    //   2. der Observer emittiert bereits vor diesem subscribe (Rennen im Konstruktor).
    // GetObject stoesst dabei bei Bedarf selbst den Load an. Nur zeichnen, wenn wirklich
    // Daten da sind: ein spaet aufloesender Erst-Aufruf darf einen inzwischen vom Sync
    // gezeichneten Stand nicht wieder auf leer zuruecksetzen (writeColorTokens leert bei
    // null/undefined per Vertrag den Block).
    me._webshopColorTokensObsServ.GetObject(WebshopColorTokensDMKey)
      .then(colorTokens => {
        if (colorTokens) {
          me._webshopColorTokensService.writeColorTokens(colorTokens);
        }
      })
      .catch(e => {
        me._coreLogService.error("WebshopService.constructor", "initial:_webshopColorTokensObsServ.GetObject", e);
      });

    me.ShippingCartObserver.subscribe((items) => {
      if (items != null && me.isInitialized) {
        me.saveToStorage();
      }
    });

    //! Achtung isContenttypeActive prüft nur ob die Navigaton freigegeben ist, und nicht ob es betretten werden kann
    //! dies ist nur eine Prüfung ob Bonussystem grundsätzlich angeboten wird, und nicht ob man es betretten kann
    me._navigationService.isContenttypeActive(ContentType.Bonussystem).then(canCollectBonuspoints => {
      me._canCollectBonuspoints = canCollectBonuspoints;
    });
    if (me._navigationService.isContenttypeSupported(ContentType.Coupon)) {
      me._navigationService.isContenttypeActive(ContentType.Coupon).then(isCouponNavigationActive => {
        me._canNavigateToCoupons = isCouponNavigationActive;
      });
    } else {
      me._canNavigateToCoupons = false;
    }
    me._navigationService.ObserveChanges.subscribe(async () => {
      me._canCollectBonuspoints = await me._navigationService.isContenttypeActive(ContentType.Bonussystem);
      if (me._navigationService.isContenttypeSupported(ContentType.Coupon)) {
        me._canNavigateToCoupons = await me._navigationService.isContenttypeActive(ContentType.Coupon);
      } else {
        me._canNavigateToCoupons = false;
      }
    });
    // Set Currency based on any Locations currency since they can not be diffrent.
    // This way it can be globally accessed without having selected a location. (i.e UserProfile)
    me._locationObsServ.GetObjectsByFilter(model => !model.deleted && model.participate).then(locations => {
      if (locations.length > 0) {
        const location = locations.find(l => l.currencySymbol != "")
        if (location.currencySymbol != "") {
          me._currencySymbol = location.currencySymbol
        }
        else {
          me._coreLogService.error("WebshopService.constructor", "_locationObsServ.GetAllObjects", "No Location to determine currency from");
        }
      } else {
        me._coreLogService.error("WebshopService.constructor", "_locationObsServ.GetAllObjects", "No Location to determine currency from");
      }
    });
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._userRegisterObserverSubscription) {
      me._userRegisterObserverSubscription.unsubscribe();
    }
    if (me._observeUserDataChangedSubscription) {
      me._observeUserDataChangedSubscription.unsubscribe();
    }
  }

  /** Coupons dürfen eingelöst werden, wenn Sie erlaubt wurden.
   * Alle ausgenommen Webgutscheine dürfen Coupons einlösen, wenn aktiv.
   * Mit ignoreServiceMode kann der aktuelle ServiceMode ignoriert werden.
   */
  public async isCouponReedemAllowed(ignoreServiceMode: boolean = false): Promise<boolean> {
    const me = this;
    const settings = await me.getWebshopSettingsDataModel();
    return settings.use_coupon_code && (ignoreServiceMode || me.serviceMode !== WebShopMode.Webvoucher);
  }

  /** ermittelt ob eine Navigation zu den Coupons möglich ist. */
  public get canNavigateToCoupons(): boolean {
    return this._canNavigateToCoupons;
  }

  /** coupon_code is the raw code or the scanned QR text; navigates to the product on success. */
  public async scanCouponCode(
    coupon_code: string,
    is_app_coupon: boolean,
    options: OpenProductOptions
  ): Promise<CouponScanState> {
    const me = this;
    const webshopSettings = await me.getWebshopSettingsDataModel();
    if (!webshopSettings.use_coupon_code) {
      throw new Error("coupon code is disabled");
    }

    let free_item_nr = 0;
    //parse coupon code
    const couponCodeParts = /(((^|\?|&)(HYAR=)|^)\d+(?=($|&)))/gm.exec(coupon_code)
    if (couponCodeParts && couponCodeParts.length > 0) {
      if (couponCodeParts[0].includes("=")) {
        free_item_nr = +(couponCodeParts[0].split("=")[1]);
      } else {
        free_item_nr = +(couponCodeParts[0]);
      }
    }
    if (isNaN(free_item_nr) || free_item_nr <= 0) {
      me._coreLogService.info("WebshopService.navigateToCouponCodeProduct", "wrong coupon code");
      return CouponScanState.WrongCode;
    }
    // App-Coupons werden durch Kunden definiert und können eine abweichende länge besitzen
    if (!is_app_coupon && free_item_nr.toString().length != webshopSettings.coupon_code_length) {
      me._coreLogService.info("WebshopService.navigateToCouponCodeProduct", "wrong coupon code length");
      return CouponScanState.WrongCode;
    }

    const locationID = me.locationID;
    // momentan ohne rezepturverkettung (nur normale Artikel)
    const products = await me._productService.GetProductsByFilter(locationID, me.sortiment, product => !product.deleted && product.saleable && product.free_item_nr == free_item_nr)
    if (products.length == 0) {
      me._coreLogService.info("WebshopService.navigateToCouponCodeProduct", "unknown coupon code");
      return CouponScanState.WrongCode;
    }
    // tags werden nicht benötigt nur schedule für die verfügbarkeitsprüfung
    const itemTags = [];
    const likeItemTagIds = [];
    const schedule_req = new ScheduledForRequest(me.getScheduledForReferenceTime(), locationID, webshopSettings, me._coreLanguageService);
    const product = new ProductViewModel(locationID, products[0], itemTags, likeItemTagIds, schedule_req);
    return me.resolveAvailabilityAndNavigate(product, options);
  }

  /** Finds the coupon's free product by product_id and opens it. */
  public async findAndNavigateToProductByProductId(
    productId: number,
    options: OpenProductOptions
  ): Promise<CouponScanState> {
    const me = this;
    const webshopSettings = await me.getWebshopSettingsDataModel();
    const locationID = me.locationID;
    const products = await me._productService.GetProductsByFilter(locationID, me.sortiment, product => !product.deleted && product.product_id === productId);
    if (products.length == 0) {
      me._coreLogService.info("WebshopService.findAndNavigateToProductByProductId", "product_id not found in sortiment");
      return CouponScanState.NotAvailable;
    }
    const itemTags = [];
    const likeItemTagIds = [];
    const schedule_req = new ScheduledForRequest(me.getScheduledForReferenceTime(), locationID, webshopSettings, me._coreLanguageService);
    const product = new ProductViewModel(locationID, products[0], itemTags, likeItemTagIds, schedule_req);
    return me.resolveAvailabilityAndNavigate(product, options);
  }

  /** Checks the product is available and opens it. */
  private async resolveAvailabilityAndNavigate(
    product: ProductViewModel,
    options: OpenProductOptions
  ): Promise<CouponScanState> {
    const me = this;
    const locationID = me.locationID;
    // The product count is more than the minimum and the product is not blacklisted
    const isProductValid = await me.isProductAvailable$(product.product_id);
    if (isProductValid && product.availible) {
      if (options.onBeforeOpenProduct) {
        options.onBeforeOpenProduct(product.id);
      }
      let success_navigation = false;
      if (product.is_recipe_linking) {
        success_navigation = await me._router.navigate(["recipeLink", options.backItemGroupId, product.id, locationID]);
      } else {
        success_navigation = await me._router.navigate(["menudetail", options.backItemGroupId, product.id, locationID]);
      }

      if (success_navigation) {
        return CouponScanState.OK;
      } else {
        throw new Error("navigation faild");
      }
    } else {
      return CouponScanState.NotAvailable;
    }
  }

  /** sammeln der Bonus punkte ist unabhängig von der Zahlung mit Webgutscheinen, aber es darf nicht beim Kauf von Webgutscheinen erfolgen
   * da 1. es nicht im Bonussystem beachtet wird
   * und 2. am POS sonst die Zahlungsart fest als Bar gebucht wird, was falsch ist
   */
  public get canCollectBonuspoints(): boolean {
    return this._canCollectBonuspoints && this.serviceMode !== WebShopMode.Webvoucher;
  }

  // #region Webshop Data Restore

  /**
   * Builds the base data object to save in the local storage
   * @returns WebshopBaseData
   */
  private buildBaseData() {
    const me = this;
    const weshopBaseData: WebshopBaseData = new WebshopBaseData();

    weshopBaseData.serviceMode = me.serviceMode;
    weshopBaseData.locationID = me.locationID;
    weshopBaseData.locationName = me._locationName;
    weshopBaseData.city = me.DestinationCity;
    weshopBaseData.zipCode = me.DestinationZipCode;
    weshopBaseData.address = me.DestinationAddress;
    weshopBaseData.country = me.DestinationCountry;
    weshopBaseData.polygonMapInformation = me.PolygonMapInformation;
    weshopBaseData.deliveryArea = me.deliveryArea;
    weshopBaseData.serviceLeadTimeType = me.serviceLeadTimeType;
    weshopBaseData.serviceLeadTime = me.serviceLeadTime;
    weshopBaseData.serviceCycletime = me.serviceCycletime;
    weshopBaseData.minimumOrderValue = me._minimumOrderValue;
    weshopBaseData.deliveryFee = me._deliveryFee;
    weshopBaseData.useFreeShipping = me._useFreeShipping;
    weshopBaseData.freeShippingThreshold = me._freeShippingThreshold;
    weshopBaseData.locationMwst1 = me._locationMwst1;

    if (me.openTimeService && me.openTimeService.length > 0) {
      weshopBaseData.openTimeService = _.cloneDeep(me.openTimeService);
    }
    if (me.locationOpenDays && me.locationOpenDays.length > 0) {
      weshopBaseData.locationOpenDays = _.cloneDeep(me.locationOpenDays);
    }

    weshopBaseData.timestamp = moment().toString();
    return weshopBaseData;
  }

  /**
   * Builds the basket restore data object to save in the local storage
   * @returns BaskeRestoretData
   */
  private buildBasketRestoreData() {
    const me = this;
    const basketData: BasketRestoreData = new BasketRestoreData();

    basketData.recommendationIds = me._recommendationProductIds;
    basketData.shippingCartItems = _.cloneDeep(me.shippingCartItems);
    basketData.trinkgeldValue = me._trinkgeldValue;
    basketData.trinkgeldPercentage = me._trinkgeldPercentage;
    basketData.orderComment = me._orderComment;
    basketData.orderASAP = me.orderASAP;

    if (me.serviceMode === WebShopMode.OrderToTable) {
      basketData.qrCode = me.qrCode;
      basketData.tableName = me.tableName;
    }
    if (me.serviceMode === WebShopMode.Webvoucher) {
      basketData.voucherServiceType = me._voucherServiceType;
    }

    basketData.fixedBasket = !me.allowBasketModification;
    basketData.addPurchaseOrderToken = me.addPurchaseOrderToken;
    basketData.returnURLSuccess = me.returnURLSuccess;
    basketData.returnURLFail = me.returnURLFail;
    basketData.returnURLBasket = me.returnURLBasket;

    return basketData;
  }

  /** Emits the current cart to all subscribers and persists it. Called after in-place
   *  mutations (e.g. attaching coupon_id/coupon_code) that bypass the normal add/remove paths. */
  public notifyCartChanged(): void {
    const me = this;
    me._shippingCartSubject.next(me.shippingCartItems);
    me.saveToStorage();
  }

  /**
   * Saves the webshop data to the local storage
   */
  public saveToStorage() {
    const me = this;
    const baseData: WebshopBaseData = me.buildBaseData();
    me._coreComService.environment.valueStorage.set(StorageHive.Local, LocalKeys.WebshopBaseData, baseData);

    if (me.shippingCartItems.length > 0) {
      const basketData: BasketRestoreData = me.buildBasketRestoreData();
      me._coreComService.environment.valueStorage.set(StorageHive.Local, LocalKeys.WebshopBasket, basketData);
      const timeStr = moment().toString();
      me._coreComService.environment.valueStorage.set(StorageHive.Local, LocalKeys.WebshopBasketTime, timeStr);
    } else {
      me._coreComService.environment.valueStorage.remove(StorageHive.Local, LocalKeys.WebshopBasket);
      me._coreComService.environment.valueStorage.remove(StorageHive.Local, LocalKeys.WebshopBasketTime);
    }
  }

  /**
   * Restores the webshop data from the local storage if valid,
   *  otherwise resets the webshop service
   */
  public async restoreFromValueStorage() {
    const me = this;
    try {
      const now = moment();
      const baseData = await me._coreComService.environment.valueStorage.get(
        StorageHive.Local,
        LocalKeys.WebshopBaseData
      );
      const basketData = await me._coreComService.environment.valueStorage.get(
        StorageHive.Local,
        LocalKeys.WebshopBasket
      );
      const basketTimeStr = await me._coreComService.environment.valueStorage.get(
        StorageHive.Local,
        LocalKeys.WebshopBasketTime
      );
      const basketTime = basketTimeStr ? moment(basketTimeStr) : null;
      const isBasketDataValid = me.isTimeValid(basketTime, now) && me.hasItems(basketData);

      let finalBaseData: WebshopBaseData = null;
      let finalBasketData: BasketRestoreData = null;

      if (isBasketDataValid) {
        finalBasketData = basketData;
        finalBaseData = baseData;
      } else {
        await me._coreComService.environment.valueStorage.remove(StorageHive.Local, LocalKeys.WebshopBasket);
        await me._coreComService.environment.valueStorage.remove(StorageHive.Local, LocalKeys.WebshopBasketTime);

        const isBaseDataValid = baseData && me.isTimeValid(moment(baseData.timestamp), now);
        finalBaseData = isBaseDataValid ? baseData : null;
        if (!isBaseDataValid && baseData) {
          await me._coreComService.environment.valueStorage.remove(StorageHive.Local, LocalKeys.WebshopBaseData);
        }
      }

      if (finalBaseData || finalBasketData) {
        await me.restoreFromRestorePoint({ baseData: finalBaseData, basketData: finalBasketData });
      } else {
        me.resetWebshopService();
      }

    } catch (error) {
      me._coreLogService.error("WebshopService.restoreFromValueStorage", "restore data", error);
      me.resetWebshopService();
    } finally {
      me._fullyLoadedAsyncSubject.next(null);
      me._fullyLoadedAsyncSubject.complete();
    }
  }

  private isTimeValid(time: moment.Moment | null, now: moment.Moment): boolean {
    if (!time) return false;
    return now.isBefore(time.clone().add(120, "minutes"));
  }

  private hasItems(basket: BasketRestoreData): boolean {
    return !!(basket && basket.shippingCartItems && basket.shippingCartItems.length);
  }


  /**
   * Restore webshop data
   * @param restore baseData, basketData
   */
  private async restoreFromRestorePoint(restore: WebshopServiceRestorePoint) {
    const me = this;
    const { baseData, basketData } = restore;
    // Restore base data
    if (baseData) {
      const serviceModeResult = await me.setServiceMode(baseData.serviceMode);
      // If serviceMode could not be set (invalid/non-existent ordertype), skip restore and reset
      if (serviceModeResult === null) {
        me.resetWebshopService();
        return;
      }
      await me.initializeService();
      me._locationID = baseData.locationID;
      me._locationName = baseData.locationName;
      me.DestinationZipCode = baseData.zipCode;
      me.DestinationAddress = baseData.address;
      me.DestinationCity = baseData.city;
      me.DestinationCountry = baseData.country;
      if (baseData.polygonMapInformation) me.PolygonMapInformation = baseData.polygonMapInformation;
      await me.initializeOrderDataViewModel();
      me.deliveryArea = baseData.deliveryArea;
      me.serviceLeadTimeType = baseData.serviceLeadTimeType;
      me.serviceLeadTime = baseData.serviceLeadTime;
      me.serviceCycletime = baseData.serviceCycletime;
      me._minimumOrderValue = baseData.minimumOrderValue;
      me._deliveryFee = baseData.deliveryFee;
      me._useFreeShipping = baseData.useFreeShipping;
      me._freeShippingThreshold = baseData.freeShippingThreshold;
      me._locationMwst1 = baseData.locationMwst1;

      if (baseData.openTimeService) {
        me.openTimeService = baseData.openTimeService.map(el => _.extend(new LocationOpenTime, el));
      }
      if (baseData.locationOpenDays) {
        me.locationOpenDays = _.clone(baseData.locationOpenDays);
      }
    }

    // Restore basket data
    if (basketData) {
      me._recommendationProductIds = basketData.recommendationIds;
      me.toggleFixedMode(basketData.fixedBasket);
      me.addPurchaseOrderToken = basketData.addPurchaseOrderToken;
      me.returnURLSuccess = basketData.returnURLSuccess;
      me.returnURLFail = basketData.returnURLFail;
      me.returnURLBasket = basketData.returnURLBasket;

      if (me.ordertype.useYASBasket) {
        me.syncYASServerBasketToLocal();
      } else if (basketData.shippingCartItems && Array.isArray(basketData.shippingCartItems)) {
        me.shippingCartItems = basketData.shippingCartItems.map(el => _.extend(new BasketItemViewModel, el));
        me.shippingCartItems.map(item => item.product_extras = item.product_extras.map(extra => _.extend(new BasketItemExtraViewModel, extra)));
      } else {
        me.shippingCartItems = [];
      }

      me._trinkgeldValue = basketData.trinkgeldValue;
      me._trinkgeldPercentage = basketData.trinkgeldPercentage;

      if (me.serviceMode === WebShopMode.OrderToTable) {
        me.qrCode = basketData.qrCode;
        me._tableName = basketData.tableName;
      }
      if (me.serviceMode === WebShopMode.Webvoucher) {
        me._voucherServiceType = basketData.voucherServiceType;
      }

      me._orderComment = basketData.orderComment;
      me.orderASAP = basketData.orderASAP;
      me._shippingCartSubject.next(me.shippingCartItems);
    }
  }

  // #endregion  Webshop Data Restore

  public async getWebshopSettingsDataModel(): Promise<WebshopSettingsDataModel2> {
    if (!this._webshopSettingsDataModel) {
      this._webshopSettingsDataModel = await this._webshopSettingsObsServ.GetObject(WebshopSettingsDMKey);
    }
    return this._webshopSettingsDataModel;
  }

  /** ermittelt ob es Intup Felder gibt welche der Gast zu füllen hat */
  public get hasCustomerInputFields(): boolean {
    if (this.ordertype.customer_input_fields.find(field => field["used"])) {
      return true;
    } else {
      return false;
    }
  }

  public getDeliveryCountries(): DeliveryCountry[] {
    if (this.serviceMode === WebShopMode.Retail && this._webshopSettingsDataModel) {
      const deliveryCountries = this._webshopSettingsDataModel.delivery_countries || []; // ! TODO es muss asynchrone werden, das webshopSettings async sind
      const sortedDeliveryCountries = deliveryCountries.sort((a, b) => a.country_de.localeCompare(b.country_de));
      return sortedDeliveryCountries;
    } else {
      return [];
    }
  }

  /**
   * Applies delivery-country-derived fee/threshold values and the resulting order-data
   * destination to service state — shared so both callers compute the fee identically.
   */
  private applyDeliveryCountryFeeValues(deliveryCountry: DeliveryCountry): void {
    const me = this;
    me._minimumOrderValue = me.calculateMinimumOrderValue(deliveryCountry.minimum_order_value);
    me._deliveryFee = me.calculateDeliveryFee(deliveryCountry.delivery_fee);
    me._freeShippingThreshold = me.calculateFreeShippingThreshold(deliveryCountry.free_shipping_threshold);
    me._useFreeShipping = me.validateUseFreeShipping(deliveryCountry.use_free_shipping);
    me.DestinationCountry = deliveryCountry;
    me.setOrderDataDestination();
  }

  public selectDeliveryCountry(deliveryCountry: DeliveryCountry) {
    const me = this;
    me.applyDeliveryCountryFeeValues(deliveryCountry);
    me._orderDataCountryChangedSubject.next(true);
    // Must persist: restore overwrites all base-data fields unconditionally, silently losing this otherwise.
    me.saveToStorage();
  }

  /**
   * Diese Funktion darf nur vom remoteOrderModeSelector aufgerufen werden, um zwischen Lieferung und Gruppenbestellunglieferung
   * oder Abholung und Gruppenabholung zu wechseln!
   * @param serviceId
   * @returns
   */
  public changeServiceMode(serviceId: WebShopMode): Promise<number | null> {
    const me = this;
    if (
      ((me.serviceMode === WebShopMode.Delivery || me.serviceMode === WebShopMode.DeliveryGroup) && (serviceId === WebShopMode.Delivery || serviceId === WebShopMode.DeliveryGroup))
      ||
      ((me.serviceMode === WebShopMode.TakeAway || me.serviceMode === WebShopMode.PickupGroup) && (serviceId === WebShopMode.TakeAway || serviceId === WebShopMode.PickupGroup))
      ||
      // if user just joined the me.serviceMode is still null, so allowing for this case
      Utils.IsNull(me.serviceMode)
    ) {
      return me._setServiceMode(serviceId, false, null, true);
    } else {
      me._coreLogService.error("WebshopService.changeServiceMode", "servicdeMode and serviceId are wrong!", me.serviceMode, serviceId);
      me._snackBarService.ShowErrorMessageFailed(131);
      return null;
    }
  }

  public setServiceMode(serviceId: number, checkVoucherType: boolean = false, voucherServiceType: VoucherServiceType = null): Promise<number | null> {
    return this._setServiceMode(serviceId, checkVoucherType, voucherServiceType, false);
  }

  private async _setServiceMode(serviceId: number, checkVoucherType: boolean, voucherServiceType: VoucherServiceType, suppressResetWebshopService: boolean): Promise<number | null> {
    const me = this;
    if ((!suppressResetWebshopService && me.serviceMode != null && me.serviceMode !== serviceId) || (checkVoucherType && me._voucherServiceType !== null && me._voucherServiceType !== voucherServiceType)) {
      me.resetWebshopService();
    }
    // restore old gtc value, nur bei InHouse
    if (serviceId === WebShopMode.OrderToTable) {
      try {
        const gtc = await me._coreComService.environment.valueStorage.get(StorageHive.Local, LocalKeys.gtc);
        if (!me._hasAcceptedAGB) {
          me._hasAcceptedAGB = (gtc === true);
        }
      } catch (error) {
        me._coreLogService.error("WebshopService.setServiceMode", "valueStorage.get gtc catch", error);
      }
    } else {
      me._hasAcceptedAGB = false;
    }

    me.ordertype = await me._webshopOrdertypesService.getOrdertypeByID(serviceId).toPromise();
    const servicechanging = me.serviceMode !== serviceId;
    me.serviceMode = serviceId;

    me._voucherServiceType = voucherServiceType;
    // bei Gutscheinen muss ein Gutschein-Verkaufs-Typ gestezt werden
    if (me.serviceMode === WebShopMode.Webvoucher && me._voucherServiceType === null) {
      me._voucherServiceType = VoucherServiceType.Order;
    }

    const webshopSettings = await me.getWebshopSettingsDataModel();
    const ordertype = webshopSettings.ordertypes.find(o => o.id === serviceId);
    if (ordertype) {
      me.servicePe = ordertype.default_pe;
      me.sortiment = ordertype.sortiment;
      me._trinkgeldPercentage = ordertype.tip_percentage;
      me.sortiment = ordertype.sortiment;
    } else {
      // Webvoucher is currently not configurable and does not need PE and sortiment
      if (serviceId === WebShopMode.Webvoucher) {
        me.servicePe = 0;
        me.sortiment = webshopSettings.ordertypes.find(o => o.id === WebShopMode.Delivery).sortiment; // Used currently be ExternalBasket
      } else {
        // Reset serviceMode if ordertype is invalid (e.g. from restore with old/deleted ordertype)
        me.serviceMode = null;
        return null;
      }
    }
    me._reloadUserDiscountsAndPriceLevel(servicechanging);
    return me.serviceMode;
  }


  /**
   * Reload userPe and discounts when order type changes
   * In InHouse mode, userPe is set to null (no discounts allowed).
   * When switching from IH to Pickup/Delivery, userPe must be reloaded from server
   * to display discounted prices again.
   */
  private async _reloadUserDiscountsAndPriceLevel(serviceChanging: boolean) {
    const me = this;
    if (serviceChanging) {
      await me.onUserChange();
    }

  }

  /**
   *
   * @param locationWebshopViewModel
   * @param zipCode verwendete PLZ
   * @param city verwendete Stadt
   * @param address verwendete Straße
   */
  public async setServiceLocationInfo(locationWebshopViewModel: LocationWebshopViewModel, zipCode: string, city: string = "", address: string = "") {
    const me = this;
    try {
      if (await me.initializeService()) {
        if (me.locationID && me.locationID !== locationWebshopViewModel.hyp_cus_nr) {
          me.resetWebshopLocationService();
        }
        me._locationID = locationWebshopViewModel.hyp_cus_nr;
        me._locationName = locationWebshopViewModel.label;
        me.DestinationZipCode = zipCode;
        me.DestinationCity = city;
        me.DestinationAddress = address;
        me._locationMwst1 = locationWebshopViewModel.mwst1;
        me.deliveryArea = locationWebshopViewModel.delivery_areas;
        me.deliveryAreaPolygonMap = locationWebshopViewModel.delivery_areas_polygon_map;
        await me.initializeOrderDataViewModel();

        me.locationOpenDays = locationWebshopViewModel.openDaysList;
        me.openTimeService = locationWebshopViewModel.momentOpenTimeService;
        // TODO both condition are the same?
        // if (me.openTimeService && me.openTimeService !== locationWebshopViewModel.momentOpenTimeService) {
        //   me.openTimeService = locationWebshopViewModel.momentOpenTimeService;
        // } else {
        //   me.openTimeService = locationWebshopViewModel.momentOpenTimeService;
        // }
        switch (me.serviceMode) {
          case WebShopMode.Delivery:
            {
              const targetDeliveryLocation = locationWebshopViewModel.delivery_areas.find(l => l.zip === zipCode && (!l.city || l.city === city));
              if (!targetDeliveryLocation) {
                me._coreLogService.error("WebshopService.setServiceLocationInfo", "delivery area not found", { zipCode, city });
              }
              me.serviceLeadTimeType = locationWebshopViewModel.delivery_lead_time_type;
              me.serviceLeadTime = locationWebshopViewModel.delivery_lead_time;
              me.serviceCycletime = locationWebshopViewModel.delivery_beat;
              me._minimumOrderValue = me.calculateMinimumOrderValue(targetDeliveryLocation ? targetDeliveryLocation.minimum_order_value : 0);
              me._deliveryFee = me.calculateDeliveryFee(targetDeliveryLocation ? targetDeliveryLocation.delivery_fee : 0);
              const webshopSettings = await me.getWebshopSettingsDataModel();
              me._useFreeShipping = me.validateUseFreeShipping(webshopSettings.use_free_shipping);
              me._freeShippingThreshold = me.calculateFreeShippingThreshold(webshopSettings.free_shipping_threshold);
              break;
            }
          case WebShopMode.TakeAway:
            {
              me.serviceLeadTimeType = locationWebshopViewModel.pickup_lead_time_type;
              me.serviceLeadTime = locationWebshopViewModel.pickup_lead_time;
              me.serviceCycletime = locationWebshopViewModel.pickup_beat;
              break;
            }
          default: {
            break;
          }
        }
      }
    } catch (error) {
      me._coreLogService.error("WebshopService.setServiceLocationInfo", "try catch", error);
    }
  }

  public async checkRequiredOrderDataStatus(): Promise<OrdereRequirementsStatus> {
    const me = this;
    const isDelivery = me.serviceMode === WebShopMode.Delivery;
    const isTakeAway = me.serviceMode === WebShopMode.TakeAway;
    const isTimeRequired = isDelivery || isTakeAway;
    const isAddressRequired = isDelivery;
    let status = OrdereRequirementsStatus.OK;
    // Check if address is required and properly entered
    if (isAddressRequired) {
      const isAddressEntered =
        !Utils.IsNullOrEmpty(me.currentlyUsedZipcode) &&
        !Utils.IsNullOrEmpty(me.currentlyUsedAddress) &&
        !Utils.IsNullOrEmpty(me.currentlyUsedCity);

      if (!isAddressEntered) {
        return OrdereRequirementsStatus.AddressRequired;
      }
    }
    // Check if time is required and set
    if (isTimeRequired && !me.serviceOrderTime) {
      // Try to restore time from local storage
      const cachedTime = await me._coreComService.environment.valueStorage.get(
        StorageHive.Local,
        LocalKeys.serviceTime
      );
      const items = me.getShippingCartItems();
      const hasEmptyBasket = !items || items.length === 0;

      if ((cachedTime && hasEmptyBasket) || !cachedTime) {
        return OrdereRequirementsStatus.TimeRequired;
      }
    }
    return status;
  }


  //#region order time

  /** Check if the current service mode requires a service time to be set.*/
  public get isTimeRequired(): boolean {
    const me = this;
    const serviceMode = me.getServiceMode();
    return serviceMode === WebShopMode.TakeAway || serviceMode === WebShopMode.Delivery || serviceMode === WebShopMode.PickupGroup || serviceMode === WebShopMode.DeliveryGroup;
  }

  //TODO customer settings (portal)
  public get useOrderSubmissionTime() {
    //? _webShopService.settings.useOrderSubmissionTime?
    return false
  }

  /** Time when the user wants to place the orders */
  private _orderSubmissionTime: moment.Moment = null;
  public get orderSubmissionTime(): moment.Moment {
    return this._orderSubmissionTime;
  }

  /**Set the submission time */
  public setServiceSubmissionTime(orderSubmissionTime: string) {
    const me = this;
    if (orderSubmissionTime) {
      me._orderSubmissionTime = moment(orderSubmissionTime);
    } else {
      me._orderSubmissionTime = null;
    }
  }

  /** Time when the user wants to receive (Delivery /pickup) the order */
  private _serviceOrderTime: moment.Moment = null;
  public get serviceOrderTime(): moment.Moment {
    return this._serviceOrderTime;
  }

  /** Set the service time */
  public setServiceOrderTime(serviceOrderTime: string) {
    const me = this;
    if (serviceOrderTime) {
      me._serviceOrderTime = moment(serviceOrderTime);
    } else {
      me._serviceOrderTime = null;
    }
  }

  public getScheduledForReferenceTime(): moment.Moment {
    const me = this;
    if (!me.isTimeRequired) {
      return moment();
    }
    if (me.serviceOrderTime != null) {
      return me.serviceOrderTime.clone();
    }
    return moment();
  }

  /** Restores the cached service time from local storage and sets it in the service */
  public async restoreAndSetServiceTimeFromCache(): Promise<moment.Moment | null> {
    const me = this;
    try {
      const cachedData: string | null = await me._coreComService.environment.valueStorage.get(StorageHive.Local, LocalKeys.serviceTime);
      if (cachedData) {
        me._serviceOrderTime = moment(cachedData);
        return me._serviceOrderTime;
      }
      return null;
    } catch (error) {
      me._coreLogService.error("WebShopService.restoreAndSetServiceTimeFromCache", error);
      return null;
    }
  }

  /** Removes the OrderTime from the cache */
  public async removeCachedServiceTime(): Promise<void> {
    const me = this;
    try {
      const cachedData: string | null = await me._coreComService.environment.valueStorage.get(StorageHive.Local, LocalKeys.serviceTime);
      if (cachedData) {
        await me._coreComService.environment.valueStorage.remove(StorageHive.Local, LocalKeys.serviceTime);
      }
    } catch (error) {
      me._coreLogService.error("WebShopService.CleanupCacheData", error);
      throw error;
    }
  }

  /** Updates the OrderTime in the cache */
  public async setCachedServiceTime(newOrderTime: string): Promise<void> {
    const me = this;
    if (!me.isTimeRequired) return;
    try {
      await me._coreComService.environment.valueStorage.set(StorageHive.Local, LocalKeys.serviceTime, newOrderTime);
    } catch (error) {
      me._coreLogService.error("WebShopService.updateOrderTimeInCache", error);
      throw error;
    }
  }

  public async hasTimeAlreadySelected() {
    const me = this;
    if (!me.serviceOrderTime) {
      await me.restoreAndSetServiceTimeFromCache();
    }
    return me.serviceOrderTime != null;
  }

  /**
 * Calculates the minimum valid service time (earliest time that can be selected/used).
 * Includes lead time (if configured) and a 5-minute buffer.
 * @returns Moment object representing the minimum valid time
 */
  public getMinimumValidServiceTime(): moment.Moment {
    const me = this;
    const buffer = 5; // 5 minutes buffer
    let minimumTime = moment();
    // Add lead time (only for minute type)
    if (me.serviceLeadTimeType === LeadTimeType.Minute && me.serviceLeadTime) {
      minimumTime = minimumTime.add(me.serviceLeadTime, "minutes");
    }
    // Add buffer
    minimumTime = minimumTime.add(buffer, "minutes");
    return minimumTime;
  }

  /**
   * Checks if valid order times are available for the current service mode and location.
   * cases:
   * - Only today allowed && no valid times available
   * - Only today allowed && has valid times
   * - Multiple days allowed && at least one day has valid times
   */
  public async hasValidOrderTimes(): Promise<boolean> {
    const me = this;
    try {
      const openDays = await me.getOpenDays();
      if (!openDays || openDays.length === 0) {
        // No open days configured
        return false;
      }
      // Check each day for valid times
      for (const day of openDays) {
        try {
          const availableTimes = await me.getAvailableServiceTimes(day.value, day.use_time);
          // If this day has valid times, return true
          if (availableTimes.length > 0) {
            return true;
          }
        } catch (error) {
          me._coreLogService.error("WebShopService.hasValidOrderTimes", "error checking day", day, error);
        }
      }
      // No days with valid times found
      return false;
    } catch (error) {
      me._coreLogService.error("WebShopService.hasValidOrderTimes", "error", error);
      // On error, allow navigation to avoid blocking user
      return true;
    }
  }

  /**Current time falls in the gap between breaks */
  public isBetweenBreaks(location: LocationWebshopViewModel) {
    let isBetweenBreak = false;
    const checkHasBreaks = location.open && location.momentOpenTimeService && location.momentOpenTimeService.length > 1;
    if (checkHasBreaks) {
      const currentDay = moment();
      const currentTimeHMS = Utils.GetHMSFromMoment(currentDay);
      for (let i = 0; i < location.momentOpenTimeService.length - 1; i++) {
        const currentBreakEnd = location.momentOpenTimeService[i].end_hms;
        const nextBreakStart = location.momentOpenTimeService[i + 1].start_hms;
        isBetweenBreak = (currentTimeHMS >= currentBreakEnd) && (currentTimeHMS < nextBreakStart);
      }
    }
    return isBetweenBreak;
  }

  /** Check if today has available timeslots */
  public async hasValidTimesForToday(): Promise<boolean> {
    const me = this;
    try {
      const today = moment().format('YYYYMMDD');
      const availableTimes = await me.getAvailableServiceTimes(today, true);
      return availableTimes.length > 0;
    } catch (error) {
      me._coreLogService.error("WebShopService.hasValidOrderTimesToday", "error", error);
      return false;
    }
  }

  /**
   * Processes order time availability and navigates accordingly.
   * Handles cases: location closed today, no valid times, before opening, between breaks.
   */
  private async processOrderTimeAvailability(data: IServiceTimeSelectionData) {
    const me = this;
    const hasRemoteGroupOrder = (data.serviceMode === WebShopMode.Delivery && data.location.service_delivery_group)
      || (data.serviceMode === WebShopMode.TakeAway && data.location.service_pickup_group);
    const route = hasRemoteGroupOrder
      ? NavigationRoute.RemoteOrderModeSelector
      : NavigationRoute.OrderTimeSelector;

    const { location, serviceMode, zipCode } = data;
    const isOpenToday = location.open && location.momentOpenTimeService && location.momentOpenTimeService.length > 0;

    if (isOpenToday && await me.hasValidTimesForToday()) {
      const now = moment();
      const firstTimeToday = Utils.GetMomentFromInt(
        Utils.GetYMDFromMoment(now),
        location.momentOpenTimeService[0].start_hms
      );
      const isBeforeOpening = now.isBefore(firstTimeToday);
      const isBetweenBreaks = this.isBetweenBreaks(location);

      // If current time is before opening or during breaks
      if (isBeforeOpening || isBetweenBreaks) {
        // Show dialog with today's times only
        me.openAvailableServiceTime({
          serviceMode: serviceMode,
          location: location,
          navigationRoute: route,
          hasValidOrderTimes: true,
          showOnlyToday: true
        });
      } else {
        // navigate directly to the time selector
        me._router.navigate([route]);
      }
      return;
    }

    // If location is closed today OR open but no valid times today, check future days
    if (!(await me.hasValidOrderTimes())) {
      // No valid times at all (today or future)
      me.openAvailableServiceTime({
        serviceMode: serviceMode,
        location: location,
        navigationRoute: NavigationRoute.Home,
        hasValidOrderTimes: false,
        showOnlyToday: false
      });
      me.setServiceMode(null);
      return;
    }
    // Valid times exist on future days, but lead time is based on work days, so navigation directly to time selector
    if (me.serviceLeadTimeType === LeadTimeType.WorkDay) {
      me._router.navigate([route]);
      return;
    }

    // Valid times exist on future days,show dialog with ALL days and navigate to time selector
    me.openAvailableServiceTime({
      serviceMode: serviceMode,
      location: location,
      navigationRoute: route,
      hasValidOrderTimes: true,
      showOnlyToday: false
    });
  }

  /** set service location info and process order time availability.*/
  public async initializeAndProcessServiceTime(data: IServiceTimeSelectionData): Promise<void> {
    const me = this;
    if (me.serviceMode === null) { // no order type selected; Viewing (0) is a valid mode
      me._router.navigate([NavigationRoute.MenuService]);
      return;
    }
    await me.setServiceLocationInfo(data.location, data.zipCode || "", data.city || "", data.address || "");
    const loadData = {
      serviceMode: data.serviceMode,
      location: data.location,
      zipCode: data.zipCode || "",
      city: data.city || "",
      address: data.address || ""
    }
    await me.processOrderTimeAvailability(loadData);
  }
  //#End time selection

  /**
   * Opens a warning dialog when the user attempts to leave the current group to select a different order type.
   *
   * @param next_location - The ID of the next location the user wants to switch to.
   * @param next_service - The next service mode the user wants to switch to.
   */
  public async openWarningLeaveGroup(next_location: number, next_service: WebShopMode, changelocationViaMainNavIcon: boolean = false): Promise<void> {
    const me = this;
    const currentService = me.getServiceMode();
    const isRemoteGroup = currentService === WebShopMode.DeliveryGroup || currentService === WebShopMode.PickupGroup;
    const locationDataIsNotTheSame = me.locationID !== next_location || currentService !== next_service;
    if (isRemoteGroup && (locationDataIsNotTheSame || changelocationViaMainNavIcon)) {
      const dialog = me._bottomSheetHelperService.open(SecureCheckDialogComponent, {
        data: {
          title: "phRemoteOrder_ChangeOrder_Dialog_Title",
          description: "phRemoteOrder_ChangeOrder_Dialog_Content",
          buttonTextAccept: "phGlobal_Return",
          buttonTextDeny: "phRemoteOrder_ChangeOrder_Dialog_Button",
          icon: "hypersoft-achtung.svg",
        },
        panelClass: "mat-bottom-sheet-container-medium"
      });
      dialog.afterDismissed().subscribe((stay: boolean) => {
        if (!stay) {
          me._router.navigate(["/remoteOrderGroupServiceSelector"]);
        } //else nothing
      })
    }
  }

  // public setVoucherServiceType(voucherServiceType: VoucherServiceType) {
  //   const me = this;
  //   me._voucherServiceType = voucherServiceType;
  // }

  /** Öffnet den Dialog mit dem Hinweis, dass beim fortfahren die offnen Bestellungen verlorengehen
   * @param next_location wechsel des Standorts
   * @param next_service wechsel des Service
   * @param agree_callback wird aufgerufen, wenn zugestimmt wurde
   * @param dasagree_callback wird aufgerufen, wenn abgelehnt wurde
  */
  public async openWarningResetBasketDialogIfNeed(next_location: number, next_service: WebShopMode, callback: (boolean) => void): Promise<void> {
    const me = this;
    const currentService = me.getServiceMode();
    const hasTableItems = (me._objObsInjectHelper.inHouseOrderService.UiData.open_amount > 0);
    const hasGroupBasketItems = await me._objObsInjectHelper.inHouseOrderService.HasGroupBasketItems();
    const hasBasketItems = (me.shippingCartItems && me.shippingCartItems.length > 0);
    // todo voucherServiceType berücksichtigen? me._webShopService.voucherServiceType !== null && me._webShopService.voucherServiceType !== voucherServiceType
    if ((hasTableItems || hasGroupBasketItems || hasBasketItems) && (me.locationID !== next_location || currentService !== next_service || currentService === WebShopMode.OrderToTable)) {
      if (hasTableItems || ((hasGroupBasketItems || hasBasketItems) && currentService === WebShopMode.OrderToTable)) {
        // todo auslagern, wird auch in inHouseServiceSelector componente verwendet
        const dialog = me._bottomSheetHelperService.open(SecureCheckDialogComponent, {
          data: {
            title: "phInHauseService_Leave_Table_Dialog_Title",
            description: "phInHauseService_Leave_Table_Content",
            buttonTextAccept: "phGlobal_Return",
            buttonTextDeny: "phInHauseService_Leave_Table_Dialog_Button",
            icon: "shop-icons.svg#ya-hypersoft-achtung",
          },
          panelClass: "mat-bottom-sheet-container-medium"
        });
        dialog.afterDismissed().subscribe((accepted) => {
          callback(!accepted); // accepted = return
        });
      }
      else { // if (hasBasketItems)
        const dialog = me._bottomSheetHelperService.open(ResetbasketwarningdialogComponent, {
          data: { isLocationChange: true, locationName: me.locationName },
          panelClass: "mat-bottom-sheet-container--full-height"
        });
        dialog.afterDismissed().subscribe(callback);
      }
    } else {
      callback(true); // true = success
    }
  }

  public resetWebshopService() {
    const me = this;
    me.serviceMode = null;
    me._voucherServiceType = null;
    me.trinkgeldInputMethod = TrinkgeldInputMethod.Percentage;
    me.orderComment = "";
    me._serviceOrderTime = null;
    me._orderSubmissionTime = null;
    me.removeCachedServiceTime();
    me.resetNewsletterConfirm();
    me.resetWebshopLocationService();
    me.saveToStorage();
  }

  public resetWebshopLocationService() {
    const me = this;
    me.isInitialized = false;
    me._locationID = null;
    me._locationName = "";
    me.DestinationZipCode = "";
    me.DestinationCity = "";
    me.DestinationAddress = "";
    me.DestinationCountry = null;
    me.deliveryArea = null;
    me.deliveryAreaPolygonMap = null;
    me.openTimeService = null;
    me.locationOpenDays = null;
    me.serviceLeadTimeType = LeadTimeType.Minute;
    me.serviceLeadTime = 0;
    me.serviceCycletime = 0;
    me._deliveryFee = 0;
    me._useFreeShipping = false;
    me._freeShippingThreshold = 0;
    me._minimumOrderValue = 0;
    me._trinkgeldValue = 0;
    me._serviceOrderTime = null;
    me.releaseCouponReservationsOnReset();
    me.shippingCartItems = [];
    me._recommendationProductIds = [];
    me.serviceOpenTimeViewModels = null;
    me.deliveryAddressViewModel = new FurtherAddressViewModel();
    me._customerInputFieldViewModels = null;
    me._tableName = "";
    me.addPurchaseOrderToken = "";
    me.qrCode = "";
    me.allowBasketModification = true;
    me.returnURLSuccess = "";
    me.returnURLFail = "";
    me.returnURLBasket = "";
    me._activeItemGroupId = null;
    // try leave table, no .then() > try and forgot
    if (me._objObsInjectHelper.inHouseOrderService.Status != ConnectionState.Disconnected) {
      me._objObsInjectHelper.inHouseOrderService.Disconnect().catch((error) => {
        me._coreLogService.error("WebshopService.resetWebshopLocationService", "inHouseOrderService.Disconnect.catch", error);
      });
    }
    me._shippingCartSubject.next(me.shippingCartItems);
  }

  private async initializeService(): Promise<boolean> {
    const me = this;
    if (me.serviceMode == null) {
      me._coreLogService.error("WebshopService.initializeService", "Tried to initialize while ServiceMode null");
      me.resetWebshopService();
      me._router.navigate(["menuservice"]);
      return false;
    }
    else if (!me.isInitialized) {
      await me.GetWebshopOrderDataViewModel();
      const webshopSettings = await me.getWebshopSettingsDataModel();
      me.useAvailability = webshopSettings.article_availability;
      me.availabilityMinimum = webshopSettings.article_availability_minimum;
      me._customerInputFieldViewModels = me.createCustomerInputFieldViewModel(me.ordertype.customer_input_fields);

      me.isInitialized = true;
    }
    return true;
  }

  /**
   * navigation to web voucher
   * ! charge web voucher is under menu detail
   */
  public tryAndRouteToSingleVariableWebvoucher() {
    const me = this;
    if (me.serviceMode === WebShopMode.Webvoucher) {
      if (me._voucherServiceType === VoucherServiceType.Charge) {
        me.tryAndRouteToSingleChargeWebvoucher();
      } else {
        me._webvoucherCustomObsServ.GetObjectsByFilter(webvoucher => webvoucher.active && !webvoucher.deleted)
          .then(webvouchers => {
            if (webvouchers && webvouchers.length > 0) {
              if (webvouchers.length == 1) {
                me._isSingleWebVoucher = true;
                me._router.navigate(["webVoucherCustomDetail", webvouchers[0].id, me.locationID]); // todo ist locationID notwendig?
              } else {
                me._router.navigate(["webVoucherSelector"]);
              }
            } else {
              me._coreLogService.error("WebshopService.tryAndRouteToSingleVariableWebvoucher", "Could not find a variable Webvoucher", webvouchers);
              me.openWebVoucherWarningDialog();
            }
          }).catch(e => {
            me._coreLogService.error("WebshopService.tryAndRouteToSingleVariableWebvoucher", "me._productService.GetProductsByFilter", e);
          });
      }
    }
  }

  private _isSingleWebVoucher: boolean = false;
  public get isSingleWebVoucher() {
    const me = this;
    return me._isSingleWebVoucher;
  }

  /**check if model using type is web voucher
   * @param modelUsyngType using type of product data model
   * @returns boolean depending on modelUsyngType value
   */
  public isUsingTypeWebVoucher(modelUsyngType: number): boolean {
    const me = this;
    if (modelUsyngType === UsingType.Webvoucher || modelUsyngType === UsingType.VariableWebvoucher) {
      return true;
    } else {
      return false;
    }
  }

  /** navigate to charge web Voucher */
  public tryAndRouteToSingleChargeWebvoucher() {
    const me = this;
    me._productService.GetProductsByFilter(me.locationID, me.sortiment, model => !model.deleted && model.saleable && model.usingtype === UsingType.Webvoucher && model.price === 0)
      .then(webvoucher => {
        if (webvoucher && webvoucher.length > 0) {
          me._router.navigate(["menudetail", -1, webvoucher[0].id, me.locationID]);
        } else {
          me._coreLogService.error("WebshopService.tryAndRouteToSingleChargeWebvoucher", "Could not find a variable Webvoucher", webvoucher);
          me.openWebVoucherWarningDialog();
        }
      }).catch(e => {
        me._coreLogService.error("WebshopService.tryAndRouteToSingleChargeWebvoucher", "me._productService.GetProductsByFilter", e);
      });
  }

  public getAddressInputFields() {
    const me = this;
    const addressInputs = me.ordertype.customer_input_fields.filter(a => Object.keys(OrderDataAddressFieldInputs).includes(a["field"]));
    return me.createAddressInputFields(addressInputs);
  }


  /** cache für die für die letzte warnung genutzten daten */
  private lastWarningData_DiscountCannotBeUsed = {
    tableName: null,
    userPe: null,
    _userDiscountPercent: null,
    _webvoucherDiscountPercent: null,
  }

  /** cachten die daten */
  private cacheLastWarningData_DiscountCannotBeUsed() {
    const me = this;
    const lastWarningData = me.lastWarningData_DiscountCannotBeUsed;
    lastWarningData.tableName = me.tableName;
    lastWarningData.userPe = me.userPe;
    lastWarningData._userDiscountPercent = me._userDiscountPercent;
    lastWarningData._webvoucherDiscountPercent = me._webvoucherDiscountPercent;
  }

  /** bereinigt die gecachten daten */
  private resetLastWarningData_DiscountCannotBeUsed() {
    const me = this;
    const lastWarningData = me.lastWarningData_DiscountCannotBeUsed;
    lastWarningData.tableName = null;
    lastWarningData.userPe = null;
    lastWarningData._userDiscountPercent = null;
    lastWarningData._webvoucherDiscountPercent = null;
  }

  public async onUserChange(): Promise<void> {
    const me = this;
    me.loginState = me._userHelperService.IsRegistered;
    if (me.loginState) {
      try {
        const promises = await Promise.all([
          me._objObsInjectHelper.yourAppServer.User.GetUserInfo(true),
          me._webvoucherService.GetWebVoucherBalanceViewModel(),
        ])
        const userinfo = promises[0];
        const webvoucherInfo = promises[1];
        const oldUserPe = me.userPe;
        const newUserPe = (userinfo.pe === -1 || userinfo.pe == null) ? null : userinfo.pe;
        me.userPe = newUserPe;
        me._userDiscountPercent = userinfo.discount || 0;
        if (webvoucherInfo != null && userinfo.card_number) {
          const webvoucher = new Webvoucher();
          webvoucher.balance = webvoucherInfo.balance;
          webvoucher.balanceBonus = webvoucherInfo.balanceBonus;
          webvoucher.discountBonus = webvoucherInfo.discountBonus;
          webvoucher.cardnumber = userinfo.card_number;
          me.userHasWebvoucher = true;
          me.userWebvoucher = webvoucher;
          me._webvoucherDiscountPercent = webvoucherInfo.discountBonus;
        } else {
          me.userHasWebvoucher = false;
          me.userWebvoucher = null;
          me._webvoucherDiscountPercent = 0;
        }

        // ! achtung, wenn man eingellogt ist und in das payment geht, wird
        // todo forübergehend werden im InHouse keine Gast Preisebenen/Rabatte angewandt
        //! achtung checkout.component.ts UseWebVoucher beachten, hat selbe prüfung
        if (me.serviceMode === WebShopMode.OrderToTable) {
          const user_at_table = !Number.isNaN(me._objObsInjectHelper.inHouseOrderService.TableData.location);
          const table_has_mandatory_payment = me._objObsInjectHelper.inHouseOrderService.TableData.mandatory_Payment;
          if (user_at_table && !table_has_mandatory_payment) {
            if (me.userPe !== null || me._userDiscountPercent !== 0 || me._webvoucherDiscountPercent !== 0) {
              /** mögliche Rabatte / abweichende Preise werden momentan nicht berücksichtigt */
              const lastWarningData = me.lastWarningData_DiscountCannotBeUsed;
              if (me.tableName !== lastWarningData.tableName ||
                me.userPe !== lastWarningData.userPe ||
                me._userDiscountPercent !== lastWarningData._userDiscountPercent ||
                me._webvoucherDiscountPercent !== lastWarningData._webvoucherDiscountPercent) {
                me.openDiscountCannotBeUsed();
              }
              // cache the last warning data
              me.cacheLastWarningData_DiscountCannotBeUsed();
            } else {
              me.resetLastWarningData_DiscountCannotBeUsed();
            }
            me.userPe = null;
            me._userDiscountPercent = 0;
            // Webvoucher bleibt zum zahlen aber ohne rabatt
            me._webvoucherDiscountPercent = 0;
          } else {
            // in mandatory_Payment (PayNow) wird OrdarAndPay ausgeführt, damit ist dem Gast möglich Rabatt zu nutzen
            me.resetLastWarningData_DiscountCannotBeUsed();
          }
        } else {
          me.resetLastWarningData_DiscountCannotBeUsed();
        }

        me.recalcDiscountPricesInBasket(me.discountPercent);
        return;
      } catch (error) {
        me._coreLogService.error("WebshopService.initializeService", "_yourAppServer.User.GetUserInfo", error);
      }
    } else {
      me.resetLastWarningData_DiscountCannotBeUsed();
      me.userPe = null;
      me._userDiscountPercent = 0;
      me.userHasWebvoucher = false;
      me.userWebvoucher = null;
      me._webvoucherDiscountPercent = 0;
      me.recalcDiscountPricesInBasket(me.discountPercent);
      return;
    }
  }

  public getServiceMode() {
    const me = this;
    return me.serviceMode;
  }

  // todo function ist async und wird synchrone aufgerufen was nachteile hat und umgebaut werden muss
  private use_eCommerce: boolean = false;
  private async _loadUseECommerce(): Promise<void> {
    const me = this;
    try {
      me.use_eCommerce = (await this._productService.GetMenuSettings()).use_eCommerce;
    } catch (error) {
      me._coreLogService.error("WebshopService._loadUseECommerce", "GetMenuSettings", error);
    }
  }
  public useECommerce() {
    return this.use_eCommerce;
  }

  public getServiceLocation() {
    const me = this;
    return me.locationID;
  }

  //#region Available times

  public getOpenTimeService() {
    const me = this;
    return me.openTimeService;
  }

  public getLocationPickupTime() {
    const me = this;
    return me.serviceOpenTimeViewModels;
  }

  /** Loads the service mode for open days based on the current service mode.
   * open days for remote group ordering are always the same as for Delivery or Pickup.
  */
  private loadServiceModerForOpenDays(): number {
    const me = this;
    let serviceModeForOpenDays: number;
    if (me.serviceMode === WebShopMode.DeliveryGroup) {
      serviceModeForOpenDays = WebShopMode.Delivery;
    } else if (me.serviceMode === WebShopMode.PickupGroup) {
      serviceModeForOpenDays = WebShopMode.TakeAway;
    } else {
      serviceModeForOpenDays = me.serviceMode;
    }
    return serviceModeForOpenDays;
  }

  /**get opendays base on customer setting. this use to show next days to ordering */
  public async getOpenDays(): Promise<DDLViewModel[]> {
    const me = this;
    const serviceModeForOpenDays: number = me.loadServiceModerForOpenDays();
    const webshopSettings = await me.getWebshopSettingsDataModel();
    //pre order days configuration: 0 means that order is only possible for today
    const orderDayRange = webshopSettings.order_day_limit;
    const location = await me._locationService.GetWebshopLocationInfoViewModel(serviceModeForOpenDays, me.locationID);
    if (orderDayRange) {
      // ermitteln der Vorlaufzeit in Tagen
      let leadTimeDays = -1;
      if (me.serviceLeadTimeType === LeadTimeType.WorkDay) {
        leadTimeDays = me.serviceLeadTime;
      }
      const orderOpenDays: DDLViewModel[] = [];
      // festhalten des ersten tages
      let firstOrderOpenDay: { model: DDLViewModel, inLeadTime: boolean } = { model: null, inLeadTime: false };
      const currentDay = moment();
      const dicOpenDayTimeDE = CoreOpenDayTime["de"];
      const dicOpenDayTimeEN = CoreOpenDayTime["en"];
      const currentTimeYMD = Utils.GetYMDFromMoment(currentDay);
      const currentTimeHMS = Utils.GetHMSFromMoment(currentDay);
      let markYMD = location.model.GetTheoreticalOpenYMD(currentTimeYMD, currentTimeHMS, +serviceModeForOpenDays);
      for (let index = 0; index < orderDayRange; index++) {
        const openDay = location.model.GetOpenDayForYMD(markYMD, +serviceModeForOpenDays);
        if (leadTimeDays <= 0 || firstOrderOpenDay.model == null) {
          if (openDay && (openDay.open || firstOrderOpenDay.model == null)) { // always show first entry
            const orderOpenDay: DDLViewModel = new DDLViewModel();
            const weekdayName: string = Utils.EnumName(DayOfWeek, openDay.weekday);
            const phWeekdayNameDE: string = dicOpenDayTimeDE[`ph${weekdayName}Full`];
            const phWeekdayNameEN: string = dicOpenDayTimeEN[`ph${weekdayName}Full`];
            orderOpenDay.keyDE = `${phWeekdayNameDE}, ${currentDay.format('DD.MM.YYYY')}`;
            orderOpenDay.keyEN = `${phWeekdayNameEN}, ${currentDay.format('MM/DD/YYYY')}`;
            orderOpenDay.value = currentDay.toString();
            orderOpenDay.use_time = leadTimeDays == 0;
            if (firstOrderOpenDay.model == null || !firstOrderOpenDay.inLeadTime) {
              orderOpenDay.is_closed = !openDay.open;
              firstOrderOpenDay.model = orderOpenDay;
              firstOrderOpenDay.inLeadTime = leadTimeDays <= 0;
            }
            if (leadTimeDays <= 0 && openDay.open) {
              orderOpenDays.push(orderOpenDay);
            }
          }
        } // else überspringe den tag vor der Vorlaufzeit
        leadTimeDays -= (openDay && openDay.open) ? 1 : 0;
        markYMD = Utils.GetYMDFromMoment(Utils.GetMomentFromInt(markYMD).add(1, "day"));
        currentDay.add(1, "day");
      }
      // Leere Tabelle mit erstem Tag auffüllen
      if (orderOpenDays.length === 0 && firstOrderOpenDay.model) {
        orderOpenDays.push(firstOrderOpenDay.model);
      }
      return orderOpenDays;
    } else {
      return null;
    }
  }

  /**
   * Get available times for the selected day and filter by lead time, availability, and booking state
   * @param selectedServiceday  Selected day in string format
   * @param use_time  Whether to consider current time for lead time calculation (true for LeadTimeType.WorkDay)
   * @returns  Array of available times
   */
  public async getAvailableServiceTimes(selectedServiceday: string = "", use_time: boolean = false) {
    const me = this;
    const location = await me._locationService.GetWebshopLocationInfoViewModel(me.serviceMode, me.locationID);
    me.serviceOpenTimeViewModels = new Array();
    const serviceModeForOpenDays: number = me.loadServiceModerForOpenDays();
    const currentDay = moment();
    const currentTimeYMD = Utils.GetYMDFromMoment(currentDay);
    const currentTimeHMS = Utils.GetHMSFromMoment(currentDay);
    // Load location open YMD data
    const markYMD = location.model.GetTheoreticalOpenYMD(currentTimeYMD, currentTimeHMS, serviceModeForOpenDays);

    // Setup openTimeService and check if next day needs to be marked
    const isNextDay = me.setupOpenTimesAndCheckNextDay(location, selectedServiceday, currentDay, markYMD, serviceModeForOpenDays);

    // If no open times are available, add message and return empty list
    if (!me.openTimeService || me.openTimeService.length === 0) {
      me.addNoServiceAvailableMessage();
      return me.serviceOpenTimeViewModels;
    }
    // Calculate earliest possible time based on lead time
    const earliestPossibleTime = me.calculateEarliestPossibleTime(selectedServiceday, isNextDay, use_time);

    // Generate all time slots
    me.openTimeService.forEach((worktime, index) => {
      me.calculateServicePickuptimeViewModel(worktime, selectedServiceday, index);
    });

    // Filter by earliest time (except for OrderToTable)
    me.filterByEarliestTime(earliestPossibleTime);

    // Remove unavailable/ fully booked time slots
    await me.removeUnavailableTimeslots(location, selectedServiceday);

    // Add ASAP option or special service options
    if (me.serviceOpenTimeViewModels.length > 0) {
      await me.addSpecialServiceOptions(currentTimeHMS, isNextDay);
    } else {
      me.addNoServiceAvailableMessage();
    }

    return me.serviceOpenTimeViewModels;
  }


  /**
   * Loads open times for the selected day and checks if it's a future day
   * @param location Location data
   * @param selectedServiceday Selected order day
   * @param currentDay Current date
   * @param markYMD Theoretical opening day for today
   * @param serviceModeForOpenDays Service mode (Delivery/TakeAway/etc.)
   * @returns True if selectedServiceday is a future day, otherwise false
   */
  private setupOpenTimesAndCheckNextDay(location: LocationWebshopViewModel, selectedServiceday: string, currentDay: moment.Moment, markYMD: number, serviceModeForOpenDays: number): boolean {
    const me = this;
    if (!selectedServiceday) return false;
    const orderDay = moment(selectedServiceday);
    const orderTimeYMD = Utils.GetYMDFromMoment(orderDay);
    const orderTimeHMS = Utils.GetHMSFromMoment(orderDay);
    const markOrderYMD = location.model.GetTheoreticalOpenYMD(orderTimeYMD, orderTimeHMS, serviceModeForOpenDays);

    // Setup openTimeService
    const openDayForMarkYMD = location.model.GetOpenDayForYMD(markOrderYMD, serviceModeForOpenDays);
    me.openTimeService = (openDayForMarkYMD && openDayForMarkYMD.open) ? openDayForMarkYMD.times : [];

    // Return isNextDay
    return markOrderYMD !== markYMD ||
      (markOrderYMD === markYMD && currentDay.format("YYYY.MM.DD") !== orderDay.format("YYYY.MM.DD"));
  }

  /**
   * Adds a "no times available" message based on the service mode
   */
  private addNoServiceAvailableMessage(): void {
    const me = this;
    const messageKeyMap = {
      [WebShopMode.Delivery]: "phWebshop_NoDelivery_Time",
      [WebShopMode.TakeAway]: "phWebshop_NoPickup_Time",
      [WebShopMode.OrderToTable]: "phWebshop_NoInHause_Time"
    };

    const messageKey = messageKeyMap[me.serviceMode];
    if (messageKey) {
      me.serviceOpenTimeViewModels.push({
        display: me._coreLanguageService.value(messageKey),
        value: "",
        asap: false
      });
    }
  }

  /**
    * Calculates earliest possible service time based on selected order day and lead time
    * @param selectedServiceday Selected day
    * @param isNextDay Whether selectedServiceday is a future day
    * @param use_time True when day is calculated as LeadTimeType.WorkDay and current time should be considered
    * @returns Earliest possible order time
    */
  private calculateEarliestPossibleTime(selectedServiceday: string, isNextDay: boolean, use_time: boolean): moment.Moment {
    const me = this;
    let earliestPossibleTime = moment();

    if (selectedServiceday) {
      if (isNextDay && moment(selectedServiceday).format("YYYYMMDD") !== earliestPossibleTime.format("YYYYMMDD")) {
        earliestPossibleTime = me.getEarliestTimeForNextDay(selectedServiceday, use_time);
      } else {
        me.applyLeadTime(earliestPossibleTime);
      }
    } else {
      me.applyLeadTime(earliestPossibleTime);
    }

    return earliestPossibleTime;
  }

  /**
     * Calculates earliest time for next day: with use_time=true uses current time, otherwise restaurant opening time
     * @param selectedServiceday Day for which earliest time should be calculated
     * @param use_time True to use current time, false to use opening time
     * @returns Earliest possible order time for the next day
     */
  private getEarliestTimeForNextDay(selectedServiceday: string, use_time: boolean): moment.Moment {
    const me = this;
    if (use_time) {
      const earliestTimeYMD = Utils.GetYMDFromMoment(moment(selectedServiceday));
      const earliestTimeHMS = Utils.GetHMSFromMoment(moment());
      return Utils.GetMomentFromInt(earliestTimeYMD, earliestTimeHMS);
    } else {
      return moment(selectedServiceday)
        .hours((me.openTimeService[0].start_hms / 10000) % 100)
        .minutes((me.openTimeService[0].start_hms / 100) % 100)
        .seconds(me.openTimeService[0].start_hms % 100);
    }
  }

  /**
   * Applies lead time to the given time based on serviceLeadTimeType
   * @param time Time to which lead time should be added
   *  now + leadtime + buffer
   */
  private applyLeadTime(time: moment.Moment): void {
    const me = this;
    const buffer = 5; // 5 minutes buffer

    if (me.serviceLeadTimeType === LeadTimeType.Minute) {
      time.add(me.serviceLeadTime, "minutes");
    } else if (me.serviceLeadTimeType === LeadTimeType.WorkDay) {
      time.add(me.serviceLeadTime, "days");
    } else {
      me._coreLogService.error("WebshopService.applyLeadTime", "unknown serviceLeadTimeType", me.serviceLeadTimeType);
    }

    time.add(buffer, "minutes");
  }

  private filterByEarliestTime(earliestPossibleTime: moment.Moment): void {
    const me = this;

    if (me.serviceMode !== WebShopMode.OrderToTable) {
      me.serviceOpenTimeViewModels = me.serviceOpenTimeViewModels.filter(t =>
        moment(t.value).isSameOrAfter(earliestPossibleTime)
      );
    }
  }

  /**
   * Removes timeslots that have reached their order capacity
   * @param location Location data
   * @param selectedServiceday Selected service day
   */
  private async removeUnavailableTimeslots(location: any, selectedServiceday: string): Promise<void> {
    const me = this;
    if (!me.serviceOpenTimeViewModels || me.serviceOpenTimeViewModels.length === 0) {
      return;
    }
    const timeslotConfig = me.getTimeslotCheckConfig(location);
    if (timeslotConfig.orderType === orderTypes.allUnknown) {
      return;
    }
    try {
      const checkTimeslotData = await me._locationService.CheckTimeslotOrderAmount(
        location.model.hyp_cus_nr,
        timeslotConfig.orderType,
        timeslotConfig.timeslot_type
      );
      me.removeOpenTimeViewModelForTimeslotOrderAmount(selectedServiceday, checkTimeslotData.not_available_timeslots);
    } catch (error) {
      me._coreLogService.error(
        "WebshopService.removeUnavailableTimeslots",
        "CheckTimeslotOrderAmount failed",
        error
      );
    }
  }

  /**
   * Gets timeslot check configuration based on service mode
   * @param location Location data
   * @returns Order type and timeslot type configuration
   */
  private getTimeslotCheckConfig(location: LocationWebshopViewModel): { orderType: number, timeslot_type: number } {
    const me = this;
    let orderType = orderTypes.allUnknown;
    let timeslot_type = 0;

    switch (me.serviceMode) {
      case WebShopMode.Delivery:
        if (location.model.delivery_timeslot_type > 0) {
          orderType = orderTypes.delivery;
          timeslot_type = location.model.delivery_timeslot_type;
        }
        break;

      case WebShopMode.TakeAway:
        if (location.model.pickup_timeslot_type > 0) {
          orderType = orderTypes.pickup;
          timeslot_type = location.model.pickup_timeslot_type;
        }
        break;
    }

    return { orderType, timeslot_type };
  }

  /**
   * Adds special service options like ASAP or custom labels based on service mode
   * @param currentTimeHMS Current time in HMS format
   * @param isNextDay Whether the order is for a future day
   */
  private async addSpecialServiceOptions(currentTimeHMS: number, isNextDay: boolean): Promise<void> {
    const me = this;
    const firstTime = me.serviceOpenTimeViewModels[0];
    const isCurrentlyInTimeSlot = me.isCurrentlyInAnyTimeSlot(currentTimeHMS);
    const webshopSettings = await me.getWebshopSettingsDataModel();

    switch (me.serviceMode) {
      case WebShopMode.Delivery:
        if (webshopSettings.use_asap_delivery && isCurrentlyInTimeSlot && !isNextDay) {
          me.addAsapOption(firstTime);
        }
        break;

      case WebShopMode.TakeAway:
        if (webshopSettings.use_asap_pickup && isCurrentlyInTimeSlot && !isNextDay) {
          me.addAsapOption(firstTime);
        }
        break;

      case WebShopMode.OrderToTable:
        firstTime.display = me._coreLanguageService.value("phWebshop_InHause_Time");
        break;
    }
  }

  /**
   * Checks if current time is within any of the service time slots
   * @param currentTimeHMS Current time in HMS format
   * @returns True if currently in a time slot
   */
  private isCurrentlyInAnyTimeSlot(currentTimeHMS: number): boolean {
    const me = this;

    return me.openTimeService.some((timeslot) => {
      const afterStart = currentTimeHMS >= timeslot.start_hms;
      const beforeEnd = currentTimeHMS < timeslot.end_hms;
      const timeslotSpansMultipleDays = timeslot.start_hms > timeslot.end_hms;

      return (afterStart && beforeEnd) ||
        (timeslotSpansMultipleDays && (beforeEnd || afterStart));
    });
  }

  /**
   * Adds "As Soon As Possible" option to the beginning of available times
   * @param firstTime First available time slot
   */
  private addAsapOption(firstTime: ServiceOpenTimeViewModel): void {
    const me = this;
    const asapOption: ServiceOpenTimeViewModel = {
      display: me._coreLanguageService.value("phWebshop_AsSoonAsPossible"),
      value: firstTime.value,
      asap: true
    };
    me.serviceOpenTimeViewModels.unshift(asapOption);
  }

  /** Checks if the currently selected service time is still available (not fully booked) */
  public async isSelectedTimeSlotFullyBooked(): Promise<boolean> {
    const me = this;

    // Check if a time has been selected
    if (!me.serviceOrderTime) {
      return false; // No time selected - not fully booked
    }
    const selectedTime = me.serviceOrderTime;
    const selectedYMD = Utils.GetYMDFromMoment(selectedTime);
    const selectedHMS = Utils.GetHMSFromMoment(selectedTime);

    try {
      const location = await me._locationService.GetWebshopLocationInfoViewModel(me.serviceMode, me.locationID);
      // Get timeslot configuration
      const timeslotConfig = me.getTimeslotCheckConfig(location);
      // If no capacity restrictions for this service mode, time is available
      if (timeslotConfig.orderType === orderTypes.allUnknown) {
        return false; //  No capacity management: not fully booked
      }
      // Check availability from server
      const checkTimeslotData = await me._locationService.CheckTimeslotOrderAmount(
        location.model.hyp_cus_nr,
        timeslotConfig.orderType,
        timeslotConfig.timeslot_type
      );

      // Check if selected time is in the "not available" list
      if (checkTimeslotData.not_available_timeslots && checkTimeslotData.not_available_timeslots.length > 0) {
        const isFullyBooked = checkTimeslotData.not_available_timeslots.some(slot =>
          slot.ymd === selectedYMD && slot.hms === selectedHMS
        );
        return isFullyBooked;
      }
      return false; // time is available (not fully booked)

    } catch (error) {
      me._coreLogService.error(
        "WebshopService.isSelectedTimeSlotFullyBooked",
        "Failed to check timeslot availability",
        error
      );
      return false; // On error, assume available
    }
  }

  /** Entfernt Zeiträume, die im Zeitraum ihre Bestellmenge erreicht haben
   * @param selectedServiceday Bestellzeitpunkt YMD
   * @param timeslotNotAvailable Bestellzeitpunkt HMS
  */
  private removeOpenTimeViewModelForTimeslotOrderAmount(selectedServiceday: string, timeslotNotAvailable: Timeslot[]) {
    const me = this;
    if (timeslotNotAvailable && timeslotNotAvailable.length > 0) {
      const openTimeDay = selectedServiceday ? moment(selectedServiceday) : moment();
      const openTimeDayYMD = Utils.GetYMDFromMoment(openTimeDay);
      const openTimeDayHMS = Utils.GetHMSFromMoment(openTimeDay);
      for (let i = 0; i < timeslotNotAvailable.length; i++) {
        const timeslot = timeslotNotAvailable[i];
        if (timeslot.ymd == openTimeDayYMD && timeslot.hms >= openTimeDayHMS) {
          // behalte die serviceOpenTimeViewModels die nicht im timeslotNotAvailable sind
          me.serviceOpenTimeViewModels = me.serviceOpenTimeViewModels.filter(t => {
            const momentValue = moment(t.value);
            // ymd nicht berücksichtigen, da es für den aktuellen Tag gilt
            return Utils.GetHMSFromMoment(momentValue) !== timeslot.hms;
          });
        } // else timeslot not in openDay or in the past
      }
    }
  }

  private calculateServicePickuptimeViewModel(serviceTime: LocationOpenTime, selectedServiceday: string = "", startTimeIndex: number = 0) {
    const me = this;
    const now = moment();
    let cycletime: moment.Moment;
    let serviceStartTime: moment.Moment;
    let serviceEndTime: moment.Moment;
    if (selectedServiceday) {
      cycletime = moment(selectedServiceday);
      serviceStartTime = moment(selectedServiceday);
      serviceEndTime = moment(selectedServiceday);
    } else {
      cycletime = moment();
      serviceStartTime = moment();
      serviceEndTime = moment();
    }

    // cycletime startet mit voller Stunde, um Bestellmenge pro Zeiteinheit zu ermöglichen
    cycletime.hours((serviceTime.start_hms / 10000) % 100)
      .minutes(0).seconds(0);

    serviceStartTime.hours((serviceTime.start_hms / 10000) % 100)
      .minutes((serviceTime.start_hms / 100) % 100)
      .seconds(serviceTime.start_hms % 100);

    serviceEndTime.hours((serviceTime.end_hms / 10000) % 100)
      .minutes((serviceTime.end_hms / 100) % 100)
      .seconds(serviceTime.end_hms % 100);

    if (serviceEndTime.isBefore(serviceStartTime)) {
      serviceEndTime.add(1, "days");
    }

    if (me.serviceMode === WebShopMode.OrderToTable) {
      if (now.isAfter(serviceStartTime) && now.isBefore(serviceEndTime)) {
        const serviceOpenTimeViewModel = new ServiceOpenTimeViewModel();
        serviceOpenTimeViewModel.display = DateManager.MomentDateTimeFormatter(now, false, true);
        serviceOpenTimeViewModel.value = now.seconds(0).toString();
        serviceOpenTimeViewModel.asap = false;
        me.serviceOpenTimeViewModels.push(serviceOpenTimeViewModel);
      }
    } else {
      let timeSteps = me.serviceCycletime;
      if (timeSteps < 1) {
        me._coreLogService.error("WebshopService.calculateServicePickuptimeViewModel", "serviceCycletime is wrong", me.serviceCycletime)
        timeSteps = 15; // 15 statt 0 damit es nicht in einer endlosschleife endet
      }
      while (cycletime.isBefore(serviceEndTime)
        || cycletime.format("HH:mm") === serviceEndTime.format("HH:mm")) {
        if (now.isBefore(cycletime) && cycletime.isSameOrAfter(serviceStartTime)) {
          const serviceOpenTimeViewModel = new ServiceOpenTimeViewModel();
          serviceOpenTimeViewModel.display = DateManager.MomentDateTimeFormatter(cycletime, false, true);
          serviceOpenTimeViewModel.value = cycletime.seconds(0).toString();
          serviceOpenTimeViewModel.asap = false;
          me.serviceOpenTimeViewModels.push(serviceOpenTimeViewModel);
        }
        cycletime.add(timeSteps, "minutes");
      }
    }
  }

  // endregion Available times

  /**
   * get a list of basketItems
   */
  public getShippingCartItems(): BasketItemViewModel[] {
    return this.shippingCartItems;
  }

  /** zum performantem durchlauf das alter speichern */
  private _confirmedAge: number = -1;
  /**
   * Performs an age check before adding an item to the shipping cart.
   * If the age check fails, the item will not be added.
   *
   * @param locationId - Location ID
   * @param productId - Product ID
   * @param config - Optional product configuration
   * @returns Promise<boolean> - true if the item was added (age verified or not required), false otherwise
   */
  public addItemToShippingCartAndCheckAge(locationId: number, productId: number, config: ProductConfiguration = {}): Promise<boolean> {
    const me = this;
    return new Promise<boolean>(async (resolve, reject) => {
      try {
        const ageConfirmed = await me.executeWithAgeCheck(locationId, productId);
        if (!ageConfirmed) {
          resolve(false);
          return;
        }
        await me.addItemToShippingCart(locationId, productId, config);
        resolve(true);
      } catch (error) {
        me._coreLogService.error("webShopService.CheckAgeConfirmation", "catch", error);
        reject(error);
      }
    });
  }

  // todo es muss optimiert werden wie die ids ermittelt werden
  public async getProductFromPOSProductID(location: number, pos_product_id: number): Promise<ProductDataModel4> {
    const me = this;
    const productModel = await me._productService.GetProductsByFilter(location, me.sortiment, (product) => product.product_id === pos_product_id)
    if (!productModel || productModel.length !== 1) {
      return Promise.reject(new Error("Could not find Product " + pos_product_id));
    }
    return productModel[0];
  }

  // todo es muss optimiert werden wie die ids ermittelt werden
  public async getProductExtraFromPOSProductID(product_details: ProductDetailsDataModel3, extra_pos_product_id: number, extra_pos_rez_id: number): Promise<ProductExtraDataModel3> {
    const extra = product_details.extras.find((extra) => extra.product_id === extra_pos_product_id && extra.rez_id === extra_pos_rez_id);
    if (!extra) {
      return Promise.reject(new Error("Could not find Extra " + extra_pos_product_id));
    }
    return extra;
  }

  public async addWebvoucherToShippingCart(webvoucher: WebvoucherDataModel, config: WebvoucherConfiguration = {}) {
    const me = this;
    const basketItem = await me.getWebVoucherCustomAsBasketItemViewModel(webvoucher, config);
    await me.addBasketItemToShippingCart(basketItem, false); // webgutscheine werden nicht an den YAS mitgeteilt
  }

  /** erstellt ein BasketItemViewModel aus den Vorgaben */
  private async getWebVoucherCustomAsBasketItemViewModel(webvoucher: WebvoucherDataModel, config: WebvoucherConfiguration): Promise<BasketItemViewModel> {
    const me = this;
    await me.initializeService();
    const model = new BasketItemViewModel();
    if (config.id) {
      model.id = config.id;
    } else {
      model.id = null; // null um die id beim einsetzen zu füllen
    }
    // product_id wird aus webvoucher.id generiert um später Webgutscheine und Artikel mischen zu können
    model.product_id = -(webvoucher.id + 10000); // todo -10000 muss zum enum für webgutscheine werden
    model.webvoucher_id = webvoucher.id;
    model.pos_product_id = 0;
    model.labelDE = webvoucher.label_de;
    model.labelEN = webvoucher.label_en;
    model.usingtype = webvoucher.is_free_amount ? UsingType.VariableWebvoucher : UsingType.Webvoucher;
    model.noDiscount = true; // kein Rabatt
    model.minDiscountPrice = 0;
    // no model.servicePe
    // no model.userPe
    model.wgrGroupId = 0; // keine Warengruppen empfehlung
    // no model.menucourse = 0;
    // no model.default_menucourse
    model.valid_date = 0;
    model.comment = config.comment || "";

    model.count = config.count || 1;
    const personCount = config.personCount || 1;
    model.show_person_count = config.show_person_count && !webvoucher.is_free_amount || false;
    model.person_count = personCount;
    model.show_delivery_type = config.show_delivery || false;
    model.delivery_type = config.postDelivery ? deliveryTypes.post : deliveryTypes.download;

    const fallbackPrice = new BasketItemPriceViewModel();
    fallbackPrice.price = Utils.moneyRound(Utils.centsToCurrency(webvoucher.fix_amount_value * personCount));
    fallbackPrice.priceWithDefaultExtras = fallbackPrice.price;
    fallbackPrice.deposit = 0;
    fallbackPrice.vat = 0;
    model.fallbackPrices = fallbackPrice;
    // no model.pePrices[model.servicePe] = model.fallbackPrices;

    if (model.usingtype === UsingType.VariableWebvoucher) {
      if (config.variable_price != null) {
        model.variable_price = Utils.moneyRound(config.variable_price);
      } else {
        throw new Error("A Variable Webvoucher needs a variable_price defined");
      }
    }

    me.calcBasketItemPrices(model);
    return model;
  }

  /**
   * Adds a product
   * Achtung!, diese Funktion muss synchrone ausgeführt werden, wenn mehere items eingefügt werden
   * @param ID id of the product
   * @param config configuration of the product
   * @param syncToYAS: string; // if the change should be uploaded to the YAServer, if it is used.
   */
  private async addItemToShippingCart(location: number, ID: number, config: ProductConfiguration = {}, syncToYAS: boolean = true) {
    const me = this;
    const basketItem = await me.getBasketItemViewModel(location, ID, config);
    await me.addBasketItemToShippingCart(basketItem, syncToYAS);
  }

  /** Adds a basketitem
   * Achtung!, diese Funktion muss synchrone ausgeführt werden, wenn mehere items eingefügt werden
  */
  private async addBasketItemToShippingCart(product: BasketItemViewModel, syncToYAS: boolean = true) {
    const me = this;
    let productWithSameId = null;
    if (product.id !== null) {
      productWithSameId = me.shippingCartItems.find(item => item.id === product.id);
    }
    if (productWithSameId) {
      const updateSuccess = !syncToYAS || await me.updateYASItem(product);
      if (updateSuccess) {
        // Replaceprodukt with same ID
        productWithSameId = product;
        if (me.serviceMode !== me.WebShopMode.Webvoucher && me.serviceMode !== me.WebShopMode.Viewing) {
          await me.setRecommendationList();
        }
      } else {
        // no change if update fails
        me._coreLogService.error("WebshopService.addBasketItemToShippingCart", "replace > update not success", product);
        me._snackBarService.ShowErrorMessageFailed(115);
      }
    } else {
      // Check if a product with the same configuration already exists
      const identicalProduct = me.shippingCartItems.find((p) => me.areBasketItemsIdentical(p, product));

      if (identicalProduct) {
        let nextProduct = Utils.GetCopy(identicalProduct);
        nextProduct.count += product.count;
        const updateSuccess = !syncToYAS || await me.updateYASItem(nextProduct);
        if (updateSuccess) {
          identicalProduct.count = nextProduct.count;
        } else {
          // no change if update fails
          me._coreLogService.error("WebshopService.addBasketItemToShippingCart", "update > update not success", nextProduct);
          me._snackBarService.ShowErrorMessageFailed(116);
        }
      } else {
        // hier wird die nächste Position im warenkorb bestimmt, darum muss es synchrone ausgeführt werden, wenn mehrere Items eingefügt werden
        if (product.id === null) {
          product.id = me.shippingCartItems.reduce((a, b) => a > b.id ? a : b.id, 0) + 1;
        }
        const updateSuccess = !syncToYAS || await me.updateYASItem(product);
        if (updateSuccess) {
          me.shippingCartItems.push(product);
          if (me.serviceMode !== me.WebShopMode.Webvoucher && me.serviceMode !== me.WebShopMode.Viewing) {
            await me.setRecommendationList();
          }
        } else {
          // no change if update fails
          me._coreLogService.error("WebshopService.addBasketItemToShippingCart", "push > update not success", product);
          me._snackBarService.ShowErrorMessageFailed(117);
        }
      }
    }

    await me.calculateDeliveryCost();
    me.calculateTrinkGeld();
  }

  /** Checks if two basket items are identical and can be merged */
  private areBasketItemsIdentical(existingItem: BasketItemViewModel, newItem: BasketItemViewModel): boolean {
    if (existingItem.product_id !== newItem.product_id) { return false; }
    if (existingItem.variable_price !== newItem.variable_price) { return false; }
    if (existingItem.valid_date !== newItem.valid_date) { return false; }
    if (existingItem.person_count !== newItem.person_count) { return false; }
    if (existingItem.delivery_type !== newItem.delivery_type) { return false; }
    // Check if benefit status matches (benefit items can only be merged with other benefit items)
    if (existingItem.bonusactionId !== newItem.bonusactionId) { return false; }
    if (existingItem.benefitId !== newItem.benefitId) { return false; }
    if (existingItem.benefitLossId !== newItem.benefitLossId) { return false; }
    if (normalizeComment(existingItem.comment) !== normalizeComment(newItem.comment)) { return false; }
    if (existingItem.coupon_id !== newItem.coupon_id) { return false; }
    if (existingItem.coupon_code !== newItem.coupon_code) { return false; }
    if (existingItem.redemption_id !== newItem.redemption_id) { return false; }
    // Check if Extras are the same
    const areExtrasEqual = (existingItem.product_extras.length === newItem.product_extras.length
      && newItem.product_extras.every((extra) =>
      (existingItem.product_extras.some((e) =>
      (extra.product_extra_id === e.product_extra_id && extra
        && extra.count === e.count)))));
    return areExtrasEqual;
  }

  /** erstellt ein BasketItemViewModel aus den Vorgaben */
  private async getBasketItemViewModel(location: number, ID: number, config: ProductConfiguration = {}): Promise<BasketItemViewModel> {
    const me = this;
    await me.initializeService();
    const productModel = await me._productService.GetProduct(location, me.sortiment, ID);
    if (!productModel) {
      return Promise.reject(new Error("Could not find Product"));
    }
    return await me.mapProductConfigurationToBasketItemViewModel(productModel, config);
  }

  //#region InHouse Group

  /**Adding an item to the user basket for direct ordering (Yas Basket)*/
  public async addItemToIHUserBasket(locationId: number, productId: number, config: ProductConfiguration = {}): Promise<boolean> {
    const me = this;
    try {
      const ageConfirmed = await me.executeWithAgeCheck(locationId, productId);
      if (!ageConfirmed) {
        return false;
      }
      await me.addItemToIHUserBasketOnly(locationId, productId, config);
      return true;
    } catch (error) {
      me._coreLogService.error("WebshopService.addItemToIHUserBasket", "catch", error);
      throw error;
    }
  }

  private async addItemToIHUserBasketOnly(locationId: number, productId: number, config: ProductConfiguration = {}): Promise<void> {
    const me = this;
    const newProduct = await me.getBasketItemViewModel(locationId, productId, config);
    const table = await me._objObsInjectHelper.inHouseOrderService.GetTable(TableData.MyBasked);
    const currentUserToken = me._objObsInjectHelper.inHouseOrderService.UserToken;
    const userBasketItems = table.yasTable.user_basket_items.filter(
      (item) => item.user_token === currentUserToken
    );
    const currentUserItems = await Promise.all(
      userBasketItems.map(async (item) =>
        await me.mapYASBasketItemToBasketItemViewModel(item)
      )
    );
    const identicalProduct = me.findIdenticalProduct(currentUserItems, newProduct, true);
    let basketItemToSend: BasketItemViewModel;
    if (identicalProduct) {
      basketItemToSend = me.mergeIdenticalProducts(identicalProduct, newProduct);
    } else {
      if (newProduct.id === null || newProduct.id === 0) {
        newProduct.id = currentUserItems.reduce((a, b) => a > b.id ? a : b.id, 0) + 1;
      }
      basketItemToSend = newProduct;
    }
    await me.sendToYASUserBasket(basketItemToSend);
  }

  private async sendToYASUserBasket(basketItem: BasketItemViewModel): Promise<void> {
    const me = this;
    const basketItemData = me.mapBasketItemViewModelToChangeBasketItem(basketItem);
    const request: req_ChangeBasket = {
      change_type: BasketChangeType.Diff,
      return_items: false,
      items: [basketItemData]
    };
    try {
      const response = await me._objObsInjectHelper.inHouseOrderService.ChangeBasket(request);
      if (response.status !== ChangeBasketStatus.Okay) {
        me._coreLogService.error("WebshopService.sendToYASUserBasket", "ChangeBasketStatus not Okay", response.status);
      }
    } catch (error) {
      me._coreLogService.error("WebshopService.sendToYASUserBasket", "ChangeBasket catch", error);
    }
  }

  /**
* Performs an age check before adding an item to the group basket.
* If the age check fails, the item will not be added.
*
* @param locationId - Location ID
* @param productId - Product ID
* @param config - Optional product configuration
* @returns Promise<boolean> - true if the item was added (age verified or not required), false otherwise
*/
  public async addItemToIHGroupBasketAndCheckAge(locationId: number, productId: number, config: ProductConfiguration = {}): Promise<boolean> {
    const me = this;
    try {
      const ageConfirmed = await me.executeWithAgeCheck(locationId, productId);
      if (!ageConfirmed) {
        return false;
      }
      await me.addItemToIHGroupBasket(locationId, productId, config);
      return true;
    } catch (error) {
      me._coreLogService.error("WebshopService.addItemToGroupBasketAndCheckAge", "catch", error);
      throw error;
    }
  }

  private async getCurrentUserIHGroupBasketItems(): Promise<BasketItemViewModel[]> {
    const me = this;
    const currentUserToken = me._objObsInjectHelper.inHouseOrderService.UserToken;
    const table = await me._objObsInjectHelper.inHouseOrderService.GetTable(TableData.GroupBasked);
    const myGroupBasketItems = table.yasTable.group_basket_items.filter(
      (item) => item.user_token === currentUserToken
    );
    return await Promise.all(
      myGroupBasketItems.map(async (item) =>
        await me.mapYASBasketItemToBasketItemViewModel(item)
      )
    );
  }

  private async addItemToIHGroupBasket(locationId: number, productId: number, config: ProductConfiguration = {}): Promise<void> {
    const me = this;
    const newProduct = await me.getBasketItemViewModel(locationId, productId, config);
    const currentUserItems = await me.getCurrentUserIHGroupBasketItems();
    const identicalProduct = me.findIdenticalProduct(currentUserItems, newProduct, true);
    let basketItemToSend: BasketItemViewModel;
    if (identicalProduct) {
      basketItemToSend = me.mergeIdenticalProducts(identicalProduct, newProduct);
    } else {
      if (newProduct.id === null || newProduct.id === 0) {
        newProduct.id = currentUserItems.reduce((a, b) => a > b.id ? a : b.id, 0) + 1;
      }
      basketItemToSend = newProduct;
    }
    await me.sendToYASGroupBasket(basketItemToSend);
  }

  private async sendToYASGroupBasket(basketItem: BasketItemViewModel): Promise<void> {
    const me = this;
    const basketItemData = me.mapBasketItemViewModelToChangeBasketItem(basketItem);
    const request: req_ChangeGroupBasket = {
      change_type: ChangeGroupBasketChangeType.Diff,
      return_items: false,
      items: [basketItemData]
    };
    try {
      const response = await me._objObsInjectHelper.inHouseOrderService.ChangeGroupBasket(request);
      if (response.status !== ChangeGroupBasketStatus.Okay) {
        me._coreLogService.error("WebshopService.sendToYASGroupBasket", "ChangeGroupBasketStatus not Okay", response.status);
      }
    } catch (error) {
      me._coreLogService.error("WebshopService.sendToYASGroupBasket", "ChangeGroupBasket catch", error);
    }
  }

  //#endregion InHouse Group

  /** fürgt ein InHouse YAS Item in den Warenkorb
   * Achtung!, diese Funktion muss synchrone ausgeführt werden, wenn mehere items eingefügt werden
  */
  private async addYASBasketItemToShippingcart(item: BasketItem): Promise<void> {
    const me = this;
    const basketItem = await me.mapYASBasketItemToBasketItemViewModel(item);
    await me.addBasketItemToShippingCart(basketItem, false);
    // ? Full sync back incase Prices changed?
  }

  public async syncYASServerBasketToLocal() {
    const me = this;
    try {
      // todo doko wenn tabele nicht da ist was zu tun?
      const table = await me._objObsInjectHelper.inHouseOrderService.GetTable(TableData.MyBasked); // force abruf des Tisches
      me.shippingCartItems = [];
      for (const item of table.yasTable.user_basket_items) {
        await me.addYASBasketItemToShippingcart(item);
      }
      me._shippingCartSubject.next(me.shippingCartItems);
    } catch (error) {
      me._coreLogService.error("WebshopService.syncYASServerBasketToLocal", "catch", error);
      //!Mark temporary SnackbarMessage should not be displayed
      // me._snackBarService.ShowMessage(snackBarMessageKey.failed, SnackBarMessageType.Error);
      // TODO empty upsync? Try again later?
    }
  }

  public async mapYASBasketItemToBasketItemViewModel(item: BasketItem): Promise<BasketItemViewModel> {
    const me = this;
    const product = await me.getProductFromPOSProductID(me.locationID, item.product_id);
    const extras: ProductConfigurationExtra[] = [];
    if (item.extras && item.extras.length > 0) {
      const productDetails = await ProductDetailsHelperService.GetProductDetails(product, me._objObsInjectHelper, true, false);
      if (!productDetails) {
        return Promise.reject(new Error("Could not find ProductDetails " + product.id));
      }
      for (const item_extra of item.extras) {
        const extra = await me.getProductExtraFromPOSProductID(productDetails, item_extra.product_id, item_extra.linked);
        extras.push({ id: extra.id, count: item_extra.amount });
      }
    }
    const config: ProductConfiguration = {
      id: item.position,
      count: item.amount,
      comment: item.freetext,
      menu_course: item.menu_course,
      valid_date: item.validDate_YMD,
      extras: extras
    };

    return await me.getBasketItemViewModel(me.locationID, product.id, config);
  }

  public mapBasketItemViewModelToChangeBasketItem(item: BasketItemViewModel): BasketItem {
    return {
      user_token: this._objObsInjectHelper.inHouseOrderService.UserToken,
      place_number: this._objObsInjectHelper.inHouseOrderService.UiData.place_no,
      ihah: "IH", // momentan nur InHouse
      position: item.id,
      product_id: item.pos_product_id,
      name_de: item.labelDE,
      name_en: item.labelEN,
      freetext: item.comment,
      amount: item.count,
      menu_course: item.menucourse,
      orgprice: Math.round(item.basePrice * 100),  // *100 > cents // TODO Pfand dazu?
      price: Math.round(item.price * 100), // *100 > cents
      pe: item.servicePe, // TODO get used PE User vs Service
      discount: Math.round(this.discountPercent * 100),
      vat: Math.round(item.vatPercent * 100),
      usingType: item.usingtype,
      validDate_YMD: item.valid_date,
      extras: item.product_extras.map((extra) => this.mapBasketItemExtraViewModelToChangeBasketItemExtra(extra)),
      book_info: "", // momentan nicht genutzt
    };
  }

  public mapBasketItemExtraViewModelToChangeBasketItemExtra(extra: BasketItemExtraViewModel): BasketItemExtra {
    return {
      amount: extra.count,
      name_de: extra.titleDE,
      name_en: extra.titleEN,
      price: 0, // TODO momentan existiert diese Info nicht im ViewModel
      product_id: extra.pos_product_id,
      linked: extra.pos_rez_id,
    };
  }

  /**
   * Berechnet die Lieferkosten aus den Artikeln im Warenkorb
   */
  private async calculateDeliveryCost(): Promise<void> {
    const me = this;
    if (me.serviceMode == WebShopMode.Webvoucher) {
      // wenn Gutscheine per Post versendet werden, werden versandkosten berechnet
      const postItem = me.shippingCartItems.find(item => item.delivery_type == deliveryTypes.post);
      if (postItem && postItem.count > 0) {
        const webshopSettings = await me.getWebshopSettingsDataModel();
        me._deliveryFee = me.calculateDeliveryFee(Utils.centsToCurrency(webshopSettings.webvoucher.delivery_price));
      } else {
        me._deliveryFee = 0;
      }
    }

    if (me.serviceMode == WebShopMode.Delivery) {
      me._deliveryFee = me.calculateDeliveryFee(me._deliveryFee);
    }
  }

  private calculateFreeShippingThreshold(defaultValue: number): number {
    return this.usePolyMapForDeliveryFee() ? -1 /* Polymap hat keine freie Lieferkosten */ : defaultValue;
  }

  private calculateDeliveryFee(fallback: number) {
    return this.usePolyMapForDeliveryFee() ? this.calculatePolygonMapDeliveryFee(fallback) : fallback;
  }

  private calculatePolygonMapDeliveryFee(fallback: number): number {
    const basketSum = this.getBasketSumDiscounted();

    let fee = -1;
    if (this.PolygonMapInformation && this.PolygonMapInformation.DeliveryFees) {
      this.PolygonMapInformation.DeliveryFees.forEach(deliveryFee => {
        if (basketSum >= deliveryFee.ShoppingCartValue) {
          fee = deliveryFee.Amount;
        }
      });
    }

    return fee >= 0 ? fee : fallback;
  }

  private calculateMinimumOrderValue(fallback: number): number {
    if (this.usePolyMapForDeliveryFee() && this.PolygonMapInformation && this.PolygonMapInformation.DeliveryFees) {
      const deliveryFee = this.PolygonMapInformation.DeliveryFees.reduce((r, e) => r.ShoppingCartValue < e.ShoppingCartValue ? r : e);
      return deliveryFee ? deliveryFee.ShoppingCartValue : fallback;
    }
    return fallback;
  }

  private validateUseFreeShipping(fallback: boolean): boolean {
    if (this.usePolyMapForDeliveryFee()) {
      return false; // Polymap hat keine freie Lieferkosten
    }
    return fallback;
  }

  private usePolyMapForDeliveryFee(): boolean {
    const me = this;
    const deliveryFeesAreValid = me.PolygonMapInformation && me.PolygonMapInformation.DeliveryFees && me.PolygonMapInformation.DeliveryFees.length > 0;
    const coordinatesAreValid = me.PolygonMapInformation && me.PolygonMapInformation.Coordinates && me.PolygonMapInformation.Coordinates.Latitude > 0 && me.PolygonMapInformation.Coordinates.Longitude > 0;
    return me.serviceMode == WebShopMode.Delivery && deliveryFeesAreValid && coordinatesAreValid;
  }

  /**
   * calculate tips base on products and tip percentage
   */
  private calculateTrinkGeld(): void {
    const me = this;
    if (me.isTippingEnabled()) {
      const sumPrice = me.shippingCartItems.map(b => b.price * b.count).reduce((a, b) => a + b, 0);
      if (sumPrice > 0) { // Avoid changing Trinkgeld when there is no value
        if (me.trinkgeldInputMethod === TrinkgeldInputMethod.Percentage) {
          me._trinkgeldValue = +((sumPrice / 100 * me._trinkgeldPercentage).toFixed(1));
        } else {
          me._trinkgeldPercentage = Math.round(me._trinkgeldValue / sumPrice * 100);
        }
      }
    } else {
      me._trinkgeldValue = 0;
      me._trinkgeldPercentage = 0;
    }
    me._shippingCartSubject.next(me.shippingCartItems);
  }

  /** Aktualisiert das Item (wichtig für den YAS Warenkorb) */
  public async updateYASItem(basketItem: BasketItemViewModel): Promise<boolean> {
    const me = this;
    if (me.ordertype.useYASBasket) {
      const request: req_ChangeBasket = {
        change_type: BasketChangeType.Diff,
        return_items: false,
        items: [me.mapBasketItemViewModelToChangeBasketItem(basketItem)]
      };
      try {
        const response = await me._objObsInjectHelper.inHouseOrderService.ChangeBasket(request)
        if (response.status !== ChangeBasketStatus.Okay) {
          // todo notify user ?
          me._coreLogService.error("WebshopService.updateYASItem", "ChangeBasketStatus status not Okay", response.status);
          await me.syncYASServerBasketToLocal();
          return false;
        } else {
          return true;
        }
      } catch (error) {
        me._coreLogService.error("WebshopService.updateYASItem", "inHouseOrderService.ChangeBasket catch", error);
        me._objObsInjectHelper.inHouseOrderService.leaveTable(true);
        return false;
      }
    } // else no sync is needed
    return true;
  }

  /** Unterstützung momentan zum resynchronisieren der Artikel, um Rabatt zu ermöglichen */
  public async refreshYASUserBasket(): Promise<boolean> {
    const me = this;
    if (me.ordertype.useYASBasket) {
      const request: req_ChangeBasket = {
        change_type: BasketChangeType.Full,
        return_items: false,
        items: []
      };
      for (const basketItem of me.shippingCartItems) {
        request.items.push(me.mapBasketItemViewModelToChangeBasketItem(basketItem));
      }
      try {
        const response = await me._objObsInjectHelper.inHouseOrderService.ChangeBasket(request)
        if (response.status === ChangeBasketStatus.Okay) {
          return true;
        } else {
          me._coreLogService.error("WebshopService.refreshYASUserBasket", "ChangeBasketStatus status not Okay", response.status);
          return false;
        }
      } catch (error) {
        me._coreLogService.error("WebshopService.refreshYASUserBasket", "inHouseOrderService.ChangeBasket catch", error);
        return false;
      }
    } else {
      me._coreLogService.error("WebshopService.refreshYASUserBasket", "use yas basket not possible");
      return false;
    }
  }

  /**increase item count */
  public async addCountItem(basketItem: BasketItemViewModel): Promise<void> {
    const me = this;
    let updateSuccess = true;
    const nextCount = (basketItem.count + 1);
    if (me.ordertype.useYASBasket) {
      let nextItem = Utils.GetCopy(basketItem);
      nextItem.count = nextCount;
      updateSuccess = await me.updateYASItem(nextItem);
    }

    if (updateSuccess) {
      basketItem.count = nextCount;
      await me.calculateDeliveryCost();
      me.calculateTrinkGeld();
      me.trackAddToCart(basketItem);
    } else {
      me._coreLogService.error("WebshopService.addCountItem", "update not success", basketItem);
      me._snackBarService.ShowErrorMessageFailed(118);
    }
  }

  /**decreas item count; remove item when there is just one in basket */
  public async removeCountItem(basketItem: BasketItemViewModel): Promise<void> {
    const me = this;
    let updateSuccess = true;
    const nextCount = Math.max(0, (basketItem.count - 1));
    if (me.ordertype.useYASBasket) {
      let nextItem = Utils.GetCopy(basketItem);
      nextItem.count = nextCount;
      updateSuccess = await me.updateYASItem(nextItem);
    }

    if (updateSuccess) {
      basketItem.count = nextCount;
      if (basketItem.count === 0) {
        // remove item with count 0
        me.shippingCartItems = me.shippingCartItems.filter((b) => b !== basketItem);
        me.notifyCouponRemovedFromCart(basketItem);
      }
      await me.calculateDeliveryCost();
      me.calculateTrinkGeld();
    } else {
      me._coreLogService.error("WebshopService.removeCountItem", "update not success", basketItem);
      me._snackBarService.ShowErrorMessageFailed(119);
    }
  }

  /**Remove scheduled items if they are outside the order time*/
  public async removeScheduledItems(basketItem: BasketItemViewModel): Promise<void> {
    const me = this;
    let updateSuccess = true;
    const nextCount = Math.max(0, (basketItem.count - basketItem.count));
    if (updateSuccess) {
      basketItem.count = nextCount;
      if (basketItem.count === 0) {
        // remove item with count 0
        me.shippingCartItems = me.shippingCartItems.filter((b) => b !== basketItem);
        me.notifyCouponRemovedFromCart(basketItem);
      }
      await me.calculateDeliveryCost();
      me.calculateTrinkGeld();
      me._shippingCartSubject.next(me.shippingCartItems);
    } else {
      me._coreLogService.error("WebshopService.removeCountItem", "update not success", basketItem);
      me._snackBarService.ShowErrorMessageFailed(120);
    }
  }

  private _couponRemovedFromCart$ = new Subject<number>();

  /** Reports the redemption_id of every coupon removed from the cart. */
  public get couponRemovedFromCart$(): Observable<number> {
    return this._couponRemovedFromCart$.asObservable();
  }

  private notifyCouponRemovedFromCart(basketItem: BasketItemViewModel): void {
    const me = this;
    if (basketItem.coupon_id && basketItem.redemption_id) {
      me._couponRemovedFromCart$.next(basketItem.redemption_id);
    }
  }

  /** Frees all coupons in the cart before it is reset, e.g. on a location change. Not used after an order. */
  private releaseCouponReservationsOnReset(): void {
    const me = this;
    me.shippingCartItems.forEach(item => me.notifyCouponRemovedFromCart(item));
  }

  public setTrinkgeldPercentage(trinkgeldPercentage: number) {
    const me = this;
    if (trinkgeldPercentage >= 0) {
      me.trinkgeldInputMethod = TrinkgeldInputMethod.Percentage;
      me._trinkgeldPercentage = trinkgeldPercentage;
      me.calculateTrinkGeld();
    }
    else {
      console.log("Invalid value for tip percentage. The value must be greater than or equal to zero.");
    }
  }

  public setTrinkgeldAmount(trinkgeldValue: number) {
    const me = this;
    if (trinkgeldValue >= 0) {
      me.trinkgeldInputMethod = TrinkgeldInputMethod.Fixed;
      me._trinkgeldValue = trinkgeldValue;
      me.calculateTrinkGeld();
    }
    else {
      console.log("Invalid value for tip amount. The value must be greater than or equal to zero.");
    }
  }

  /** Achtung ist nur für InHouse, da es nicht den warenkorb im webshop service nutzt */
  public setFixTrinkgeldAmount(trinkgeldValue: number) {
    const me = this;
    me.trinkgeldInputMethod = TrinkgeldInputMethod.Fixed;
    me._trinkgeldValue = trinkgeldValue;
    // no calculation for ih
  }

  /**
   * Empties the Basket
   */
  public clearItems() {
    const me = this;
    me.shippingCartItems = [];
    me._shippingCartSubject.next(me.shippingCartItems);
  }

  public recalcDiscountPricesInBasket(discountPercent: number) {
    const me = this;
    if (me.shippingCartItems) {
      me.shippingCartItems.forEach((item) => {
        me.setBasketItemDiscount(item, discountPercent);
      });
      me._shippingCartSubject.next(me.shippingCartItems);
    }
  }

  public recalcServicePeInBasket(): boolean {
    const me = this;
    var changed = false;
    if (me.shippingCartItems) {
      me.shippingCartItems.forEach((item) => {
        const peBefore = item.servicePe;
        me.calcBasketItemPrices(item);
        if (peBefore != item.servicePe) { changed = true; }
      });
      me._shippingCartSubject.next(me.shippingCartItems);
    }
    return changed;
  }

  public async getProductPrices(product: ProductDataModel4, withExtras: boolean = true, productDetails: ProductDetailsDataModel3 = null): Promise<ProductPricesModel> {
    const me = this;
    // bei extras müssen die Produkt details übergeben werden
    if (withExtras && !productDetails) {
      productDetails = await ProductDetailsHelperService.GetProductDetails(product, me._objObsInjectHelper, true, false);
    }
    await me.handleEventPE();

    const prices = ProductDetailsHelper.calculateProductPrices(product,
      me.isServiceAusserHaus(),
      ProductDetailsHelper.calculateBestPricelevel(product, me.servicePe, me.userPe),
      me.discountPercent,
      withExtras,
      productDetails,
      me._coreLogService);
    return prices;
  }

  private async getEventPE(): Promise<IEvent> {
    const me = this;
    const orderType = me.mapWebShopModeToOrderType(me.serviceMode);
    let filteredEvents: IEvent[];
    filteredEvents = me._eventManagerService.filterEventsByOrderTypeAndLocation(me._webshopSettingsDataModel.events, orderType, me.locationID, false);
    if (filteredEvents.length > 0) {
      let timeForEventCheck: Moment;
      const now = moment();
      // event check time
      if (orderType === orderTypes.inHouse) {
        // InHouse : time now
        timeForEventCheck = now;
      } else if (me.isTimeRequired) {
        // Takeaway/Delivery serviceOrderTime
        if (!me._serviceOrderTime) {
          // cached serviceOrderTime
          await me.restoreAndSetServiceTimeFromCache();
        }
        timeForEventCheck = me._serviceOrderTime || now; // fallback now
      } else {
        // fallback time now
        timeForEventCheck = now;
      }
      const activeEvent = me._eventManagerService.filterActiveEventForMoment(
        filteredEvents,
        timeForEventCheck,
        me._webshopSettingsDataModel.holidays
      );

      if (!Utils.IsNull(activeEvent)) {
        return activeEvent;
      }
    }

    return null;
  }

  public async handleEventPE(): Promise<void> {
    const me = this;
    const event: IEvent = await this.getEventPE();
    if (!Utils.IsNull(event)) {
      me.currentEventID = event.id;
      if (me.servicePe !== event.pricelevel) {
        me.servicePe = event.pricelevel;
        me._peChangedSubject.next(true);
        me._isEventPeActiveSubject.next(true);
      }

    } else {
      me.currentEventID = null;
      const webshopSettings = await me.getWebshopSettingsDataModel();
      const serviceMode = me.getServiceMode();
      const ordertype = webshopSettings.ordertypes.find(o => o.id === serviceMode);
      me.servicePe = ordertype.default_pe;
      me._peChangedSubject.next(true);
      me._isEventPeActiveSubject.next(false);
    }
  }

  /**
   * Creates a BasketItemModel from a ProductDataModel and chosen Configuration
   * @param product ProductDataModel to map
   * @param config Extraconfiguration (i.e which extras have been selected)
   * @param productDetails ProductDetailsDataModel can be optionally provided to avoid servercall
   */
  private async mapProductConfigurationToBasketItemViewModel(product: ProductDataModel4, config: ProductConfiguration, productDetails: ProductDetailsDataModel3 = null): Promise<BasketItemViewModel> {
    const me = this;
    const model = new BasketItemViewModel();
    const isAusserHaus = me.isServiceAusserHaus();
    if (config.id) {
      model.id = config.id;
    } else {
      model.id = null; // null um die id beim einsetzen zu füllen
    }
    model.product_id = product.id;
    model.pos_product_id = product.product_id;
    if (me.serviceMode === WebShopMode.Webvoucher && me.voucherServiceType === VoucherServiceType.Charge) {
      model.labelDE = "Aufladung Guthaben";
      model.labelEN = "Charging Credit";
    } else {
      model.labelDE = product.label_de;
      model.labelEN = product.label_en;
    }
    model.hasImage = product.last_image_update_at_hms > -1
    if (model.hasImage) {
      model.imageUrl = ContentType.sub_Product + "/" + product.product_id + "_photo_" + ImageOrientation.Landscape + "/" + product.last_image_update_at_ymd + "/" + product.last_image_update_at_hms;
    } else {
      model.imageUrl = "";
    }
    model.time_set = product.time_set;
    model.scheduled_to_hms = product.scheduled_to_hms;
    model.scheduled_from_hms = product.scheduled_from_hms;
    model.usingtype = product.usingtype;
    model.bonusactionId = config.benefitData ? config.benefitData.bonusactionId : null;
    model.benefitId = config.benefitData ? config.benefitData.benefitId : null;
    model.benefitProductId = config.benefitData ? config.benefitData.benefitProductId : null;
    model.benefitLossId = config.benefitData ? config.benefitData.benefitLossId : null;
    model.benefitCostPoints = config.benefitData ? config.benefitData.benefitCostPoints : null;
    if (config.couponData) {
      model.coupon_id = config.couponData.couponId;
      model.coupon_code = config.couponData.couponCode;
      model.redemption_id = config.couponData.redemptionId;
    }
    model.noDiscount = product.noDiscount;
    model.minDiscountPrice = product.minDiscountPrice;
    model.servicePe = me.servicePe;
    model.userPe = me.userPe;
    model.wgrGroupId = product.wgr_grp_id_item;
    const webshopSettings = await me.getWebshopSettingsDataModel();
    if (webshopSettings.use_menu_course) {
      productDetails = productDetails || await ProductDetailsHelperService.GetProductDetails(product, me._objObsInjectHelper, true, false);
      model.menucourse = productDetails.menu_course;
      model.default_menucourse = model.menucourse;
    }
    if (config.menu_course != null) {
      model.menucourse = config.menu_course;
    }

    if (config.comment && config.comment.length > 0) {
      model.comment = config.comment;
    }
    const fallbackPrices = new BasketItemPriceViewModel();
    fallbackPrices.price = product.price;
    fallbackPrices.priceWithDefaultExtras = product.extras;
    fallbackPrices.deposit = product.dep_ah;
    fallbackPrices.vat = product.vat_ah;
    product.prices.forEach(price => {
      const pePrices = new BasketItemPriceViewModel();
      pePrices.price = price.price;
      pePrices.priceWithDefaultExtras = product.extras;
      pePrices.deposit = (isAusserHaus) ? product.dep_ah : product.dep;
      pePrices.vat = (isAusserHaus) ? product.vat_ah : product.vat;
      model.pePrices[price.pe] = pePrices;
    });

    model.count = config.count || 1;
    model.valid_date = config.valid_date || 0;
    model.variable_price = Utils.moneyRound(config.variable_price) || 0;

    if (product.usingtype === UsingType.Webvoucher && product.price === 0) {
      if (config.variable_price != null) {
        model.variable_price = Utils.moneyRound(config.variable_price);
      } else {
        throw new Error("A Variable Webvoucher needs a variable_price defined");
      }
    }
    if (config.extras && config.extras.length > 0) {
      productDetails = productDetails || await ProductDetailsHelperService.GetProductDetails(product, me._objObsInjectHelper, true, false);
      productDetails.extras.forEach(extra => {
        const fallbackExtraPrice = new BasketItemExtraPriceViewModel();
        fallbackExtraPrice.price = extra.price;
        fallbackExtraPrice.deposit = extra.dep_ah;
        fallbackPrices.extraPrices[extra.id] = fallbackExtraPrice;

        extra.prices.forEach(price => {
          const extraPrice = new BasketItemExtraPriceViewModel();
          extraPrice.price = price.price;
          extraPrice.deposit = (isAusserHaus) ? price.dep_ah : price.dep;
          model.pePrices[price.pe].extraPrices[extra.id] = extraPrice;
        });
      });
      // Prefill Extragroups with no Choice
      const prefilledExtras: ProductConfigurationExtra[] = [];
      const noSortProperty = "NoSort" + me.sortiment;
      const extrasInSort: ProductExtraDataModel3[] = [];
      const subExtrasInSort: ProductExtraDataModel3[] = [];
      productDetails.extras.filter(extra => !extra[noSortProperty]).forEach(extra => {
        (extra.SubIndex >= 0 ? extrasInSort : subExtrasInSort).push(extra);
      });
      for (let i = 1; i <= 16; ++i) {
        if (productDetails.extramode.getForceMode(i)) {
          const extras = extrasInSort.filter(extra => extra.getQ(i));
          if (extras.length === 1) {
            const extra = extras[0];
            const subExtras = subExtrasInSort.filter(subExtra => subExtra.SubIndex === -extra.SubIndex);
            if (subExtras.length <= 1) {
              const maxCount = productDetails.extramode["c" + i];
              const subExtra = subExtras[0];
              prefilledExtras.push({ id: extras[0].id, count: maxCount });
              if (subExtra) {
                prefilledExtras.push({ id: subExtra.id, count: maxCount });
              }
            }
          }
        }
      }
      config.extras = config.extras.filter(extra => !prefilledExtras.some(pExtra => pExtra.id === extra.id));
      for (const extra of [...prefilledExtras, ...config.extras]) {
        const extraModel = new BasketItemExtraViewModel();
        const extraDetail = productDetails.extras.find(extraDataModel => extraDataModel.id === extra.id);
        if (extraDetail) {
          extraModel.product_extra_id = extra.id;
          extraModel.pos_rez_id = extraDetail.rez_id;
          extraModel.pos_product_id = extraDetail.product_id;
          extraModel.count = extra.count;
          extraModel.titleDE = extraDetail.title_de;
          extraModel.titleEN = extraDetail.title_en;
          extraModel.subIndex = extraDetail.SubIndex;
          model.product_extras.push(extraModel);
        } else {
          throw new Error(`Can't find Extra:${extra.id} for Product:${product.id}`);
        }
      }
    }
    if (config.comment) {
      model.comment = config.comment;
    }
    model.fallbackPrices = fallbackPrices;
    me.calcBasketItemPrices(model);
    return model;
  }

  public calcBasketItemPrices(item: BasketItemViewModel) {
    const me = this;
    const servicePe = me.servicePe;
    const userPe = me.userPe;
    item.servicePe = servicePe;
    item.userPe = userPe;
    const pePrices = item.pePrices;
    let bestPe: number;
    if (servicePe != null && pePrices[servicePe]) {
      bestPe = servicePe;
      const servicePrices = pePrices[servicePe];
      item.vatPercent = servicePrices.vat;
      item.basePrice = servicePrices.price;
      item.deposit = servicePrices.deposit;
    }
    if (userPe != null && userPe !== -1 && item.pePrices[userPe]) {
      if (bestPe != null) {
        bestPe = userPe;
      } else if (pePrices[servicePe].priceWithDefaultExtras >= pePrices[userPe].priceWithDefaultExtras) {

      }
    }
    const prices: BasketItemPriceViewModel = (bestPe != null) ? pePrices[bestPe] : item.fallbackPrices;
    item.vatPercent = prices.vat;

    // If the basket is fixed we _always_ use variable_price otherwise only when a variable price is supplied;
    const useVariablePrice = !me.allowBasketModification || item.variable_price > 0;
    // Determine Benefit item and set basePrice to 0
    const isBenefit = this.isBenefitItem(item.benefitLossId, item.bonusactionId, item.benefitId);
    if (isBenefit) {
      item.basePrice = 0;
    } else {
      item.basePrice = (useVariablePrice) ? item.variable_price : prices.price;
    }
    item.deposit = prices.deposit;
    for (const extra of item.product_extras.filter(extra => extra.is_real_product)) {
      const extraDetail = prices.extraPrices[extra.product_extra_id]
      if (extraDetail) {
        if (!isBenefit) {
          item.basePrice += extraDetail.price * extra.count;
        }
        item.deposit += extraDetail.deposit * extra.count;
      } else {
        throw new Error(`Can't find Extra:${extra.product_extra_id} for Product:${item.product_id}`);
      }
    }
    me.setBasketItemDiscount(item, me.discountPercent); // Apply Discount
  }

  public setBasketItemDiscount(item: BasketItemViewModel, discountPercent: number) {
    item.appliedDiscount = discountPercent;
    item.price = ProductDetailsHelper.applyDiscount(item.basePrice, discountPercent, item.minDiscountPrice, item.noDiscount);
  }

  public isBenefitItem(benefitLossId: number, bonusactionId: number, benefitId: number): boolean {
    const hasBonusActionId = bonusactionId !== undefined && bonusactionId > 0;
    const hasBenefit = benefitId !== undefined && benefitId > 0;
    return benefitLossId && hasBonusActionId && hasBenefit;
  }

  /**
   * Re-resolves the Retail delivery fee from the persisted DestinationCountry right before
   * order creation; throws rather than silently sending a zero-fee order.
   */
  private async resolveRetailDeliveryFeeOrThrow(): Promise<void> {
    const me = this;
    if (me.serviceMode !== WebShopMode.Retail) {
      return;
    }
    if (me.DestinationCountry === null) {
      throw CheckoutErrorCode.RetailDeliveryCountryUnresolved;
    }

    let deliveryCountries: DeliveryCountry[];
    try {
      if (!me._webshopSettingsDataModel) {
        await me.getWebshopSettingsDataModel();
      }
      deliveryCountries = me.getDeliveryCountries();
    } catch (error) {
      me._coreLogService.error("WebShopService.resolveRetailDeliveryFeeOrThrow", "getDeliveryCountries threw", error && (error.codeText || error.code) || error);
      me.clearUnresolvedDestinationCountry();
      throw CheckoutErrorCode.RetailDeliveryCountryUnresolved;
    }

    const matchedCountry = (deliveryCountries || []).find(country => country.id === me.DestinationCountry.id);
    if (!matchedCountry || matchedCountry.delivery_fee == null) {
      me._coreLogService.error("WebShopService.resolveRetailDeliveryFeeOrThrow", "no resolvable delivery country for id", me.DestinationCountry.id);
      me.clearUnresolvedDestinationCountry();
      throw CheckoutErrorCode.RetailDeliveryCountryUnresolved;
    }

    me.applyDeliveryCountryFeeValues(matchedCountry);
    // Notify + persist: the resolved country can differ from what is currently displayed.
    // Fires unconditionally; subscribers are idempotent no-ops when nothing changed.
    me._orderDataCountryChangedSubject.next(true);
    me.saveToStorage();
  }

  /**
   * Resets DestinationCountry (and its derived money fields) to the unselected state and
   * notifies subscribers before the hard stop, so a retry doesn't repeat the same doomed
   * lookup while the UI still shows the rejected country as selected (stale reference).
   * Notification is wrapped defensively so a throwing subscriber can't mask the pending throw.
   */
  private clearUnresolvedDestinationCountry(): void {
    const me = this;
    if (me.DestinationCountry === null) {
      return;
    }
    me.DestinationCountry = null;
    me._minimumOrderValue = 0;
    me._deliveryFee = 0;
    me._useFreeShipping = false;
    me._freeShippingThreshold = 0;
    me.deliveryAddressViewModel.country = "";
    try {
      me._orderDataCountryChangedSubject.next(true);
    } catch (subscriberError) {
      me._coreLogService.error("WebShopService.clearUnresolvedDestinationCountry", "subscriber threw during notification", subscriberError && (subscriberError.codeText || subscriberError.code) || subscriberError);
    }
    me.saveToStorage();
  }

  /**
   * createAddPurchaseOrderDataModel from current Basket Data
   * @param WebvoucherAmount BasketItemDataModel
   */
  public async createAddPurchaseOrderDataModel(useDeliveryAddress: boolean = false, webvoucher: { amount: number, code: string } = { amount: 0, code: "" }): Promise<AddPurchaseOrderDataModel> {
    const me = this;
    await me.resolveRetailDeliveryFeeOrThrow();
    const apodm = new AddPurchaseOrderDataModel();
    const location = await me._locationObsServ.GetObject(me.locationID);

    apodm.language = InternationalisationService.locale;
    apodm.location = me.locationID;
    apodm.ordertype = me.mapWebShopModeToOrderType(me.serviceMode);
    apodm.currencySymbol = location.currencySymbol || "€"; // Todo Remove Temporary Fallback
    apodm.comment = me._orderComment;

    // Set EventID from currentEventID in WebShopService for price validation
    if (me.currentEventID) {
      apodm.EventID = me.currentEventID;
    }

    if (me.serviceMode === WebShopMode.Webvoucher || me.serviceMode === WebShopMode.Retail || me.serviceMode === WebShopMode.Ticket) {
      me._serviceOrderTime = moment();
    }
    if (me.isTimeRequired && !me._serviceOrderTime) {
      //load cached service time if not already done
      await me.restoreAndSetServiceTimeFromCache();
    }
    apodm.wantedHandoverDate = 0 // YMD
    apodm.wantedHandoverTime = 0 // HMS
    if (me._serviceOrderTime) {
      apodm.wantedHandoverDate = Utils.GetYMDFromMoment(me._serviceOrderTime);
      apodm.wantedHandoverTime = Utils.GetHMSFromMoment(me._serviceOrderTime);
    }
    if (me.orderASAP) {
      // A negative wantedHandoverDate sets the Express flag
      apodm.wantedHandoverDate = apodm.wantedHandoverDate === 0 ? -1 : -apodm.wantedHandoverDate;
    }
    apodm.cusGuest = !(await me._userHelperService.IsRegistered); // Mabye IsRegistrationConfirmed
    const orderdata = me._webshopOrderDataViewModel;

    apodm.cusDeliveryCo = "";
    apodm.cusDeliveryAdress = "";
    apodm.cusDeliveryAddition = "";
    apodm.cusDeliveryPlz = "";
    apodm.cusDeliveryCity = "";
    apodm.cusDeliveryCountry = "";
    apodm.cusDeliveryTel = ""; // No Informations
    apodm.cusDeliveryMail = ""; // No Informations
    if (me.serviceMode === WebShopMode.Delivery || me.serviceMode === WebShopMode.Webvoucher || me.serviceMode === WebShopMode.Retail || me.serviceMode === WebShopMode.DeliveryGroup) {
      const deliveryAddress: FurtherAddressViewModel = me.deliveryAddressViewModel; // TODO: ANY BECAUSE Currently Bugged see zip
      if (deliveryAddress && useDeliveryAddress) {
        apodm.cusDeliveryCo = deliveryAddress.co || "";
        apodm.cusDeliveryAdress = deliveryAddress.address || "";
        apodm.cusDeliveryAddition = deliveryAddress.addition || "";
        apodm.cusDeliveryPlz = deliveryAddress.zip_code || ""; // TODO Type definition say .zip but the model has it as zip_code
        apodm.cusDeliveryCity = deliveryAddress.city || "";
        apodm.cusDeliveryCountry = deliveryAddress.country || "";
        apodm.cusDeliveryTel = orderdata.telephone_mobile || orderdata.telephone1 || orderdata.telephone2 || "";
        apodm.cusDeliveryMail = orderdata.email || "";
      }
    }

    apodm.cusTitle = ""; // Always send as EmptyString since it is unknown to the Webshop
    apodm.cusName = orderdata.name || "";
    apodm.cusFname = orderdata.fname || "";
    apodm.cusPrefix = orderdata.prefix || "";
    apodm.cusBillCo = orderdata.co || "";
    apodm.cusBillAdress = orderdata.address || "";
    apodm.cusBillAddition = orderdata.addition || "";
    apodm.cusBillPlz = orderdata.zip_code || "";
    apodm.cusBillCity = orderdata.city || "";
    apodm.cusBillCountry = orderdata.country || "";
    apodm.cusBillTel = orderdata.telephone_mobile || orderdata.telephone1 || orderdata.telephone2 || "";
    apodm.cusBillMail = orderdata.email || "";
    apodm.tel1 = orderdata.telephone1 || "";
    apodm.tel2 = orderdata.telephone2 || "";
    apodm.telM = orderdata.telephone_mobile || "";
    apodm.birth = orderdata.bday_ymd || 0;

    const webshopSettings = await me.getWebshopSettingsDataModel();
    // Im Haus Zahlungen sind möglich bei eigen Initialisiereung der Zahlung, oder wenn es sich um eine Gruppe handelt
    const mandatory_Payment = me._objObsInjectHelper.inHouseOrderService.TableData.mandatory_Payment;
    if (me.serviceMode === WebShopMode.OrderToTable && !mandatory_Payment && (webshopSettings.order_inhouse_without_payment || me._objObsInjectHelper.inHouseOrderService.UiData.isGroup)) {
      const pos_items = await me.getInHousePaymentItems();
      apodm.items = await me.mapInHousePOSTableItemsToAddPurchaseOrderItemDataModels(pos_items);
      apodm.baseprice = Utils.moneyRound(pos_items.reduce((a, b) => a + (Utils.centsToCurrency(b.orgprice + 0 /* 0 = kein Pfand bei InHouse */) * b.amount), 0));
      apodm.discountTotal = Utils.moneyRound(pos_items.reduce((a, b) => a + (Utils.centsToCurrency(b.orgprice - b.price) * b.amount), 0));
      apodm.deposit = 0; // 0 = kein Pfand bei InHouse
      apodm.deliveryCost = 0; // 0 = keine Versandkosten bei InHouse
      apodm.vatStats = me.getVatStatsFromInHouseOrder(pos_items);
    } else if (me.serviceMode === WebShopMode.Webvoucher) {
      if (me.basketItemsAreWebvouchers()) {
        apodm.webvouchers = await me.mapBasketItemsToAddPurchaseOrderWebvoucherItemDataModels();
        apodm.baseprice = Utils.moneyRound(me.shippingCartItems.reduce((a, b) => a + (b.basePrice * b.count), 0));
        apodm.discountTotal = 0; // 0 = kein Rabatt bei Webgutscheinen
        apodm.deposit = 0; // 0 = kein Pfand bei Webgutscheinen
        apodm.deliveryCost = Utils.moneyRound(me.finalDeliveryFee);
        // ! todo Die USt für den Versand der Gutscheine Richtig berechnen?
        apodm.vatStats = me.getBasketVatStats();
      } else { // es ist eine Gutschein Aufladung, auf altem Weg aufladen
        apodm.items = me.mapBasketItemsToAddPurchaseOrderItemDataModels();
        apodm.baseprice = Utils.moneyRound(me.shippingCartItems.reduce((a, b) => a + (b.basePrice * b.count), 0))
        apodm.discountTotal = Utils.moneyRound(me.shippingCartItems.reduce((a, b) => a + ((b.basePrice - b.price) * b.count), 0));
        apodm.deposit = Utils.moneyRound(me.shippingCartItems.reduce((a, b) => a + (b.deposit * b.count), 0));
        apodm.deliveryCost = Utils.moneyRound(me.finalDeliveryFee);
        apodm.vatStats = me.getBasketVatStats();
      }
    } else { // nicht InHouseOrder oder OrderAndPay (es hat ein Basket)
      apodm.items = me.mapBasketItemsToAddPurchaseOrderItemDataModels();
      apodm.baseprice = Utils.moneyRound(me.shippingCartItems.reduce((a, b) => a + (b.basePrice * b.count), 0))
      apodm.discountTotal = Utils.moneyRound(me.shippingCartItems.reduce((a, b) => a + ((b.basePrice - b.price) * b.count), 0));
      apodm.deposit = Utils.moneyRound(me.shippingCartItems.reduce((a, b) => a + (b.deposit * b.count), 0));
      apodm.deliveryCost = Utils.moneyRound(me.finalDeliveryFee);
      apodm.vatStats = me.getBasketVatStats();
    }
    apodm.tip = Utils.moneyRound(me.trinkgeldValue || 0);
    apodm.grossprice = Utils.moneyRound(apodm.baseprice - apodm.discountTotal + apodm.deposit + apodm.tip + apodm.deliveryCost);
    // MwSt aufsummieren und aufsteigend sortiern
    apodm.vat = Utils.moneyRound(apodm.vatStats.reduce((a, b) => a + Utils.centsToCurrency(b.vat), 0));
    apodm.vatStats.sort((a, b) => b.percent - a.percent);

    apodm.paymentAmount = Utils.moneyRound(Math.max(apodm.grossprice - webvoucher.amount, 0));
    apodm.partialPaymentAmount = Utils.moneyRound(apodm.grossprice - apodm.paymentAmount);
    apodm.partialpaymentInfo = webvoucher.code;
    if (me.qrCode) {
      apodm.qrCode = me.qrCode;
    }
    const Orderidentification = await me.GetOrderIndentification()
    if (!Utils.IsNullOrEmpty(Orderidentification.token)) {
      apodm.token = me.addPurchaseOrderToken + "|" + Orderidentification.token;
    }
    else {
      apodm.token = me.addPurchaseOrderToken;
    }

    me.saveToStorage();
    return apodm;
  }

  /** Ermittelt die Artikel die bezahlt werden */
  private async getInHousePaymentItems(): Promise<POSTable_Item[]> {
    const me = this;
    const inHouseOrderService = me._objObsInjectHelper.inHouseOrderService;
    const table = await inHouseOrderService.GetTable(TableData.All); // force abruf des Tisches
    const userPayment = table.yasTable.payments.find((payment) => payment.userToken === inHouseOrderService.UserToken)
    const items: POSTable_Item[] = [];
    userPayment.items.forEach((payment_item, index) => {
      const pos_item = table.posTable.items.find((item) => item.id === payment_item.id);
      if (pos_item && pos_item.productID == payment_item.prod_id && pos_item.amount >= payment_item.amount) {
        const item = Utils.GetCopy(pos_item);
        item.amount = payment_item.amount;
        items.push(item);
      } else {
        throw new Error("Payment item not found in pos items to pay");
      }
    });
    return items;
  }

  /** wandelt POSTable_Items in AddPurchaseOrderItemDataModel */
  private mapInHousePOSTableItemsToAddPurchaseOrderItemDataModels(pos_items: POSTable_Item[]): AddPurchaseOrderItemDataModel[] {
    const me = this;
    const items: AddPurchaseOrderItemDataModel[] = [];
    pos_items.forEach((pos_item, index) => {
      const item = me.mapInHousePOSTableItemToAddPurchaseOrderItemDataModel(pos_item);
      item.position = index + 1;
      items.push(item);
    });
    return items;
  }

  /**
   * Maps the POSTable_Item to the AddPurchaseOrderItemDataModel so it can be used in a request
   * @param pos_item POSTable_Item
   */
  private mapInHousePOSTableItemToAddPurchaseOrderItemDataModel(pos_item: POSTable_Item): AddPurchaseOrderItemDataModel {
    const me = this;
    const item = new AddPurchaseOrderItemDataModel();
    item.product_id = pos_item.productID;
    item.count = pos_item.amount;
    item.comment = pos_item.FT;
    item.usingtype = pos_item.usingType;
    item.variable_price = 0;
    item.valid_date = pos_item.validDate_YMD || 0;
    item.product_extras = [];
    pos_item.extras.forEach((pos_item_extra) => {
      item.product_extras.push(me.mapInHousePOSTableItemExtraToAddPurchaseOrderItemExtraDataModel(pos_item_extra));
    });
    return item;
  }

  /**
   * Maps the POSTable_Item_Extra to the AddPurchaseOrderItemExtraDataModel so it can be used in a request
   * @param pos_item_extra POSTable_Item_Extra
   */
  private mapInHousePOSTableItemExtraToAddPurchaseOrderItemExtraDataModel(pos_item_extra: POSTable_Item_Extra): AddPurchaseOrderItemExtraDataModel {
    const extra = new AddPurchaseOrderItemExtraDataModel();
    extra.product_extra_id = pos_item_extra.productID;
    extra.count = pos_item_extra.amount;
    return extra;
  }


  /**
   * Map WebShopMode to OrderType (for requests)
   * @param mode mode to convert
   */
  public mapWebShopModeToOrderType(mode: WebShopMode): orderTypes {
    switch (mode) {
      case WebShopMode.Delivery: return orderTypes.delivery;
      case WebShopMode.DeliveryGroup: return orderTypes.deliveryGroup;
      case WebShopMode.TakeAway: return orderTypes.pickup;
      case WebShopMode.PickupGroup: return orderTypes.pickupGroup;
      case WebShopMode.OrderToTable: return orderTypes.inHouse;
      case WebShopMode.OrderAhead: return orderTypes.orderAhead;
      case WebShopMode.Webvoucher: return this.allowBasketModification ? orderTypes.webvoucher : orderTypes.externalBasket;
      case WebShopMode.Retail: return orderTypes.retail;
      case WebShopMode.Ticket: return orderTypes.ticket;
      default: return orderTypes.allUnknown;
    }
  }

  /**
   * Maps the BasketItemDataModel to the AddPurchaseOrderItemDataModel so it can be used in a request
   * @param basketItem BasketItemDataModel
   */
  private mapBasketItemsToAddPurchaseOrderItemDataModels(): AddPurchaseOrderItemDataModel[] {
    const me = this;
    const items: AddPurchaseOrderItemDataModel[] = [];
    me.shippingCartItems.forEach((basketItem, index) => {
      const item = me.mapBasketItemToAddPurchaseOrderItemDataModel(basketItem);
      item.position = index + 1;
      items.push(item);
    });
    return items;
  }

  /**
   * Maps the BasketItemDataModel to the AddPurchaseOrderItemDataModel so it can be used in a request
   * @param basketItem BasketItemDataModel
   */
  private mapBasketItemToAddPurchaseOrderItemDataModel(basketItem: BasketItemViewModel): AddPurchaseOrderItemDataModel {
    const me = this;
    const item = new AddPurchaseOrderItemDataModel();
    item.product_id = basketItem.product_id;
    item.count = basketItem.count;
    item.comment = basketItem.comment;
    if (me.serviceMode === me.WebShopMode.Webvoucher && me._voucherServiceType === VoucherServiceType.Charge) {
      //  cahrging webvoucher
      item.usingtype = -4; // 4/-4 = Webvoucher
    } else {
      item.usingtype = basketItem.usingtype; // Todo add to BasketModel and get from there.
    }
    item.variable_price = basketItem.variable_price || 0;
    item.valid_date = basketItem.valid_date || 0;
    item.product_extras = [];
    item.PE = basketItem.servicePe;
    item.bonusactionId = basketItem.bonusactionId;
    item.benefitId = basketItem.benefitId;
    item.benefitProductId = basketItem.benefitProductId;
    item.benefitLossId = basketItem.benefitLossId;
    item.coupon_id = basketItem.coupon_id;
    item.coupon_code = basketItem.coupon_code;
    item.redemption_id = basketItem.redemption_id;
    basketItem.product_extras.forEach((basketExtra) => {
      item.product_extras.push(me.mapBasketExtraToAddPurchaseOrderItemExtraDataModel(basketExtra));
    });
    return item;
  }

  /**
   * Maps the BasketItemExtraDataModel to the AddPurchaseOrderItemExtraDataModel so it can be used in a request
   * @param basketExtra BasketItemExtraViewModel
   */
  private mapBasketExtraToAddPurchaseOrderItemExtraDataModel(basketExtra: BasketItemExtraViewModel): AddPurchaseOrderItemExtraDataModel {
    const extra = new AddPurchaseOrderItemExtraDataModel();
    extra.product_extra_id = basketExtra.product_extra_id;
    extra.count = basketExtra.count;
    return extra;
  }

  /** Prüfung ob alle Artikel im Warenkorb neue Webgutscheine sind.
   * Wenn nicht und die Bestellart Webvoucher ist, dann ist es eine Gutscheinaufladung
   */
  private basketItemsAreWebvouchers(): boolean {
    const me = this;
    let areWebvouchers = me.shippingCartItems.length > 0;
    me.shippingCartItems.forEach(basketItem => {
      areWebvouchers = areWebvouchers && (basketItem.isWebvoucher && basketItem.webvoucher_id > 0);
    });
    return areWebvouchers;
  }

  /**
 * Maps the BasketItemDataModel to the AddPurchaseOrderWebvoucherItemDataModel so it can be used in a request
 * @param basketItem BasketItemDataModel
 */
  private mapBasketItemsToAddPurchaseOrderWebvoucherItemDataModels(): AddPurchaseOrderWebvoucherItemDataModel[] {
    const me = this;
    const webvoucherItems: AddPurchaseOrderWebvoucherItemDataModel[] = [];
    me.shippingCartItems.forEach((basketItem, index) => {
      const webvoucherItem = me.mapBasketItemsToAddPurchaseOrderWebvoucherItemDataModel(basketItem);
      webvoucherItem.position = index + 1;
      webvoucherItems.push(webvoucherItem);
    });
    return webvoucherItems;
  }

  /**
   * Maps the BasketItemDataModel to the AddPurchaseOrderWebvoucherItemDataModel so it can be used in a request
   * @param basketItem BasketItemDataModel
   */
  private mapBasketItemsToAddPurchaseOrderWebvoucherItemDataModel(basketItem: BasketItemViewModel): AddPurchaseOrderWebvoucherItemDataModel {
    const me = this;
    if (!(basketItem.isWebvoucher && basketItem.webvoucher_id > 0)) {
      throw new Error("Basketitem is not a webvoucher");
    }
    const webvoucherItem = new AddPurchaseOrderWebvoucherItemDataModel();
    // webvoucherItem.position wird später gefüllt
    webvoucherItem.webvoucher_id = basketItem.webvoucher_id;
    webvoucherItem.delivery_type = basketItem.delivery_type;
    webvoucherItem.person_count = basketItem.person_count;
    webvoucherItem.show_person_count = basketItem.show_person_count;
    webvoucherItem.count = basketItem.count;
    webvoucherItem.comment = basketItem.comment;
    webvoucherItem.variable_price = basketItem.variable_price;
    return webvoucherItem;
  }

  /**
   * Gets the total count of items in the basket.
   * * shippingcart.length gets the amount of unique items
   */
  public getTotalCountOfItems(): number {
    return this.shippingCartItems.reduce((a, b) => a + b.count, 0);
  }

  public isServiceAusserHaus(): boolean {
    return (this.serviceMode === WebShopMode.Delivery || this.serviceMode === WebShopMode.TakeAway);
  }

  private async setRecommendationList() {
    const me = this;
    me._recommendationProductIds = [];
    const webshopSettings = await me.getWebshopSettingsDataModel();
    const recommendationRules = webshopSettings.recommendation_rules.filter(r => r.applicable_service === +me.serviceMode);
    if (recommendationRules && recommendationRules.length > 0) {
      const basketProductWGGroup: number[] = me.shippingCartItems.map(b => b.wgrGroupId);
      await Promise.all(recommendationRules.map(async rule => {
        let isRecommend: boolean = true;
        if (rule.needed_w_grps && rule.needed_w_grps.length > 0) {
          for (let i = 0; i < rule.needed_w_grps.length; i++) {
            if (!basketProductWGGroup.includes(rule.needed_w_grps[i])) {
              isRecommend = false;
              break;
            }
          }
        }
        if (isRecommend && rule.missing_w_grps && rule.missing_w_grps.length > 0) {
          for (let i = 0; i < rule.missing_w_grps.length; i++) {
            if (basketProductWGGroup.includes(rule.missing_w_grps[i])) {
              isRecommend = false;
              break;
            }
          }
        }
        if (isRecommend) {
          const schedule_req = new ScheduledForRequest(me.getScheduledForReferenceTime(), me.locationID, webshopSettings, me._coreLanguageService);
          await Promise.all(rule.product_ids.map(async productId => {
            const product = await me.getProductByProcutId(productId);
            if (product
              && !me.shippingCartItems.find(s => s.product_id === product.id)
              && !me._recommendationProductIds.includes(product.id)
              && product.isScheduledFor(schedule_req).active // empfehlungen nur aktive
              && await me.isProductAvailable$(product.product_id)) {
              me._recommendationProductIds.push(product.id);
            }
          }));
        }
      }));
    }
  }

  private async getProductByProcutId(productId: number): Promise<ProductDataModel4> {
    const me = this;
    return new Promise<ProductDataModel4>((resolve, reject) => {
      me._productService.GetProductsByFilter(me.locationID, me.sortiment, product => product.product_id === productId && !product.deleted && product.saleable)
        .then(data => {
          if (data && data.length > 0) {
            resolve(data[0]);
          } else {
            resolve(null);
          }
        })
        .catch(error => {
          resolve(null);
          me._coreLogService.error("WebShopService.getProductByProcutId", "GetProductsByFilter", error);
        });
    });
  }

  private findIdenticalProduct(items: BasketItemViewModel[], product: BasketItemViewModel, usePosIds: boolean = false): BasketItemViewModel | undefined {
    return items.find((p) => {
      if (usePosIds) {
        if (p.pos_product_id !== product.pos_product_id) { return false; }
      } else {
        if (p.product_id !== product.product_id) { return false; }
      }
      if (p.variable_price !== product.variable_price) { return false; }
      if (p.valid_date !== product.valid_date) { return false; }
      if (p.person_count !== product.person_count) { return false; }
      if (p.delivery_type !== product.delivery_type) { return false; }
      if (normalizeComment(p.comment) !== normalizeComment(product.comment)) { return false; }
      if (p.coupon_id !== product.coupon_id) { return false; }
      if (p.coupon_code !== product.coupon_code) { return false; }
      if (p.redemption_id !== product.redemption_id) { return false; }

      if (p.product_extras.length !== product.product_extras.length) { return false; }

      const areExtrasEqual = product.product_extras.every((extra) =>
        p.product_extras.some((e) => {
          if (usePosIds) {
            // GroupBasket: use POS IDs
            return extra.pos_product_id === e.pos_product_id
              && extra.pos_rez_id === e.pos_rez_id
              && extra.count === e.count;
          } else {
            // UserBasket:use interne IDs
            return extra.product_extra_id === e.product_extra_id
              && extra.count === e.count;
          }
        })
      );

      return areExtrasEqual;
    });
  }

  // #region Order Data

  public getDelivaryAddress() {
    const me = this;
    return me.deliveryAddressViewModel;
  }

  //! TODO Destination* Felder müssen durch currentlyUsed* ersetzt werden.
  // Wenn currentlyUsed die gewünschte lieferadresse beschreiben
  public currentlyUsedAddress: string = "";
  public currentlyUsedZipcode: string = "";
  public currentlyUsedCity: string = "";
  public currentlyUsedGeoCoordinates: Coordinates = null;
  public setCurrentlyUsedAddress(zipcode: string, city: string, address: string, geoCoordinates: Coordinates = null) {
    const me = this;
    me.currentlyUsedZipcode = zipcode;
    me.currentlyUsedAddress = address;
    me.currentlyUsedCity = city;
    me.currentlyUsedGeoCoordinates = geoCoordinates;
  }

  /**
   * Prüfung ob die Adresse beliefertwerden kann, anhand der im Webshop hinterlegten Liefergebiet oder der Mitgegeben.
   * Bei Polygon Liefergebieten wird nur die Destination Adresse geprüft.
   * @param zip_code ziel PLZ
   * @param city ziel Ort
   * @param address ziel Strasse und Hausnummer
   * @param country Optionals das Land für Retail (momentan nicht eingebaut)
   * @param deliveryAreas loacation delivery areas for check, else own deliveryArea
   */
  public isDeliveryAddressValid(zip_code: string, city: string, address: string, country: string = "", deliveryAreas: DeliveryArea[] = null): boolean {
    const me = this;
    if (me.serviceMode === WebShopMode.Delivery || me.serviceMode === WebShopMode.DeliveryGroup) {
      if (me.PolygonMapInformation && me.PolygonMapInformation.Coordinates) {
        return me.isDeliveryAddressDestinationAddress(zip_code, city, address);
      }
      // normale PLZ Liefergebiete prüfen
      if (deliveryAreas == null) {
        deliveryAreas = me.deliveryArea;
      }
      if (zip_code === "" || city === "") {
        return false;
        // No Delivery Areas means the location delivers everywhere
      } else if (deliveryAreas.length === 0) {
        return true;
      } else {
        const zipLC = zip_code.toLowerCase();
        const filteredZip = deliveryAreas.filter(d => d.zip.toLowerCase() === zipLC);
        if (filteredZip.length === 0) {
          return false;
        } else if (filteredZip.some(d => d.city !== "")) {
          const cityLC = city ? city.toLowerCase() : "";
          return filteredZip.some(d => d.city.toLowerCase() === cityLC);
        } else {
          return true;
        }
      }
    } else if (me.serviceMode === WebShopMode.Retail) {
      return true;
      // return country === me.DestinationCountry;
    } else if (me.serviceMode === WebShopMode.Webvoucher) {
      return true;
    } else {
      return false;
    }
  }

  /** Prüfung ob die Adresse auch die Ziel Adresse ist, welche bei der Bestellung angegeben wurde */
  public isDeliveryAddressDestinationAddress(zip_code: string, city: string, address: string): boolean {
    const me = this;
    if (me.serviceMode === WebShopMode.Delivery || me.serviceMode === WebShopMode.DeliveryGroup) {
      const _zipCode = zip_code || "";
      const _city = city || "";
      const _address = address || "";
      const _destinationZipCode = me.DestinationZipCode || "";
      const _destinationCity = me.DestinationCity || "";
      const _destinationAddress = me.DestinationAddress || "";
      return _destinationZipCode === _zipCode &&
        _destinationCity === _city &&
        _destinationAddress === _address;
    } else {
      return true; // keine prüfung, wenn nicht Lieferung oder Gruppenlieferung
    }
  }

  public setDeliveryAddress(newDeliveryAddressViewModel: FurtherAddressViewModel) {
    const me = this;
    me.deliveryAddressViewModel.id = newDeliveryAddressViewModel.id ? newDeliveryAddressViewModel.id : "";
    me.deliveryAddressViewModel.address_type = AddressType.Delivery;
    me.deliveryAddressViewModel.co = newDeliveryAddressViewModel.co ? newDeliveryAddressViewModel.co.trim() : "";
    me.deliveryAddressViewModel.address = newDeliveryAddressViewModel.address ? newDeliveryAddressViewModel.address.trim() : "";
    me.deliveryAddressViewModel.addition = newDeliveryAddressViewModel.addition ? newDeliveryAddressViewModel.addition.trim() : "";
    me.deliveryAddressViewModel.city = newDeliveryAddressViewModel.city ? newDeliveryAddressViewModel.city.trim() : "";
    me.deliveryAddressViewModel.country = newDeliveryAddressViewModel.country ? newDeliveryAddressViewModel.country.trim() : "";
    me.deliveryAddressViewModel.mobilePhone = newDeliveryAddressViewModel.mobilePhone ? newDeliveryAddressViewModel.mobilePhone.trim() : "";
    me.deliveryAddressViewModel.selected = newDeliveryAddressViewModel.selected;
  }

  public saveNewCustomerFurtherAddress(deliveryAddressViewModel: FurtherAddressViewModel) {
    const me = this;
    if (!deliveryAddressViewModel || (deliveryAddressViewModel.id && deliveryAddressViewModel.id !== "")) {
      return;
    }
    const addressInfo: { [key: string]: string | number } = {};
    addressInfo["AddresstypeID"] = AddressType.Delivery;
    me.getAddressInputFields().forEach(customerInputFieldViewModel => {
      switch (customerInputFieldViewModel.fieldName) {
        case Utils.EnumName(OrderDataAddressFieldInputs, OrderDataAddressFieldInputs.addition):
          {
            addressInfo["Addition"] = deliveryAddressViewModel.addition ? deliveryAddressViewModel.addition.trim() : "";
            break;
          }
        case Utils.EnumName(OrderDataAddressFieldInputs, OrderDataAddressFieldInputs.address):
          {
            addressInfo["Adress"] = deliveryAddressViewModel.address ? deliveryAddressViewModel.address.trim() : "";
            break;
          }
        case Utils.EnumName(OrderDataAddressFieldInputs, OrderDataAddressFieldInputs.city):
          {
            addressInfo["City"] = deliveryAddressViewModel.city ? deliveryAddressViewModel.city.trim() : "";
            break;
          }
        case Utils.EnumName(OrderDataAddressFieldInputs, OrderDataAddressFieldInputs.zip_code):
          {
            addressInfo["Plz"] = deliveryAddressViewModel.zip_code ? deliveryAddressViewModel.zip_code.trim() : "";
            break;
          }
        case Utils.EnumName(OrderDataAddressFieldInputs, OrderDataAddressFieldInputs.country):
          {
            addressInfo["Country"] = deliveryAddressViewModel.country ? deliveryAddressViewModel.country.trim() : "";
            break;
          }
        case Utils.EnumName(OrderDataAddressFieldInputs, OrderDataAddressFieldInputs.co):
          {
            addressInfo["CusCo"] = deliveryAddressViewModel.co ? deliveryAddressViewModel.co.trim() : "";
            break;
          }
        default:
          break;
      }
    });

    me._objObsInjectHelper.yourAppServer.User.SetCustomerFurtherAddressDataModel(deliveryAddressViewModel.id, addressInfo);
  }

  public setOrderDataViewModel(viewModel: WebshopOrderDataViewModel): void {
    const me = this;
    me._webshopOrderDataViewModel = viewModel;
  }

  public async initializeOrderDataViewModel(): Promise<void> {
    const me = this;
    if (me.loginState) {
      await me.GetWebshopOrderDataViewModel();
    } else {
      me._webshopOrderDataViewModel = new WebshopOrderDataViewModel();
    }
    me.setOrderDataDestination();
  }

  public setOrderDataDestination(): void {
    const me = this;
    if (!me.loginState) {
      me.setGuestOrderDataDestination();
    }
    if (me.loginState) {
      if (me.serviceMode === WebShopMode.Delivery || me.serviceMode === WebShopMode.DeliveryGroup) {
        me.deliveryAddressViewModel = new FurtherAddressViewModel();
        me.deliveryAddressViewModel.zip_code = me.DestinationZipCode;
        me.deliveryAddressViewModel.city = me.DestinationCity;
        me.deliveryAddressViewModel.address = me.DestinationAddress;
      } else if (me.serviceMode === WebShopMode.Retail) {
        if (me.DestinationCountry === null) {
          return;
        }
        me.deliveryAddressViewModel = new FurtherAddressViewModel();
        me.deliveryAddressViewModel.country = me.DestinationCountry["country_" + InternationalisationService.locale] || "";
      }
    }
  }

  private setGuestOrderDataDestination(): void {
    const me = this;
    if (!me.loginState) {
      if (me.serviceMode === WebShopMode.Delivery) {
        me.deliveryAddressViewModel = new FurtherAddressViewModel();
        if (me.currentlyUsedZipcode) {
          // preset zip code
          me._webshopOrderDataViewModel.zip_code = me.currentlyUsedZipcode;
          me.deliveryAddressViewModel.zip_code = me.currentlyUsedZipcode;
        }
        if (me.currentlyUsedCity) {
          //preset city
          me._webshopOrderDataViewModel.city = me.currentlyUsedCity;
          me.deliveryAddressViewModel.city = me.currentlyUsedCity;
        }
        if (me.currentlyUsedAddress) {
          // preset address
          me._webshopOrderDataViewModel.address = me.currentlyUsedAddress;
          me.deliveryAddressViewModel.address = me.currentlyUsedAddress;
        }
      } else {
        if (me.serviceMode === WebShopMode.Retail) {
          if (me.DestinationCountry === null) {
            return;
          }
          const countryValue = me.DestinationCountry["country_" + InternationalisationService.locale] || "";
          me.deliveryAddressViewModel.country = countryValue;
          if (me._webshopOrderDataViewModel) {
            me._webshopOrderDataViewModel.country = countryValue;
          }
        }

      }
    }
  }

  public setCustomerMainAddressDataModel(webshopOrderDataViewModel: WebshopOrderDataViewModel, customerInputFieldViewModels: CustomerInputFieldViewModel[]): Promise<void> {
    const me = this;
    const billingInfo: { [key: string]: string | number } = {};
    customerInputFieldViewModels.forEach(customerInputFieldViewModel => {
      billingInfo[customerInputFieldViewModel.fieldName] = webshopOrderDataViewModel[customerInputFieldViewModel.fieldName];
    });
    // todo nur speichern wenn adresse auch geändert wurde

    return me._objObsInjectHelper.yourAppServer.User.SetCustomerMainAddress(billingInfo).then(() => {
      // neuladen des customers wird bereits durch events realisiert
    });
  }

  public GetWebshopOrderDataViewModel(): Promise<WebshopOrderDataViewModel> {
    const me = this;
    return new Promise<WebshopOrderDataViewModel>((resolve, reject) => {
      if (me._userHelperService.IsRegistered) {
        if (me._webshopOrderDataViewModel) {
          resolve(me._webshopOrderDataViewModel);
        } else {
          me._userProfileService.GetWebshopOrderDataViewModel()
            .then(webshopOrderDataViewModel => {
              // TODO does I need this information on service!!?
              me._webshopOrderDataViewModel = webshopOrderDataViewModel;
              resolve(me._webshopOrderDataViewModel);
            })
            .catch(e => {
              reject();
              me._objObsInjectHelper.coreLogService.error("WebshopService.GetWebshopOrderDataViewModel", "GetWebshopOrderDataViewModel", e);
            });
        }
      } else {
        if (!me._webshopOrderDataViewModel) {
          me._webshopOrderDataViewModel = new WebshopOrderDataViewModel();
        }
        resolve(me._webshopOrderDataViewModel);
      }
    });
  }

  // private async checkBillingInfoValidation(customerInputFieldViewModels: CustomerInputFieldViewModel[]): Promise<void> {
  //   const me = this;
  //   const userInfo = await me._objObsInjectHelper.yourAppServer.User.GetUserInfo();
  //   const mandatoryFields = customerInputFieldViewModels.filter(c => c.isRequired);
  //   customerInputFieldViewModels.forEach(viewModel => {
  //     switch (viewModel.fieldName) {
  //       case "fname":
  //         {
  //           userInfo.fname
  //           break;
  //         }


  //       default:
  //         break;
  //     }
  //   });
  // }

  private createCustomerInputFieldViewModel(jsonInputs: Object[]) {
    const me = this;
    const customerInputFieldViewModels = new Array<CustomerInputFieldViewModel>();
    const jsonInput = jsonInputs.filter(j => (j["used"]));
    jsonInput.forEach(jsonObject => {
      const inputFieldName = Utils.EnumName(OrderDataInputFields, +(jsonObject["field"]));
      if (inputFieldName) {
        if (!(me.serviceMode === WebShopMode.Delivery && me._userHelperService.IsRegistered
          && (+(jsonObject["field"]) === OrderDataInputFields.fname || +(jsonObject["field"]) === OrderDataInputFields.email))) {
          const customerInputFieldViewModel = new CustomerInputFieldViewModel();
          customerInputFieldViewModel.fieldName = inputFieldName;
          customerInputFieldViewModel.isRequired = jsonObject["required"];
          console.log("field: " + customerInputFieldViewModel.fieldName + " required: " + customerInputFieldViewModel.isRequired);
          console.log(me.ordertype.customer_input_fields);
          customerInputFieldViewModel.fieldType = jsonObject["type"];
          customerInputFieldViewModels.push(customerInputFieldViewModel);
        }
      }
    });
    return customerInputFieldViewModels;
  }

  public createAddressInputFields(jasonInputs: Object[]) {
    const me = this;
    const addressInputFieldViewModels = new Array<CustomerInputFieldViewModel>();
    const jsonInputs = jasonInputs.filter(j => (j["used"]));
    jsonInputs.forEach(jsonObject => {
      const addressInputFielsViewModel = new CustomerInputFieldViewModel();
      addressInputFielsViewModel.fieldName = Utils.EnumName(OrderDataAddressFieldInputs, +(jsonObject["field"]));
      addressInputFielsViewModel.isRequired = jsonObject["required"];
      addressInputFielsViewModel.fieldType = jsonObject["type"];
      addressInputFieldViewModels.push(addressInputFielsViewModel);
    });
    return addressInputFieldViewModels;
  }

  private getBasketSumDiscounted(): number {
    return Utils.moneyRound(this.shippingCartItems.reduce((a, b) => a + ((b.price + b.deposit) * b.count), 0));
  }

  public getBasketSumTotal(): number {
    return Utils.moneyRound(this.getBasketSumDiscounted() + this.finalDeliveryFee + this.trinkgeldValue);
  }

  private getBasketVatStats(): VatStat[] {
    const me = this;
    const vatstats: VatStat[] = [];
    if (me.deliveryFee && me._locationMwst1 != null) {
      me.addVatStat(vatstats, me._locationMwst1, me.deliveryFee);
    }
    me.shippingCartItems.forEach(item => {
      const itemPrice = (item.price + item.deposit) * item.count;
      me.addVatStat(vatstats, item.vatPercent, itemPrice);
    });
    for (const vatstat of vatstats) {
      vatstat.vat = Utils.moneyRound(vatstat.vat);
    }
    return vatstats;
  }

  private getVatStatsFromInHouseOrder(pos_items: POSTable_Item[]): VatStat[] {
    const me = this;
    const vatstats: VatStat[] = [];
    if (me.deliveryFee && me._locationMwst1 != null) {
      me.addVatStat(vatstats, me._locationMwst1, me.deliveryFee);
    }
    pos_items.forEach(item => {
      const itemPrice = (Utils.centsToCurrency(item.price)) * item.amount;
      me.addVatStat(vatstats, (item.vat / 100), itemPrice);
    });
    for (const vatstat of vatstats) {
      vatstat.vat = Utils.moneyRound(vatstat.vat);
    }
    return vatstats;
  }

  private addVatStat(vatStats: VatStat[], vatPercent: number, vattedAmount: number) {
    const sameVat = vatStats.find(vatstat => vatstat.percent === vatPercent);
    if (sameVat) {
      sameVat.assessedAmount += vattedAmount;
      sameVat.vat += vattedAmount * vatPercent / (100 + vatPercent);
    } else {
      const newVat = new VatStat;
      newVat.percent = vatPercent;
      newVat.assessedAmount = vattedAmount;
      newVat.vat = (vattedAmount * vatPercent) / (100 + vatPercent);
      vatStats.push(newVat);
    }
  }

  // product_id aus der Kasse und nicht die ID des Artikels!
  public async isProductAvailable$(product_id: number): Promise<boolean> {
    const me = this;
    let isAvailable = true;
    if (me.useAvailability) {
      if (me._productService.isProductAvailabilityBlacklisted(me.locationID, product_id)) {
        isAvailable = false;
      } else {
        const count = me._productService.getProductAvailabilityCount(me.locationID, product_id);
        if (count !== -1) {
          isAvailable = count > me.availabilityMinimum; // Greater > because at the Minimum it's no longer available
        } // else keep available
      }
    } // else keep available

    // wenn verfügbar, die Zeitsteuerung prüfen
    if (isAvailable) {
      const products = await me._productService.GetProductsByFilter(me.locationID, me.sortiment, product => product.product_id == product_id);
      if (products.length == 1) {
        const product = products[0];
        const webshopSettings = await me.getWebshopSettingsDataModel();
        const schedule_req = new ScheduledForRequest(me.getScheduledForReferenceTime(), me.locationID, webshopSettings, me._coreLanguageService);
        const scheduleView = product.isScheduledFor(schedule_req);
        isAvailable = scheduleView.active;
      } else {
        isAvailable = false;
      }
    }
    return isAvailable;
  }

  public setDiscounts(discounts: { webvoucherDiscount?: number, userDiscount?: number }) {
    const me = this;
    const prevDiscount = me.discountPercent;
    if (discounts.webvoucherDiscount != null) {
      me._webvoucherDiscountPercent = discounts.webvoucherDiscount;
    }
    if (discounts.userDiscount != null) {
      me._userDiscountPercent = discounts.userDiscount;
    }
    if (prevDiscount !== me.discountPercent) {
      this.recalcDiscountPricesInBasket(me.discountPercent);
    }
  }

  /**
   * Retrieves the phone number for a specific location
   * @param locationID Optional location ID. If not provided, uses the current service location
   * @returns Promise<string> The phone number of the location or empty string if location not found
   */
  public async getLocationPhoneNumber(locationID?: number) {
    const me = this;
    const locID = locationID !== undefined ? locationID : me.locationID;
    if (locID != null) {
      const location = await me._locationObsServ.GetObject(locID);
      return location.phone_no;
    } else {
      return "";
    }
  }

  public isTippingEnabled(): boolean {
    return this.ordertype.request_tip && this.ordertype.can_request_tip;
  }

  public useBasketComment(): boolean {
    // Externer Warenkorb hat aktives Kommentarfeld. Im Moment nutzt nur der Kunde 25230 den externen Warenkorb.
    if (this.serviceMode === WebShopMode.Webvoucher && !this.allowBasketModification) {
      return true;
    }
    else {
      if (this.ordertype) {
        return this.ordertype.UseBasketComment;
      }
      else {
        this._coreLogService.error("WebshopService.useBasketComment", "ordertype not set");
        return true;
      }
    }
  }

  public useMandatoryAddressVerification(): boolean {
    const me = this;
    if (me.ordertype) {
      return me.ordertype.UseMandatoryAddressVerification;
    } else {
      me._coreLogService.error("WebshopService.useMandatoryAddressVerification", "ordertype not set");
      return false;
    }
  }

  /**
   * Retrieves the street address for a specific location
   * @param locationID Optional location ID. If not provided, uses the current service location
   * @returns Promise<string> The street address of the location or empty string if location not found
   */
  public async getLocationStreet(locationID?: number) {
    const me = this;
    const locID = locationID !== undefined ? locationID : me.locationID;
    if (locID != null) {
      const location = await me._locationObsServ.GetObject(locID);
      return location.street;
    } else {
      return "";
    }
  }

  public async hasExternalLink(locationID: number) {
    const me = this;
    const location = await me._locationObsServ.GetObject(locationID);
    return !Utils.IsNullOrEmpty(location.delivery_external_link);
  }
  // #endregion

  //#region InHouse

  public async submitTableCodeData(tablecode: string, nickname: string, checkOpenTime: boolean = true): Promise<void> {
    const me = this;
    try {
      const webshopSettingsDataModel = await me.getWebshopSettingsDataModel();
      const servicelocation = webshopSettingsDataModel.customer_location_qrCode.find(c => c.tableQRCode.some(q => q.qrCode.toLowerCase() === tablecode.toLowerCase()));
      if (servicelocation) {
        const targetLocationViewModel = await me._locationService.GetWebshopLocationInfoViewModel(WebShopMode.OrderToTable, servicelocation.locationId);
        if (targetLocationViewModel) {
          if (!checkOpenTime || targetLocationViewModel.checkOpenTime()) {
            await me.initialInhausOrdering(tablecode, nickname, targetLocationViewModel);
          } else {
            me.openIHAvaliableServiceTime(targetLocationViewModel);
          }
        } else {
          me.openInhauseLocationWarningDialog("phInHouse_NoLocation_Warning_Title", "phInHouse_NoLocation_Warning_Description", "phInHouse_NoLocation_Warning_Button_Text");
        }
      } else {
        me.openInhauseLocationWarningDialog("phInHouse_NoQRCode_Warning_Title", "phInHouse_NoQRCode_Warning_Description", "phInHouse_NoQRCode_Warning_Button_Text");
      }
    } catch (error) {
      me._coreLogService.error("WebshopService.submitQRCodeData", "try catch", error);
      me._snackBarService.ShowErrorMessageFailed(121);
    }
  }

  /**
   * initialize webshop for InHouse ordering
   * @param qrCode defines location and table number
   * @param nickname gewünschter Nickname
   * @param locationWebshopViewModel location
   */
  private async initialInhausOrdering(qrCode: string, nickname: string, locationWebshopViewModel: LocationWebshopViewModel): Promise<void> {
    const me = this;
    let check_gps = false;
    const webshoSettings = await me.getWebshopSettingsDataModel();
    if (webshoSettings && webshoSettings.in_house_order) {
      check_gps = webshoSettings.in_house_order.check_gps;
    } else {
      me._coreLogService.error("WebshopService.initialInhausOrdering", "no in_house_order in webshoSettings");
    }
    if (check_gps && !(await me.ChecklocationDistance(locationWebshopViewModel)))
      return; // break - ChecklocationDistance löst message aus

    try {
      let userNickname = nickname;
      if (Utils.IsNullOrWhiteSpace(nickname)) {
        try {
          const userInfo = await me._userHelperService.GetUserData(false);
          if (userInfo)
            userNickname = userInfo.fname;
        } catch (error) {
          me._coreLogService.error("WebshopService.initialInhausOrdering", "GetUserData.catch", error);
        }
      }

      // versuche eine verbindung herzustellen zum YourApp Stantort Server
      if (me._objObsInjectHelper.inHouseOrderService.Status !== ConnectionState.Connected) {
        await me._objObsInjectHelper.inHouseOrderService.Connect(locationWebshopViewModel.hyp_cus_nr);
      }

      // prüfe den status vom Server
      const status = await me._objObsInjectHelper.inHouseOrderService.GetStatus();
      if (!status.has_pos_connection) {
        me._objObsInjectHelper.inHouseOrderService.Disconnect();
        me.OpenWarningNoConnectionDialog();
        return; // break here
      }

      //! todo dies ist eine einzel bestellung muss noch um gruppen bestellung erweitert werden
      const response = await me._objObsInjectHelper.inHouseOrderService.SetTableCode(qrCode, userNickname);
      if (response.success) {
        me._objObsInjectHelper.inHouseOrderService.openInHauseLandingPage();
        return; // done here
      } else {
        me._coreLogService.error("WebshopService.initialInhausOrdering", "SetTableCode not success", qrCode);
        me._snackBarService.ShowErrorMessageFailed(122);
      }
    } catch (error) {
      me._coreLogService.error("WebshopService.initialInhausOrdering", "SetTableCode.catch", error);
      me._snackBarService.ShowErrorMessageFailed(123);
    }
  }

  /** Warning dialog: No connection to the restaurant */
  private OpenWarningNoConnectionDialog() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phInHouse_NoConnection_Title"
        , content: "phInHouse_NoConnection_Description"
        , btnLabel: "phInHouse_Cancel_Btn"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningButtomSheet.afterDismissed().subscribe(() => {
      me._router.navigate["/"]; // back to home
    });
  }

  /** prüft ob das Device sich in Reichweite vom Standort befinden */
  private async ChecklocationDistance(location: LocationWebshopViewModel): Promise<boolean> {
    const me = this;
    let inDistance = false;
    try {
      let maxDistance = 0;
      const webshoSettings = await me.getWebshopSettingsDataModel();
      if (webshoSettings && webshoSettings.in_house_order) {
        maxDistance = webshoSettings.in_house_order.gps_radius / 1000; // (/1000) > meter in kilometer
      } else {
        me._coreLogService.error("WebshopService.ChecklocationDistance", "no in_house_order in webshoSettings");
      }
      const coordinates = await me._deviceLocationService.getCurrentPosition();
      if (coordinates) {
        if (location.latitude > 0 && location.longitude > 0) {
          const distance = Utils.getDistanceBetweenPoints(coordinates.latitude, coordinates.longitude, location.latitude, location.longitude);
          // die halbe genauigkeit wird der maximalen entfernung für den vergleich gutgeschrieben
          maxDistance += ((coordinates.accuracy / 2) / 1000); // (/1000) > meter in kilometer
          if (distance <= maxDistance) {
            location.distance = +(distance.toFixed(1));
            inDistance = true;
          } else {
            location.distance = -1;
            me.openDistanceWarningDialog();
          }
        } else {
          me._coreLogService.error("WebshopService.ChecklocationDistance", "location has no gps", location);
          inDistance = true; // wegen der UX wird es dem Gast erlaubt, weil der Kunde die Stammdaten nicht gepflegt hat
        }
      } else {
        me.OpenLocationWarningDialog();
      }
    } catch (error) {
      me._coreLogService.error("WebshopService.ChecklocationDistance", "catch", error);
      me._snackBarService.ShowErrorMessageFailed(124);
    }
    return inDistance;
  }

  public openAvailableServiceTime(data: IAvailableTimesConfig) {
    const me = this;
    // Determine whether to show only today or all days
    const isLocationOpen = data.showOnlyToday !== null ? data.showOnlyToday : data.location.open;

    const availableButtomSheet = me._bottomSheetHelperService.open(AvailableServiceTimeComponent, {
      data: {
        isLocationOpen: isLocationOpen,
        locationOpenDays: data.location.openDays,
        serviceMode: data.serviceMode,
        hasValidOrderTimes: data.hasValidOrderTimes
      },
      panelClass: "mat-bottom-sheet-container--full-height"
    });

    availableButtomSheet.afterDismissed().subscribe(async (result: boolean) => {
      if (result) {
        const route = data.navigationRoute ? data.navigationRoute : NavigationRoute.Home;
        me._router.navigate([route]);
      }
    });
  }

  /** Avaliable service time dialog */
  private openIHAvaliableServiceTime(location: LocationWebshopViewModel) {
    const me = this;
    const availableButtomSheet = me._bottomSheetHelperService.open(AvailableServiceTimeComponent, {
      data: { isLocationOpen: location.open, locationOpenDays: location.openDays, serviceMode: me.serviceMode },
      panelClass: "mat-bottom-sheet-container--full-height"
    });
    availableButtomSheet.afterDismissed().subscribe((result: boolean) => {
      if (result) {
        me._router.navigate(["menuservice"]);
      }
    });
  }

  // TODO es ist kein inHouse oder location dialog da es alle parameter entgegen nimmt, also entweder global schalten oder spezialisieren
  private openInhauseLocationWarningDialog(title: string, content: string, buttonLabel: string) {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: title
        , content: content
        , btnLabel: buttonLabel
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningButtomSheet.afterDismissed().subscribe((result) => {
      me._router.navigate(["menuservice"]);
    });
  }

  /** Dialog: Location tracking permission */
  public OpenLocationWarningDialog() {
    const me = this;
    const locButtomSheet = me._bottomSheetHelperService.open(LocationDialogComponent, {
      data: {
        title: "phLocation_Required_Dialog_Title",
        description: "phLocation_Required_Dialog_Sub_Text",
        buttonText: "phLocation_Required_Dialog_Button",
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    locButtomSheet.afterDismissed().subscribe((result) => {
      me._router.navigate(["menuservice"]);
    });
  }

  /** Dialog: The distance is greater than required */
  public openDistanceWarningDialog() {
    const me = this;
    const locButtomSheet = me._bottomSheetHelperService.open(LocationDialogComponent, {
      data: {
        title: "phLocation_Dialog_Distance_Title",
        description: "phLocation_Dialog_Distance_Sub_Text",
        buttonText: "phLocation_Required_Dialog_Button",
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    locButtomSheet.afterDismissed().subscribe((result) => {
      me._router.navigate(["menuservice"]);
    });
  }

  private openDiscountCannotBeUsed() {
    const me = this;
    me._bottomSheetHelperService.open(SecureCheckDialogComponent, {
      data: {
        title: "phInHouse_Discount_Title",
        description: "phInHouse_Discount_Info",
        buttonTextAccept: "phGlobal_Continue",
        icon: "shop-icons.svg#ya-hypersoft-coupon",
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
  }

  private openWebVoucherWarningDialog() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phVoucherCredit_Warning_Title"
        , content: "phVoucherCredit_Warning_Description"
        , btnLabel: "phGlobal_Return"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningButtomSheet.afterDismissed().subscribe(() => {
      me._router.navigate(["menuservice"]);
    });
  }

  //#endregion

  /**
   * Age Confirmation dialog
   * Result and required age will be saved as Local value
   * @param requiredAge needed age
   * @param callback answer from user
   */
  public OpenAgeConfirmDialog(requiredAge: number, callback: (confirmed: boolean) => void) {
    const me = this;
    const bottomSheetRef = me._bottomSheetHelperService.open(AgeConfirmDialogComponent, {
      data: {
        title: me._coreLanguageService.value("phAgeDialog_Title").replace("{age}", requiredAge.toString()),
        description: "phAgeDialog_Note",
        buttonTextAccept: "phAgeDialog_Confirm_Btn",
        buttonTextDeny: "phAgeDialog_Deny_Btn",
        icon: "shop-icons.svg#ya-hypersoft-user-single",
        notice: "phAgeDialog_Notice"
      },
      panelClass: "mat-bottom-sheet-container--full-height"
    });
    bottomSheetRef.afterDismissed().subscribe(callback);
  }

  /**
   * Get local value of confirm and required age.
   * Compare the confirmed age with the required age
   */
  private async HasAgeConfirm(requiredAge: number): Promise<boolean> {
    const me = this;
    if (me._confirmedAge == -1) {
      const confirmedAge = await me._coreComService.environment.valueStorage.get(StorageHive.Local, LocalKeys.maxConfirmedAge);
      if (confirmedAge)
        me._confirmedAge = confirmedAge;
      else
        me._confirmedAge = 0;
    }
    return me._confirmedAge >= requiredAge;
  }

  /** speichert das bestätigte alter für spätere prüfungen über HasAgeConfirm */
  private SaveAgeConfirm(age: number): Promise<void> {
    const me = this;
    me._confirmedAge = age
    return me._coreComService.environment.valueStorage.set(StorageHive.Local, LocalKeys.maxConfirmedAge, age);
  }

  /**
 * Checks if age verification is required for a product and performs it if necessary
 * @param locationId - Location ID
 * @param productId - Product ID
 * @returns Promise<{canAdd: boolean, productRequiredAge: number}>
 */
  private async checkProductAgeAndConfirmRequirement(locationId: number, productId: number): Promise<{ canAdd: boolean, productRequiredAge: number }> {
    const me = this;
    let ask_age = false;
    const webshopSettings = await me.getWebshopSettingsDataModel();
    if (webshopSettings) {
      ask_age = webshopSettings.use_ask_age;
    } else {
      me._coreLogService.error("WebshopService.checkProductAge", "no webshopSettings");
    }
    let productRequiredAge = 0;
    let canAddItem = true;
    if (ask_age) {
      const productModel = await me._productService.GetProduct(locationId, me.sortiment, productId);
      if (productModel && productModel.ask_age) {
        productRequiredAge = productModel.ask_age;
      }
      canAddItem = await me.HasAgeConfirm(productRequiredAge);
    }
    return { canAdd: canAddItem, productRequiredAge };
  }

  /**
   * Performs an age check and returns whether the item may be added.
   * @param locationId - Location ID
   * @param productId - Product ID
   * @returns Promise<boolean> - true if age is verified (or not required)
   */
  private async executeWithAgeCheck(locationId: number, productId: number): Promise<boolean> {
    const me = this;
    return new Promise<boolean>(async (resolve, reject) => {
      try {
        const { canAdd, productRequiredAge } = await me.checkProductAgeAndConfirmRequirement(locationId, productId);
        if (canAdd) {
          resolve(true);
        } else {
          me.OpenAgeConfirmDialog(productRequiredAge, async (confirmed) => {
            if (confirmed) {
              try {
                await me.SaveAgeConfirm(productRequiredAge);
                resolve(true);
              } catch (error) {
                me._coreLogService.error("WebshopService.executeWithAgeCheck", "SaveAgeConfirm", error);
                resolve(false);
              }
            } else {
              resolve(false);
            }
          });
        }
      } catch (error) {
        me._coreLogService.error("WebshopService.executeWithAgeCheck", "catch", error);
        reject(error);
      }
    });
  }

  /**
   *
   * @param service WebShopMode
   * @param locationID
   * Direct webshop access is available for the following order types :
   * Viewing, TakeAway, Delivery, Retail, Ticket, Webvoucher
   */
  public navigateToWebshop(service: WebShopMode = null, locationID: number = null) {
    const me = this;
    // Make sure WebshopSettings are loaded and Old State restored before navigating
    me.getFullyLoadedObservable.toPromise().then(() => {
      if (service === null) {
        me._router.navigate(["menuservice"]);
      } else {
        me.setServiceMode(service).then(() => {
          if (locationID === null) {
            if (service === WebShopMode.Delivery) {
              me._router.navigate(["/orderAddressQuery"]);
            } else {
              me._router.navigate(["/menulocation"]);
            }
          } else {
            me.setServiceLocationByID(locationID).then(() => {
              if (service === WebShopMode.Delivery) {
                me._router.navigate(["/orderAddressQuery"]);
              } else if (service === WebShopMode.TakeAway) {
                me._router.navigate(["/orderTimeSelector"]);
              } else {
                me._router.navigate(["/menugroup"]);
              }
            });
          }
        });
      }
    });
  }

  /** ServiceMode must be set first, like setServiceMode */
  public setServiceLocationByID(locationID: number): Promise<void> {
    const me = this;
    return new Promise<void>((resolve, reject) => {
      me._locationService.GetWebshopLocationInfoViewModel(me.serviceMode, locationID).then(locationviewmodel => {
        me.setServiceLocationInfo(locationviewmodel, "").then(resolve).catch(reject);
      }).catch(error => {
        me._coreLogService.error("WebshopService.setServiceLocationByID", "_locationService.GetWebshopLocationViewModelByID", error);
        reject(error)
      });
    });
  }

  public openVacationWarningDialog() {
    const me = this;
    const message = me._webshopSettingsDataModel.vacation_notification_text || ""; // ! TODO muss asynchrone werden da die webshopsettings es sind
    me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: message,
        content: "",
        btnLabel: "phWebshopVacationWarning_Button",
      },
      panelClass: "mat-bottom-sheet-container--full-height"
    });
  }

  public formatCurrency(price: number, hasSymbol: boolean = true, useGrouping: boolean = true) {
    return Utils.currencyFormatter(price, this.currencySymbol, hasSymbol, useGrouping);
  }

  public singleLocationHasPickupGroup: boolean = false;
  private _singleLocationHasPickupGroup(hasPickupGroup: boolean) {
    const me = this;
    return me.singleLocationHasPickupGroup = hasPickupGroup;
  }

  public HasSingleLocation(serviceMode: WebShopMode): Promise<boolean> {
    const me = this;
    return new Promise<boolean>(async (resolve, reject) => {
      const menuSettings = await me.getMenuSettings();
      me._locationService.GetWebshopGuardSingleLocationData(serviceMode, menuSettings.locations)
        .then((webShopLocations) => {
          if (webShopLocations && webShopLocations.length === 1) {
            me._singleLocationHasPickupGroup(webShopLocations[0].service_pickup_group);
            me.setServiceLocationByID(webShopLocations[0].hyp_cus_nr)
              .then(() => {
                resolve(true);
              })
              .catch(e => {
                me._coreLogService.error("MenuServiceSelectorComponent.checkSingleLocation", "_webshopService.setServiceLocationByID", e);
                reject();
              });
          } else {
            resolve(false);
          }
        })
        .catch(e => {
          me._coreLogService.error("MenuServiceSelectorComponent.checkSingleLocation", "_locationService.GetWebshopGuardSingleLocationData", e);
          reject();
        });
    });
  }

  public toggleFixedMode(enable: boolean) {
    const me = this;
    me._mainNavService.navigationEnabled = !enable;
    me.allowBasketModification = !enable;
  }

  public UseFixedBasket(token: string, hash: string) {
    const me = this;
    me.resetWebshopService();
    me._router.navigateByUrl("/load");
    me.GetBasketFromServer(token, hash).then((response) => {
      const basket = response.basket[0];
      if (basket) {
        // Use WebvoucherMode as Fixed Basket
        me._fullyLoadedAsyncSubject.subscribe(async () => {
          await me.setServiceMode(WebShopMode.Webvoucher);
          me._productService.RefreshLocationProductData(basket.location, me.sortiment).then(() => {
            me._voucherServiceType = VoucherServiceType.Order;
            me.setServiceLocationByID(basket.location).then(async () => {
              me.toggleFixedMode(true);
              me.addPurchaseOrderToken = basket.token;
              me.returnURLSuccess = basket.urlTrue;
              me.returnURLFail = basket.urlFalse;
              me.returnURLBasket = basket.urlBasket;
              me.orderComment = basket.comment;
              try {
                for (const item of basket.items) {
                  const config: ProductConfiguration = {
                    count: item.count,
                    valid_date: item.valid_date_ymd,
                    variable_price: item.variable_price,
                    comment: item.comment,
                  };
                  try {
                    await me.addItemToShippingCart(basket.location, item.id, config);
                  } catch (error) {
                    me._router.navigateByUrl("/fixedBasketError");
                    me._coreLogService.error("WebshopService.UseFixedBasket", "addItemToShippingCart", error);
                  }
                }
              } catch (e) {
                me._router.navigate(["/fixedBasketError", FixedBasketErrorCodes.ProductsNotUptodate]);
                me._coreLogService.error("WebshopService.UseFixedBasket", "addItemToShippingCart", e);
              }
              me._router.navigateByUrl("/webshop");
            }).catch(e => {
              me._router.navigate(["/fixedBasketError", FixedBasketErrorCodes.ProductsNotUptodate]);
              me._coreLogService.error("WebshopService.UseFixedBasket", "setServiceLocationByID", e);
            });
          }).catch(e => {
            me._router.navigate(["/fixedBasketError", FixedBasketErrorCodes.NoBasket]);
            me._coreLogService.error("WebshopService.UseFixedBasket", "_productService.RefreshLocationProductData", e);
          });
        });
      }
    }).catch(e => {
      me._router.navigate(["/fixedBasketError", FixedBasketErrorCodes.NoBasket]);
      me._coreLogService.error("WebshopService.UseFixedBasket", "GetBasketFromServer Could not retrieve Basket", e);
    });
  }

  /* YourAPPServerCalls*/

  /**
   * Gets a Basket from the YourAPPServer
   * @param token identifier for the Basket
   * @param hash for verification of Basket contents
   */
  public GetBasketFromServer(token: string, hash: string): Promise<ReservationBasketSyncDataModel> {
    const me = this;
    return new Promise<ReservationBasketSyncDataModel>((resolve, reject) => {
      // FAKE for hypcus 34007
      // const response = new ReservationBasketSyncDataModel();
      // const basket = new ReservationBasketDataModel();
      // const article: ReservationBasketArticleDataModel = {
      //   comment: "Kommentar",
      //   count: 2,
      //   productId: 3059, // P
      //   id: 6767,
      //   valid_date_ymd: 20210520,
      //   valid_time_hms: 83030,
      //   variable_price: 20, // Not Implemented
      //       }
      // basket.comment = "FULL COMMENT",
      // basket.items = [article];
      // basket.location = 29479;
      // basket.token = "myFAKEtoken";
      // response.basket = [basket];
      // resolve(response);

      try {
        const RequestData = new ReservationBasketSyncModel();
        const now = moment();
        RequestData.changes_since_ymd = Utils.GetYMDFromMoment(now); // Used as Request Time on YourAPPServer
        RequestData.changes_since_hms = Utils.GetHMSFromMoment(now); // Used as Request Time on YourAPPServer
        RequestData.token = token;
        RequestData.hash = hash;
        const FunctionName = "reservation/GetBasket";
        const SyncDataModelConstructor = ReservationBasketSyncDataModel;
        me._objObsInjectHelper.yourAppServer.Api.RequestService(SyncDataModelConstructor, FunctionName, RequestData)
          .then((response) => {
            if (response.OK) {
              me._coreLogService.debug("WebshopService.GetBasketFromServer", "RequestService (response OK)", response);
              resolve(response.Data);
            } else {
              me._coreLogService.error("WebshopService.GetBasketFromServer", "RequestService (response not OK)", response);
              reject(response.HttpResponse.codeText);
            }
          })
          .catch((error) => { me._coreLogService.error("WebshopService.GetBasketFromServer", "RequestService", error); reject(); });
      } catch (error) {
        me._coreLogService.error("WebshopService.GetBasketFromServer", "try catch", error);
        reject();
      }
    });
  }
  private trackAddToCart(basketItem: BasketItemViewModel): void {
    this._trackingManager.trackAddToCart(
      basketItem.product_id,
      basketItem.label,
      1,
      basketItem.price,
      this.currencySymbol,
      this.getBasketSumTotal(),
      this.getShoppingCartItemsIDs()
    );
  }

  private mergeIdenticalProducts(existingProduct: BasketItemViewModel, newProduct: BasketItemViewModel): BasketItemViewModel {
    const merged = Utils.GetCopy(existingProduct);
    merged.count += newProduct.count;
    if (newProduct.comment && newProduct.comment.trim() !== "") {
      merged.comment = newProduct.comment;
    }

    return merged;
  }

  //#region PreOrder
  private async _fetchPreOrderSelectionSettings() {
    const api = this._objObsInjectHelper.yourAppServer.Api;
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      "YA-Version": appConfig.version,
    };

    if (api.YourAppServer.Auth.IsActive) {
      headers["Authorization"] = "Bearer " + api.YourAppServer.Auth.BearerToken;
    }
    const endpoint = "PreOrder/RemoteOrderModeSelectorData"
    const url = api.YourAppServer.BaseURI + api.MainPath + endpoint

    const response = await fetch(url, {
      headers: headers,
    })

    return await response.json();
  }

  private _preOrderSelectionSettings
  public async getPreOrderSelectionSettings() {
    if (!this._preOrderSelectionSettings) {
      this._preOrderSelectionSettings = await this._fetchPreOrderSelectionSettings();
    }
    return this._preOrderSelectionSettings;
  }
  //#endregion PreOrder


  private getShoppingCartItemsIDs(): number[] {
    return this.getShippingCartItems().map(item => item.product_id);
  }
  /**
   * Ermittelt vom Server den OrderidentificationToken
   */
  private GetOrderIndentification(): Promise<OrderIdentification> {
    const me = this;
    return new Promise<OrderIdentification>((resolve, reject) => {
      try {
        const FunctionName = "webshop/GetOrderIdentification";
        const SyncDataModelConstructor = OrderIdentification;
        me._objObsInjectHelper.yourAppServer.Api.RequestService(SyncDataModelConstructor, FunctionName)
          .then((response) => {
            if (response.OK) {
              me._coreLogService.debug("checkoutService.GetOrderIdentification", "RequestService (response OK)", response);
              resolve(response.Data);
            } else {
              me._coreLogService.error("checkoutService.GetOrderIdentification", "RequestService (response not OK)", response);
              reject(response.HttpResponse.codeText);
            }
          })
          .catch((error) => { me._coreLogService.error("checkoutService.GetOrderIdentification", "RequestService", error); reject(); });
      } catch (error) {
        me._coreLogService.error("checkoutService.GetOrderIdentification", "try catch", error);
        reject();
      }
    });
  }
  public applyAccessibilitySettings(): void {
    this._accessibilityWebShopService.applyAccessibilitySettings();
  }

  //#region Newsletter
  public _hasAcceptedNewsletter: boolean = false;
  public get hasAcceptedNewsletter(): boolean {
    return this._hasAcceptedNewsletter;
  }
  public set hasAcceptedNewsletter(accepted: boolean) {
    const me = this;
    me._hasAcceptedNewsletter = accepted;
    me._coreComService.environment.valueStorage.set(StorageHive.Local, LocalKeys.newsletter_accepted, this._hasAcceptedNewsletter).then();
  }

  /**
   * Checks if newsletter checkbox should be displayed
   * @param isRegistered Whether user is registered
   * @returns Promise<boolean> true if checkbox should be shown
   */
  public checkCanDisplayNewsletter(isRegistered: boolean): Promise<boolean> {
    const me = this;

    if (!isRegistered) {
      return Promise.resolve(false);
    }
    return me._userHelperService.GetUserData(false)
      .then(userInfo => {
        if (userInfo && userInfo.AllowMailNewsletter) {
          me.hasAcceptedNewsletter = true; // Cache
          return false; // Don't show checkbox
        }
        return true; // Show checkbox
      })
      .catch(err => {
        me._coreLogService.error('WebShopService', 'checkCanDisplayNewsletter', err);
        return false;
      });
  }

  /**
   * Loads and sanitizes the newsletter text from settings or resolver data.
   * @param settingsViewModel Optional settings (for direct access in Registration)
   * @returns SafeHtml | null
   */

  public SetNewsletter(hasAcceptedNewsletter: boolean): Promise<boolean> {
    const me = this;
    return me._objObsInjectHelper.yourAppServer.Auth.ChangeAllowMailNewsletter(hasAcceptedNewsletter)
      .then((success) => {
        if (success) {
          me.hasAcceptedNewsletter = hasAcceptedNewsletter;
        }
        return success;
      })
      .catch((err) => {
        me._coreLogService.error("webShop.SetNewsletter", "Failed to set newsletter opt-in", err);
        return false;
      });
  }

  public resetNewsletterConfirm(): void {
    const me = this;
    me._hasAcceptedNewsletter = false;
    me._coreComService.environment.valueStorage.remove(StorageHive.Local, LocalKeys.newsletter_accepted).then();
  }

  //#endregion Newsletter
}
